var Zn = (t, e, r) => {
  if (!e.has(t))
    throw TypeError("Cannot " + r);
};
var b = (t, e, r) => (Zn(t, e, "read from private field"), r ? r.call(t) : e.get(t)), L = (t, e, r) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, r);
}, I = (t, e, r, n) => (Zn(t, e, "write to private field"), n ? n.call(t, r) : e.set(t, r), r);
var gn = (t, e, r, n) => ({
  set _(s) {
    I(t, e, s, r);
  },
  get _() {
    return b(t, e, n);
  }
}), G = (t, e, r) => (Zn(t, e, "access private method"), r);
import * as Se from "react";
import Ae, { createContext as Ga, useContext as Ql, useState as te, useRef as Le, useEffect as We, useCallback as Yl, Children as Xl, memo as Gl } from "react";
import { Checkbox as Jl, ActionMenu as Zl, LanguageCodeEnum as ps, CloseIcon as Ri, Modal as kn, PrimaryButton as an, SecondaryButton as Ja, FieldErrorAndDescription as En, ActionMenuItem as In, InfoIcon as ec, BinIcon as tc, PenIcon as rc, DonwloadIcon as nc, FormInputSearch as sc, FormSelectMultiple as _i, Loader as ic, toast as Me, CloseCircleIcon as Pi, SmallPenIcon as ac, UploadIcon as oc, CheckBoxSwitcher as lc, useWindowSize as cc, FormInput as uc, ModalSizeEnum as hc } from "@systemeio/ui";
import { getTFuncWithNamespace as dc, getUseLocoTranslation as fc, setupBasicInterceptor as pc, getUseBaseFetch as mc, httpBaseClient as gc, RequestMethodsEnum as tr, BadRequest as yc } from "@systemeio/util";
import { flushSync as bc } from "react-dom";
var ms = { exports: {} }, Rr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ti;
function vc() {
  if (Ti)
    return Rr;
  Ti = 1;
  var t = Ae, e = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, s = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(o, l, c) {
    var u, d = {}, h = null, m = null;
    c !== void 0 && (h = "" + c), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (m = l.ref);
    for (u in l)
      n.call(l, u) && !i.hasOwnProperty(u) && (d[u] = l[u]);
    if (o && o.defaultProps)
      for (u in l = o.defaultProps, l)
        d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: e, type: o, key: h, ref: m, props: d, _owner: s.current };
  }
  return Rr.Fragment = r, Rr.jsx = a, Rr.jsxs = a, Rr;
}
var _r = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ni;
function wc() {
  return Ni || (Ni = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Ae, e = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), o = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), f = Symbol.iterator, y = "@@iterator";
    function p(g) {
      if (g === null || typeof g != "object")
        return null;
      var T = f && g[f] || g[y];
      return typeof T == "function" ? T : null;
    }
    var S = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function x(g) {
      {
        for (var T = arguments.length, F = new Array(T > 1 ? T - 1 : 0), B = 1; B < T; B++)
          F[B - 1] = arguments[B];
        C("error", g, F);
      }
    }
    function C(g, T, F) {
      {
        var B = S.ReactDebugCurrentFrame, se = B.getStackAddendum();
        se !== "" && (T += "%s", F = F.concat([se]));
        var ae = F.map(function(ee) {
          return String(ee);
        });
        ae.unshift("Warning: " + T), Function.prototype.apply.call(console[g], console, ae);
      }
    }
    var P = !1, j = !1, w = !1, _ = !1, O = !1, R;
    R = Symbol.for("react.module.reference");
    function N(g) {
      return !!(typeof g == "string" || typeof g == "function" || g === n || g === i || O || g === s || g === c || g === u || _ || g === m || P || j || w || typeof g == "object" && g !== null && (g.$$typeof === h || g.$$typeof === d || g.$$typeof === a || g.$$typeof === o || g.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      g.$$typeof === R || g.getModuleId !== void 0));
    }
    function k(g, T, F) {
      var B = g.displayName;
      if (B)
        return B;
      var se = T.displayName || T.name || "";
      return se !== "" ? F + "(" + se + ")" : F;
    }
    function D(g) {
      return g.displayName || "Context";
    }
    function z(g) {
      if (g == null)
        return null;
      if (typeof g.tag == "number" && x("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof g == "function")
        return g.displayName || g.name || null;
      if (typeof g == "string")
        return g;
      switch (g) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case s:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case o:
            var T = g;
            return D(T) + ".Consumer";
          case a:
            var F = g;
            return D(F._context) + ".Provider";
          case l:
            return k(g, g.render, "ForwardRef");
          case d:
            var B = g.displayName || null;
            return B !== null ? B : z(g.type) || "Memo";
          case h: {
            var se = g, ae = se._payload, ee = se._init;
            try {
              return z(ee(ae));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, M = 0, re, ce, $, K, ne, W, A;
    function Q() {
    }
    Q.__reactDisabledLog = !0;
    function Z() {
      {
        if (M === 0) {
          re = console.log, ce = console.info, $ = console.warn, K = console.error, ne = console.group, W = console.groupCollapsed, A = console.groupEnd;
          var g = {
            configurable: !0,
            enumerable: !0,
            value: Q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: g,
            log: g,
            warn: g,
            error: g,
            group: g,
            groupCollapsed: g,
            groupEnd: g
          });
        }
        M++;
      }
    }
    function Te() {
      {
        if (M--, M === 0) {
          var g = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, g, {
              value: re
            }),
            info: U({}, g, {
              value: ce
            }),
            warn: U({}, g, {
              value: $
            }),
            error: U({}, g, {
              value: K
            }),
            group: U({}, g, {
              value: ne
            }),
            groupCollapsed: U({}, g, {
              value: W
            }),
            groupEnd: U({}, g, {
              value: A
            })
          });
        }
        M < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var nt = S.ReactCurrentDispatcher, ot;
    function Ct(g, T, F) {
      {
        if (ot === void 0)
          try {
            throw Error();
          } catch (se) {
            var B = se.stack.trim().match(/\n( *(at )?)/);
            ot = B && B[1] || "";
          }
        return `
` + ot + g;
      }
    }
    var Er = !1, Ot;
    {
      var qn = typeof WeakMap == "function" ? WeakMap : Map;
      Ot = new qn();
    }
    function Cr(g, T) {
      if (!g || Er)
        return "";
      {
        var F = Ot.get(g);
        if (F !== void 0)
          return F;
      }
      var B;
      Er = !0;
      var se = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ae;
      ae = nt.current, nt.current = null, Z();
      try {
        if (T) {
          var ee = function() {
            throw Error();
          };
          if (Object.defineProperty(ee.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ee, []);
            } catch (Ne) {
              B = Ne;
            }
            Reflect.construct(g, [], ee);
          } else {
            try {
              ee.call();
            } catch (Ne) {
              B = Ne;
            }
            g.call(ee.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ne) {
            B = Ne;
          }
          g();
        }
      } catch (Ne) {
        if (Ne && B && typeof Ne.stack == "string") {
          for (var Y = Ne.stack.split(`
`), Oe = B.stack.split(`
`), me = Y.length - 1, be = Oe.length - 1; me >= 1 && be >= 0 && Y[me] !== Oe[be]; )
            be--;
          for (; me >= 1 && be >= 0; me--, be--)
            if (Y[me] !== Oe[be]) {
              if (me !== 1 || be !== 1)
                do
                  if (me--, be--, be < 0 || Y[me] !== Oe[be]) {
                    var ze = `
` + Y[me].replace(" at new ", " at ");
                    return g.displayName && ze.includes("<anonymous>") && (ze = ze.replace("<anonymous>", g.displayName)), typeof g == "function" && Ot.set(g, ze), ze;
                  }
                while (me >= 1 && be >= 0);
              break;
            }
        }
      } finally {
        Er = !1, nt.current = ae, Te(), Error.prepareStackTrace = se;
      }
      var Qt = g ? g.displayName || g.name : "", _t = Qt ? Ct(Qt) : "";
      return typeof g == "function" && Ot.set(g, _t), _t;
    }
    function Kn(g, T, F) {
      return Cr(g, !1);
    }
    function un(g) {
      var T = g.prototype;
      return !!(T && T.isReactComponent);
    }
    function Vt(g, T, F) {
      if (g == null)
        return "";
      if (typeof g == "function")
        return Cr(g, un(g));
      if (typeof g == "string")
        return Ct(g);
      switch (g) {
        case c:
          return Ct("Suspense");
        case u:
          return Ct("SuspenseList");
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case l:
            return Kn(g.render);
          case d:
            return Vt(g.type, T, F);
          case h: {
            var B = g, se = B._payload, ae = B._init;
            try {
              return Vt(ae(se), T, F);
            } catch {
            }
          }
        }
      return "";
    }
    var lt = Object.prototype.hasOwnProperty, hn = {}, dn = S.ReactDebugCurrentFrame;
    function Rt(g) {
      if (g) {
        var T = g._owner, F = Vt(g.type, g._source, T ? T.type : null);
        dn.setExtraStackFrame(F);
      } else
        dn.setExtraStackFrame(null);
    }
    function fn(g, T, F, B, se) {
      {
        var ae = Function.call.bind(lt);
        for (var ee in g)
          if (ae(g, ee)) {
            var Y = void 0;
            try {
              if (typeof g[ee] != "function") {
                var Oe = Error((B || "React class") + ": " + F + " type `" + ee + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof g[ee] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Oe.name = "Invariant Violation", Oe;
              }
              Y = g[ee](T, ee, B, F, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (me) {
              Y = me;
            }
            Y && !(Y instanceof Error) && (Rt(se), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", B || "React class", F, ee, typeof Y), Rt(null)), Y instanceof Error && !(Y.message in hn) && (hn[Y.message] = !0, Rt(se), x("Failed %s type: %s", F, Y.message), Rt(null));
          }
      }
    }
    var de = Array.isArray;
    function Ce(g) {
      return de(g);
    }
    function st(g) {
      {
        var T = typeof Symbol == "function" && Symbol.toStringTag, F = T && g[Symbol.toStringTag] || g.constructor.name || "Object";
        return F;
      }
    }
    function qt(g) {
      try {
        return pn(g), !1;
      } catch {
        return !0;
      }
    }
    function pn(g) {
      return "" + g;
    }
    function mn(g) {
      if (qt(g))
        return x("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", st(g)), pn(g);
    }
    var Or = S.ReactCurrentOwner, Nl = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, yi, bi, Qn;
    Qn = {};
    function jl(g) {
      if (lt.call(g, "ref")) {
        var T = Object.getOwnPropertyDescriptor(g, "ref").get;
        if (T && T.isReactWarning)
          return !1;
      }
      return g.ref !== void 0;
    }
    function Dl(g) {
      if (lt.call(g, "key")) {
        var T = Object.getOwnPropertyDescriptor(g, "key").get;
        if (T && T.isReactWarning)
          return !1;
      }
      return g.key !== void 0;
    }
    function Fl(g, T) {
      if (typeof g.ref == "string" && Or.current && T && Or.current.stateNode !== T) {
        var F = z(Or.current.type);
        Qn[F] || (x('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', z(Or.current.type), g.ref), Qn[F] = !0);
      }
    }
    function Al(g, T) {
      {
        var F = function() {
          yi || (yi = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", T));
        };
        F.isReactWarning = !0, Object.defineProperty(g, "key", {
          get: F,
          configurable: !0
        });
      }
    }
    function kl(g, T) {
      {
        var F = function() {
          bi || (bi = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", T));
        };
        F.isReactWarning = !0, Object.defineProperty(g, "ref", {
          get: F,
          configurable: !0
        });
      }
    }
    var Il = function(g, T, F, B, se, ae, ee) {
      var Y = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: g,
        key: T,
        ref: F,
        props: ee,
        // Record the component responsible for creating this element.
        _owner: ae
      };
      return Y._store = {}, Object.defineProperty(Y._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Y, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: B
      }), Object.defineProperty(Y, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: se
      }), Object.freeze && (Object.freeze(Y.props), Object.freeze(Y)), Y;
    };
    function Ml(g, T, F, B, se) {
      {
        var ae, ee = {}, Y = null, Oe = null;
        F !== void 0 && (mn(F), Y = "" + F), Dl(T) && (mn(T.key), Y = "" + T.key), jl(T) && (Oe = T.ref, Fl(T, se));
        for (ae in T)
          lt.call(T, ae) && !Nl.hasOwnProperty(ae) && (ee[ae] = T[ae]);
        if (g && g.defaultProps) {
          var me = g.defaultProps;
          for (ae in me)
            ee[ae] === void 0 && (ee[ae] = me[ae]);
        }
        if (Y || Oe) {
          var be = typeof g == "function" ? g.displayName || g.name || "Unknown" : g;
          Y && Al(ee, be), Oe && kl(ee, be);
        }
        return Il(g, Y, Oe, se, B, Or.current, ee);
      }
    }
    var Yn = S.ReactCurrentOwner, vi = S.ReactDebugCurrentFrame;
    function Kt(g) {
      if (g) {
        var T = g._owner, F = Vt(g.type, g._source, T ? T.type : null);
        vi.setExtraStackFrame(F);
      } else
        vi.setExtraStackFrame(null);
    }
    var Xn;
    Xn = !1;
    function Gn(g) {
      return typeof g == "object" && g !== null && g.$$typeof === e;
    }
    function wi() {
      {
        if (Yn.current) {
          var g = z(Yn.current.type);
          if (g)
            return `

Check the render method of \`` + g + "`.";
        }
        return "";
      }
    }
    function Ll(g) {
      return "";
    }
    var xi = {};
    function Ul(g) {
      {
        var T = wi();
        if (!T) {
          var F = typeof g == "string" ? g : g.displayName || g.name;
          F && (T = `

Check the top-level render call using <` + F + ">.");
        }
        return T;
      }
    }
    function Si(g, T) {
      {
        if (!g._store || g._store.validated || g.key != null)
          return;
        g._store.validated = !0;
        var F = Ul(T);
        if (xi[F])
          return;
        xi[F] = !0;
        var B = "";
        g && g._owner && g._owner !== Yn.current && (B = " It was passed a child from " + z(g._owner.type) + "."), Kt(g), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', F, B), Kt(null);
      }
    }
    function Ei(g, T) {
      {
        if (typeof g != "object")
          return;
        if (Ce(g))
          for (var F = 0; F < g.length; F++) {
            var B = g[F];
            Gn(B) && Si(B, T);
          }
        else if (Gn(g))
          g._store && (g._store.validated = !0);
        else if (g) {
          var se = p(g);
          if (typeof se == "function" && se !== g.entries)
            for (var ae = se.call(g), ee; !(ee = ae.next()).done; )
              Gn(ee.value) && Si(ee.value, T);
        }
      }
    }
    function zl(g) {
      {
        var T = g.type;
        if (T == null || typeof T == "string")
          return;
        var F;
        if (typeof T == "function")
          F = T.propTypes;
        else if (typeof T == "object" && (T.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        T.$$typeof === d))
          F = T.propTypes;
        else
          return;
        if (F) {
          var B = z(T);
          fn(F, g.props, "prop", B, g);
        } else if (T.PropTypes !== void 0 && !Xn) {
          Xn = !0;
          var se = z(T);
          x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", se || "Unknown");
        }
        typeof T.getDefaultProps == "function" && !T.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Bl(g) {
      {
        for (var T = Object.keys(g.props), F = 0; F < T.length; F++) {
          var B = T[F];
          if (B !== "children" && B !== "key") {
            Kt(g), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", B), Kt(null);
            break;
          }
        }
        g.ref !== null && (Kt(g), x("Invalid attribute `ref` supplied to `React.Fragment`."), Kt(null));
      }
    }
    var Ci = {};
    function Oi(g, T, F, B, se, ae) {
      {
        var ee = N(g);
        if (!ee) {
          var Y = "";
          (g === void 0 || typeof g == "object" && g !== null && Object.keys(g).length === 0) && (Y += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Oe = Ll();
          Oe ? Y += Oe : Y += wi();
          var me;
          g === null ? me = "null" : Ce(g) ? me = "array" : g !== void 0 && g.$$typeof === e ? (me = "<" + (z(g.type) || "Unknown") + " />", Y = " Did you accidentally export a JSX literal instead of a component?") : me = typeof g, x("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", me, Y);
        }
        var be = Ml(g, T, F, se, ae);
        if (be == null)
          return be;
        if (ee) {
          var ze = T.children;
          if (ze !== void 0)
            if (B)
              if (Ce(ze)) {
                for (var Qt = 0; Qt < ze.length; Qt++)
                  Ei(ze[Qt], g);
                Object.freeze && Object.freeze(ze);
              } else
                x("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ei(ze, g);
        }
        if (lt.call(T, "key")) {
          var _t = z(g), Ne = Object.keys(T).filter(function(Kl) {
            return Kl !== "key";
          }), Jn = Ne.length > 0 ? "{key: someKey, " + Ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ci[_t + Jn]) {
            var ql = Ne.length > 0 ? "{" + Ne.join(": ..., ") + ": ...}" : "{}";
            x(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Jn, _t, ql, _t), Ci[_t + Jn] = !0;
          }
        }
        return g === n ? Bl(be) : zl(be), be;
      }
    }
    function $l(g, T, F) {
      return Oi(g, T, F, !0);
    }
    function Hl(g, T, F) {
      return Oi(g, T, F, !1);
    }
    var Wl = Hl, Vl = $l;
    _r.Fragment = n, _r.jsx = Wl, _r.jsxs = Vl;
  }()), _r;
}
process.env.NODE_ENV === "production" ? ms.exports = vc() : ms.exports = wc();
var v = ms.exports, ft = /* @__PURE__ */ ((t) => (t.Docx = ".docx", t.Doc = ".doc", t.Ttf = ".ttf", t.AD_PRT = ".AD_PRT", t.AD_SMP = ".AD_SMP", t.AD_ASM = ".AD_ASM", t.AD_DRW = ".AD_DRW", t))(ft || {}), oe = /* @__PURE__ */ ((t) => (t.Editor = "editor", t.Community = "community", t.BlockPreview = "block_preview", t.Membership = "membership", t.Marketplace = "marketplace", t.Settings = "settings", t.Email = "email", t.Ckeditor = "ckeditor", t.TextEditor = "text_editor", t.BlogPost = "blog_post", t.PageTemplate = "page_template", t.PageTemplatePreview = "page_template_preview", t.BlogTemplatePreview = "blog_template_preview", t.EmailTemplate = "email_template", t.WebsiteTemplate = "website_template", t.Product = "product", t.FunnelTemplatePreview = "funnel_template_preview", t.DigitalStore = "digital_store", t.DigitalProductResource = "digital_product_resource", t.CalendarHostAvatar = "calendar_host_avatar", t.FileManager = "file_manager", t.WhiteLabel = "white_label", t))(oe || {}), ie = /* @__PURE__ */ ((t) => (t.Image = "image", t.ImageOther = "image_other", t.Video = "video", t.Audio = "audio", t.Font = "font", t.Document = "document", t))(ie || {});
const xc = (t) => {
  if (typeof t != "object" || t === null)
    return !1;
  const e = t;
  return typeof e.id == "number" && typeof e.name == "string" && typeof e.filename == "string" && typeof e.path == "string" && (typeof e.thumbnail == "string" || e.thumbnail === null) && Object.values(oe).includes(e.source) && typeof e.size == "number" && Object.values(ie).includes(e.type) && typeof e.createdAt == "string";
}, Sc = {
  [oe.Editor]: "file_manager.file_source.editor",
  [oe.Community]: "file_manager.file_source.community",
  [oe.BlockPreview]: "file_manager.file_source.block_preview",
  [oe.Membership]: "file_manager.file_source.membership",
  [oe.Marketplace]: "file_manager.file_source.marketplace",
  [oe.Settings]: "file_manager.file_source.settings",
  [oe.Email]: "file_manager.file_source.email",
  [oe.Ckeditor]: "file_manager.file_source.ckeditor",
  [oe.BlogPost]: "file_manager.file_source.blog_post",
  [oe.PageTemplate]: "file_manager.file_source.page_template",
  [oe.PageTemplatePreview]: "file_manager.file_source.page_template_preview",
  [oe.BlogTemplatePreview]: "file_manager.file_source.blog_template_preview",
  [oe.EmailTemplate]: "file_manager.file_source.email_template",
  [oe.Product]: "file_manager.file_source.product",
  [oe.FunnelTemplatePreview]: "file_manager.file_source.funnel_template_preview",
  [oe.DigitalStore]: "file_manager.file_source.digital_store",
  [oe.DigitalProductResource]: "file_manager.file_source.digital_product_resource",
  [oe.CalendarHostAvatar]: "file_manager.file_source.calendar_host_avatar",
  [oe.FileManager]: "file_manager.file_source.file_manager",
  [oe.TextEditor]: "file_manager.file_source.text_editor",
  [oe.WhiteLabel]: "file_manager.file_source.white_label",
  [oe.WebsiteTemplate]: "file_manager.file_source.website_template"
}, Ec = {
  [ie.Image]: "file_manager.file_type.image",
  [ie.ImageOther]: "file_manager.file_type.image_other",
  [ie.Video]: "file_manager.file_type.video",
  [ie.Audio]: "file_manager.file_type.audio",
  [ie.Font]: "file_manager.file_type.font",
  [ie.Document]: "file_manager.file_type.document"
};
var ei = /* @__PURE__ */ ((t) => (t.Next = "next", t.Prev = "prev", t))(ei || {}), Za = /* @__PURE__ */ ((t) => (t.Asc = "ASC", t.Desc = "DESC", t))(Za || {});
function Cc(t) {
  return /* @__PURE__ */ v.jsx(
    "svg",
    {
      id: "Layer_1",
      enableBackground: "new 0 0 28 28",
      height: "512",
      viewBox: "0 0 28 28",
      width: "512",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ v.jsx("g", { id: "_x35_3", children: /* @__PURE__ */ v.jsx("path", { d: "m4.6 8.7c-.2.5-.3 1-.3 1.5v12.2c0 2 1.6 3.6 3.6 3.6h12.2c2 0 3.6-1.6 3.6-3.6v-16.8c0-2-1.6-3.6-3.6-3.6h-7.6c-.5 0-1 .1-1.5.3-.4.2-.7.4-1 .7l-4.6 4.6c-.3.3-.6.7-.8 1.1zm8.1 5.7c.3 0 .7.1 1 .2v-6c0-.4.2-.8.6-.9.4-.2.8-.1 1.1.2l2.7 2.7c.4.4.4 1 0 1.4s-1 .4-1.4 0l-1-1v6.3c0 1.7-1.4 3-3 3-1.7 0-3-1.3-3-3 0-1.6 1.3-2.9 3-2.9z" }) })
    }
  );
}
function ji(t) {
  return /* @__PURE__ */ v.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      id: "Capa_1",
      enableBackground: "new 0 0 512 512",
      height: "512",
      viewBox: "0 0 512 512",
      width: "512",
      ...t,
      children: [
        /* @__PURE__ */ v.jsx("path", { d: "m106 512h300c24.814 0 45-20.186 45-45v-317h-105c-24.814 0-45-20.186-45-45v-105h-195c-24.814 0-45 20.186-45 45v422c0 24.814 20.186 45 45 45zm60-301h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h120c8.291 0 15 6.709 15 15s-6.709 15-15 15h-120c-8.291 0-15-6.709-15-15s6.709-15 15-15z" }),
        /* @__PURE__ */ v.jsx("path", { d: "m346 120h96.211l-111.211-111.211v96.211c0 8.276 6.724 15 15 15z" })
      ]
    }
  );
}
function Oc(t) {
  return /* @__PURE__ */ v.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      height: "512pt",
      viewBox: "0 -64 512 512",
      width: "512pt",
      ...t,
      children: [
        /* @__PURE__ */ v.jsx("path", { d: "m149.332031 106.667969c0 23.5625-19.101562 42.664062-42.664062 42.664062-23.566407 0-42.667969-19.101562-42.667969-42.664062 0-23.566407 19.101562-42.667969 42.667969-42.667969 23.5625 0 42.664062 19.101562 42.664062 42.667969zm0 0" }),
        /* @__PURE__ */ v.jsx("path", { d: "m448 0h-384c-35.285156 0-64 28.714844-64 64v256c0 1.195312.296875 2.324219.363281 3.519531-.300781 2.558594-.171875 5.140625.765625 7.574219 5.269532 29.996094 31.382813 52.90625 62.871094 52.90625h384c35.285156 0 64-28.714844 64-64v-256c0-35.285156-28.714844-64-64-64zm-384 42.667969h384c11.753906 0 21.332031 9.578125 21.332031 21.332031v169.367188l-112.210937-112.214844c-14.59375-14.59375-38.335938-14.59375-52.90625 0l-101.546875 101.546875-26.882813-26.878907c-14.589844-14.59375-38.335937-14.59375-52.90625 0l-80.210937 80.210938v-212.03125c0-11.753906 9.578125-21.332031 21.332031-21.332031zm0 0" })
      ]
    }
  );
}
function Rc(t) {
  return /* @__PURE__ */ v.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      id: "Capa_1",
      x: "0px",
      y: "0px",
      viewBox: "0 0 467.968 467.968",
      ...t,
      children: [
        /* @__PURE__ */ v.jsx("g", { children: /* @__PURE__ */ v.jsx("g", { children: /* @__PURE__ */ v.jsx("path", { d: "M264.704,96.512H51.2c-28.16,0-51.2,23.04-51.2,51.2v172.544c0,28.16,23.04,51.2,51.2,51.2h213.504    c28.16,0,51.2-23.04,51.2-51.2V147.712C315.904,119.04,292.864,96.512,264.704,96.512z" }) }) }),
        /* @__PURE__ */ v.jsx("g", { children: /* @__PURE__ */ v.jsx("g", { children: /* @__PURE__ */ v.jsx("path", { d: "M430.08,124.672c-3.072,0.512-6.144,2.048-8.704,3.584l-79.872,46.08V293.12l80.384,46.08    c14.848,8.704,33.28,3.584,41.984-11.264c2.56-4.608,4.096-9.728,4.096-15.36V154.368    C467.968,135.424,450.048,120.064,430.08,124.672z" }) }) }),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {})
      ]
    }
  );
}
function _c(t) {
  switch (t) {
    case ie.Audio:
      return /* @__PURE__ */ v.jsx(Cc, { className: "fill-text-secondary", width: 40, height: 40 });
    case ie.Image:
    case ie.ImageOther:
      return /* @__PURE__ */ v.jsx(Oc, { className: "fill-text-secondary", width: 40, height: 40 });
    case ie.Video:
      return /* @__PURE__ */ v.jsx(Rc, { className: "fill-text-secondary", width: 40, height: 40 });
    case ie.Font:
    case ie.Document:
      return /* @__PURE__ */ v.jsx(ji, { className: "fill-text-secondary", width: 40, height: 40 });
    default:
      return /* @__PURE__ */ v.jsx(ji, { className: "fill-text-secondary", width: 40, height: 40 });
  }
}
const ti = "-", Pc = (t) => {
  const e = Nc(t), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = t;
  return {
    getClassGroupId: (a) => {
      const o = a.split(ti);
      return o[0] === "" && o.length !== 1 && o.shift(), eo(o, e) || Tc(a);
    },
    getConflictingClassGroupIds: (a, o) => {
      const l = r[a] || [];
      return o && n[a] ? [...l, ...n[a]] : l;
    }
  };
}, eo = (t, e) => {
  var a;
  if (t.length === 0)
    return e.classGroupId;
  const r = t[0], n = e.nextPart.get(r), s = n ? eo(t.slice(1), n) : void 0;
  if (s)
    return s;
  if (e.validators.length === 0)
    return;
  const i = t.join(ti);
  return (a = e.validators.find(({
    validator: o
  }) => o(i))) == null ? void 0 : a.classGroupId;
}, Di = /^\[(.+)\]$/, Tc = (t) => {
  if (Di.test(t)) {
    const e = Di.exec(t)[1], r = e == null ? void 0 : e.substring(0, e.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, Nc = (t) => {
  const {
    theme: e,
    prefix: r
  } = t, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return Dc(Object.entries(t.classGroups), r).forEach(([i, a]) => {
    gs(a, n, i, e);
  }), n;
}, gs = (t, e, r, n) => {
  t.forEach((s) => {
    if (typeof s == "string") {
      const i = s === "" ? e : Fi(e, s);
      i.classGroupId = r;
      return;
    }
    if (typeof s == "function") {
      if (jc(s)) {
        gs(s(n), e, r, n);
        return;
      }
      e.validators.push({
        validator: s,
        classGroupId: r
      });
      return;
    }
    Object.entries(s).forEach(([i, a]) => {
      gs(a, Fi(e, i), r, n);
    });
  });
}, Fi = (t, e) => {
  let r = t;
  return e.split(ti).forEach((n) => {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}, jc = (t) => t.isThemeGetter, Dc = (t, e) => e ? t.map(([r, n]) => {
  const s = n.map((i) => typeof i == "string" ? e + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([a, o]) => [e + a, o])) : i);
  return [r, s];
}) : t, Fc = (t) => {
  if (t < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let e = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  const s = (i, a) => {
    r.set(i, a), e++, e > t && (e = 0, n = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let a = r.get(i);
      if (a !== void 0)
        return a;
      if ((a = n.get(i)) !== void 0)
        return s(i, a), a;
    },
    set(i, a) {
      r.has(i) ? r.set(i, a) : s(i, a);
    }
  };
}, to = "!", Ac = (t) => {
  const {
    separator: e,
    experimentalParseClassName: r
  } = t, n = e.length === 1, s = e[0], i = e.length, a = (o) => {
    const l = [];
    let c = 0, u = 0, d;
    for (let p = 0; p < o.length; p++) {
      let S = o[p];
      if (c === 0) {
        if (S === s && (n || o.slice(p, p + i) === e)) {
          l.push(o.slice(u, p)), u = p + i;
          continue;
        }
        if (S === "/") {
          d = p;
          continue;
        }
      }
      S === "[" ? c++ : S === "]" && c--;
    }
    const h = l.length === 0 ? o : o.substring(u), m = h.startsWith(to), f = m ? h.substring(1) : h, y = d && d > u ? d - u : void 0;
    return {
      modifiers: l,
      hasImportantModifier: m,
      baseClassName: f,
      maybePostfixModifierPosition: y
    };
  };
  return r ? (o) => r({
    className: o,
    parseClassName: a
  }) : a;
}, kc = (t) => {
  if (t.length <= 1)
    return t;
  const e = [];
  let r = [];
  return t.forEach((n) => {
    n[0] === "[" ? (e.push(...r.sort(), n), r = []) : r.push(n);
  }), e.push(...r.sort()), e;
}, Ic = (t) => ({
  cache: Fc(t.cacheSize),
  parseClassName: Ac(t),
  ...Pc(t)
}), Mc = /\s+/, Lc = (t, e) => {
  const {
    parseClassName: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: s
  } = e, i = [], a = t.trim().split(Mc);
  let o = "";
  for (let l = a.length - 1; l >= 0; l -= 1) {
    const c = a[l], {
      modifiers: u,
      hasImportantModifier: d,
      baseClassName: h,
      maybePostfixModifierPosition: m
    } = r(c);
    let f = !!m, y = n(f ? h.substring(0, m) : h);
    if (!y) {
      if (!f) {
        o = c + (o.length > 0 ? " " + o : o);
        continue;
      }
      if (y = n(h), !y) {
        o = c + (o.length > 0 ? " " + o : o);
        continue;
      }
      f = !1;
    }
    const p = kc(u).join(":"), S = d ? p + to : p, x = S + y;
    if (i.includes(x))
      continue;
    i.push(x);
    const C = s(y, f);
    for (let P = 0; P < C.length; ++P) {
      const j = C[P];
      i.push(S + j);
    }
    o = c + (o.length > 0 ? " " + o : o);
  }
  return o;
};
function Uc() {
  let t = 0, e, r, n = "";
  for (; t < arguments.length; )
    (e = arguments[t++]) && (r = ro(e)) && (n && (n += " "), n += r);
  return n;
}
const ro = (t) => {
  if (typeof t == "string")
    return t;
  let e, r = "";
  for (let n = 0; n < t.length; n++)
    t[n] && (e = ro(t[n])) && (r && (r += " "), r += e);
  return r;
};
function zc(t, ...e) {
  let r, n, s, i = a;
  function a(l) {
    const c = e.reduce((u, d) => d(u), t());
    return r = Ic(c), n = r.cache.get, s = r.cache.set, i = o, o(l);
  }
  function o(l) {
    const c = n(l);
    if (c)
      return c;
    const u = Lc(l, r);
    return s(l, u), u;
  }
  return function() {
    return i(Uc.apply(null, arguments));
  };
}
const le = (t) => {
  const e = (r) => r[t] || [];
  return e.isThemeGetter = !0, e;
}, no = /^\[(?:([a-z-]+):)?(.+)\]$/i, Bc = /^\d+\/\d+$/, $c = /* @__PURE__ */ new Set(["px", "full", "screen"]), Hc = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Wc = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Vc = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, qc = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Kc = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, it = (t) => rr(t) || $c.has(t) || Bc.test(t), ct = (t) => wr(t, "length", tu), rr = (t) => !!t && !Number.isNaN(Number(t)), es = (t) => wr(t, "number", rr), Pr = (t) => !!t && Number.isInteger(Number(t)), Qc = (t) => t.endsWith("%") && rr(t.slice(0, -1)), q = (t) => no.test(t), ut = (t) => Hc.test(t), Yc = /* @__PURE__ */ new Set(["length", "size", "percentage"]), Xc = (t) => wr(t, Yc, so), Gc = (t) => wr(t, "position", so), Jc = /* @__PURE__ */ new Set(["image", "url"]), Zc = (t) => wr(t, Jc, nu), eu = (t) => wr(t, "", ru), Tr = () => !0, wr = (t, e, r) => {
  const n = no.exec(t);
  return n ? n[1] ? typeof e == "string" ? n[1] === e : e.has(n[1]) : r(n[2]) : !1;
}, tu = (t) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Wc.test(t) && !Vc.test(t)
), so = () => !1, ru = (t) => qc.test(t), nu = (t) => Kc.test(t), su = () => {
  const t = le("colors"), e = le("spacing"), r = le("blur"), n = le("brightness"), s = le("borderColor"), i = le("borderRadius"), a = le("borderSpacing"), o = le("borderWidth"), l = le("contrast"), c = le("grayscale"), u = le("hueRotate"), d = le("invert"), h = le("gap"), m = le("gradientColorStops"), f = le("gradientColorStopPositions"), y = le("inset"), p = le("margin"), S = le("opacity"), x = le("padding"), C = le("saturate"), P = le("scale"), j = le("sepia"), w = le("skew"), _ = le("space"), O = le("translate"), R = () => ["auto", "contain", "none"], N = () => ["auto", "hidden", "clip", "visible", "scroll"], k = () => ["auto", q, e], D = () => [q, e], z = () => ["", it, ct], U = () => ["auto", rr, q], M = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], re = () => ["solid", "dashed", "dotted", "double", "none"], ce = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], $ = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], K = () => ["", "0", q], ne = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], W = () => [rr, q];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Tr],
      spacing: [it, ct],
      blur: ["none", "", ut, q],
      brightness: W(),
      borderColor: [t],
      borderRadius: ["none", "", "full", ut, q],
      borderSpacing: D(),
      borderWidth: z(),
      contrast: W(),
      grayscale: K(),
      hueRotate: W(),
      invert: K(),
      gap: D(),
      gradientColorStops: [t],
      gradientColorStopPositions: [Qc, ct],
      inset: k(),
      margin: k(),
      opacity: W(),
      padding: D(),
      saturate: W(),
      scale: W(),
      sepia: K(),
      skew: W(),
      space: D(),
      translate: D()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", q]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [ut]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": ne()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": ne()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...M(), q]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: N()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": N()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": N()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: R()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": R()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": R()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [y]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [y]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [y]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [y]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [y]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [y]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [y]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [y]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [y]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Pr, q]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: k()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", q]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: K()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: K()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Pr, q]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Tr]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Pr, q]
        }, q]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": U()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": U()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Tr]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Pr, q]
        }, q]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": U()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": U()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", q]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", q]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [h]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [h]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [h]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...$()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...$(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...$(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [x]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [x]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [x]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [x]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [x]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [x]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [x]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [x]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [x]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [p]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [p]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [p]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [p]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [p]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [p]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [p]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [p]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [p]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [_]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [_]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", q, e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [q, e, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [q, e, "none", "full", "min", "max", "fit", "prose", {
          screen: [ut]
        }, ut]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [q, e, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [q, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [q, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [q, e, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", ut, ct]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", es]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Tr]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", q]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", rr, es]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", it, q]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", q]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", q]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [t]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [S]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [t]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [S]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...re(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", it, ct]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", it, q]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [t]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: D()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", q]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", q]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [S]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...M(), Gc]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Xc]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Zc]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [t]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [f]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [f]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [f]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [m]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [o]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [o]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [o]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [o]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [o]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [o]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [o]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [o]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [o]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [S]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...re(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [o]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [o]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [S]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: re()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [s]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [s]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [s]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [s]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [s]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [s]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [s]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [s]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [s]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [s]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...re()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [it, q]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [it, ct]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [t]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: z()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [t]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [S]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [it, ct]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [t]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", ut, eu]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Tr]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [S]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...ce(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": ce()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", ut, q]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [C]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [j]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [S]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [C]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [j]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", q]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: W()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", q]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: W()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", q]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [P]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [P]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [P]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Pr, q]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [O]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [O]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [w]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [w]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", q]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", t]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", q]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [t]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": D()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": D()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": D()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": D()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": D()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": D()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": D()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": D()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": D()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": D()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": D()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": D()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": D()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": D()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": D()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": D()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": D()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": D()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", q]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [t, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [it, ct, es]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [t, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, ge = /* @__PURE__ */ zc(su), Nr = /* @__PURE__ */ new Set(), jr = /* @__PURE__ */ new Set(), zt = Ae.memo(
  ({
    src: t,
    fileType: e,
    alt: r,
    className: n,
    isThumbnail: s = !1,
    width: i,
    height: a,
    title: o
  }) => {
    const [l, c] = Ae.useState(jr.has(t)), [u, d] = Ae.useState(Nr.has(t));
    return /* @__PURE__ */ v.jsxs(
      "div",
      {
        className: ge("flex items-center justify-center", n),
        style: {
          width: i,
          height: a,
          minHeight: a
        },
        title: o,
        children: [
          e !== ie.Video && /* @__PURE__ */ v.jsx(
            "img",
            {
              src: t,
              alt: r,
              className: ge(
                "flex-2 w-full rounded-md object-cover",
                s && "h-full object-cover",
                !l && u ? "block" : "hidden"
              ),
              onLoad: () => {
                d(!0), Nr.add(t), jr.delete(t);
              },
              onError: () => {
                c(!0), Nr.delete(t), jr.add(t);
              }
            }
          ),
          e === ie.Video && /* @__PURE__ */ v.jsx(
            "video",
            {
              src: t,
              className: ge(
                "flex-2 w-full rounded-md object-cover",
                s && "h-full object-cover",
                !l && u ? "block" : "hidden"
              ),
              onLoadedData: () => {
                d(!0), Nr.add(t), jr.delete(t);
              },
              onError: () => {
                c(!0), Nr.delete(t), jr.add(t);
              },
              controls: !s
            }
          ),
          /* @__PURE__ */ v.jsx(
            "div",
            {
              className: ge(
                "flex-2 flex items-center justify-center rounded-md",
                !s && "min-h-[300px]",
                !t || l ? "flex" : "hidden"
              ),
              children: _c(e)
            }
          )
        ]
      }
    );
  }
);
zt.displayName = "FilePreview";
function iu({
  fileType: t,
  src: e,
  alt: r,
  name: n,
  secondaryText: s,
  style: i,
  selected: a,
  actionMenu: o,
  className: l,
  imageWidth: c,
  imageHeight: u,
  onSelect: d
}) {
  const h = Ae.useRef(null), m = Ae.useRef(null);
  return /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: ge("relative flex flex-col cursor-pointer", l),
      style: i,
      onClick: (f) => {
        var y;
        h.current && !((y = m.current) != null && y.contains(f.target)) && h.current.click();
      },
      children: [
        /* @__PURE__ */ v.jsx(
          zt,
          {
            src: e ?? "",
            fileType: t,
            alt: r,
            width: c,
            height: u,
            className: ge(
              "relative -top-[2px] -left-[2px] flex-1 rounded-lg border-2 border-transparent box-content",
              a && "border-brand-primary"
            ),
            isThumbnail: !0
          }
        ),
        /* @__PURE__ */ v.jsx("div", { ref: m, className: "absolute top-1 left-1", children: /* @__PURE__ */ v.jsx(Jl, { inputRef: h, value: a, onChange: d }) }),
        /* @__PURE__ */ v.jsx("div", { onClick: (f) => f.stopPropagation(), children: /* @__PURE__ */ v.jsx(
          Zl,
          {
            toggleOnHover: !0,
            menuButtonClassName: "absolute top-1 right-1 p-1 h-[20px] w-[26px]",
            menuItemsClassName: "z-30",
            ...o,
            menuItems: (o == null ? void 0 : o.menuItems) ?? []
          }
        ) }),
        /* @__PURE__ */ v.jsx(
          "div",
          {
            className: "truncate overflow-clip text-base text-text-primary mt-1",
            title: n,
            children: n
          }
        ),
        /* @__PURE__ */ v.jsx(
          "div",
          {
            className: "truncate overflow-clip text-sm text-text-secondary mt-1",
            title: s,
            children: s
          }
        )
      ]
    }
  );
}
const au = (t, e) => {
  const r = t[e];
  return r ? typeof r == "function" ? r() : Promise.resolve(r) : new Promise((n, s) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(s.bind(null, new Error("Unknown variable dynamic import: " + e)));
  });
}, H = (t) => typeof t == "string", Dr = () => {
  let t, e;
  const r = new Promise((n, s) => {
    t = n, e = s;
  });
  return r.resolve = t, r.reject = e, r;
}, Ai = (t) => t == null ? "" : "" + t, ou = (t, e, r) => {
  t.forEach((n) => {
    e[n] && (r[n] = e[n]);
  });
}, lu = /###/g, ki = (t) => t && t.indexOf("###") > -1 ? t.replace(lu, ".") : t, Ii = (t) => !t || H(t), Ur = (t, e, r) => {
  const n = H(e) ? e.split(".") : e;
  let s = 0;
  for (; s < n.length - 1; ) {
    if (Ii(t))
      return {};
    const i = ki(n[s]);
    !t[i] && r && (t[i] = new r()), Object.prototype.hasOwnProperty.call(t, i) ? t = t[i] : t = {}, ++s;
  }
  return Ii(t) ? {} : {
    obj: t,
    k: ki(n[s])
  };
}, Mi = (t, e, r) => {
  const {
    obj: n,
    k: s
  } = Ur(t, e, Object);
  if (n !== void 0 || e.length === 1) {
    n[s] = r;
    return;
  }
  let i = e[e.length - 1], a = e.slice(0, e.length - 1), o = Ur(t, a, Object);
  for (; o.obj === void 0 && a.length; )
    i = `${a[a.length - 1]}.${i}`, a = a.slice(0, a.length - 1), o = Ur(t, a, Object), o && o.obj && typeof o.obj[`${o.k}.${i}`] < "u" && (o.obj = void 0);
  o.obj[`${o.k}.${i}`] = r;
}, cu = (t, e, r, n) => {
  const {
    obj: s,
    k: i
  } = Ur(t, e, Object);
  s[i] = s[i] || [], s[i].push(r);
}, Cn = (t, e) => {
  const {
    obj: r,
    k: n
  } = Ur(t, e);
  if (r)
    return r[n];
}, uu = (t, e, r) => {
  const n = Cn(t, r);
  return n !== void 0 ? n : Cn(e, r);
}, io = (t, e, r) => {
  for (const n in e)
    n !== "__proto__" && n !== "constructor" && (n in t ? H(t[n]) || t[n] instanceof String || H(e[n]) || e[n] instanceof String ? r && (t[n] = e[n]) : io(t[n], e[n], r) : t[n] = e[n]);
  return t;
}, Yt = (t) => t.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var hu = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const du = (t) => H(t) ? t.replace(/[&<>"'\/]/g, (e) => hu[e]) : t;
class fu {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const r = this.regExpMap.get(e);
    if (r !== void 0)
      return r;
    const n = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, n), this.regExpQueue.push(e), n;
  }
}
const pu = [" ", ",", "?", "!", ";"], mu = new fu(20), gu = (t, e, r) => {
  e = e || "", r = r || "";
  const n = pu.filter((a) => e.indexOf(a) < 0 && r.indexOf(a) < 0);
  if (n.length === 0)
    return !0;
  const s = mu.getRegExp(`(${n.map((a) => a === "?" ? "\\?" : a).join("|")})`);
  let i = !s.test(t);
  if (!i) {
    const a = t.indexOf(r);
    a > 0 && !s.test(t.substring(0, a)) && (i = !0);
  }
  return i;
}, ys = function(t, e) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!t)
    return;
  if (t[e])
    return t[e];
  const n = e.split(r);
  let s = t;
  for (let i = 0; i < n.length; ) {
    if (!s || typeof s != "object")
      return;
    let a, o = "";
    for (let l = i; l < n.length; ++l)
      if (l !== i && (o += r), o += n[l], a = s[o], a !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof a) > -1 && l < n.length - 1)
          continue;
        i += l - i + 1;
        break;
      }
    s = a;
  }
  return s;
}, On = (t) => t && t.replace("_", "-"), yu = {
  type: "logger",
  log(t) {
    this.output("log", t);
  },
  warn(t) {
    this.output("warn", t);
  },
  error(t) {
    this.output("error", t);
  },
  output(t, e) {
    console && console[t] && console[t].apply(console, e);
  }
};
class Rn {
  constructor(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(e, r);
  }
  init(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = r.prefix || "i18next:", this.logger = e || yu, this.options = r, this.debug = r.debug;
  }
  log() {
    for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
      r[n] = arguments[n];
    return this.forward(r, "log", "", !0);
  }
  warn() {
    for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
      r[n] = arguments[n];
    return this.forward(r, "warn", "", !0);
  }
  error() {
    for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
      r[n] = arguments[n];
    return this.forward(r, "error", "");
  }
  deprecate() {
    for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
      r[n] = arguments[n];
    return this.forward(r, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, r, n, s) {
    return s && !this.debug ? null : (H(e[0]) && (e[0] = `${n}${this.prefix} ${e[0]}`), this.logger[r](e));
  }
  create(e) {
    return new Rn(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new Rn(this.logger, e);
  }
}
var et = new Rn();
class Mn {
  constructor() {
    this.observers = {};
  }
  on(e, r) {
    return e.split(" ").forEach((n) => {
      this.observers[n] || (this.observers[n] = /* @__PURE__ */ new Map());
      const s = this.observers[n].get(r) || 0;
      this.observers[n].set(r, s + 1);
    }), this;
  }
  off(e, r) {
    if (this.observers[e]) {
      if (!r) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(r);
    }
  }
  emit(e) {
    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++)
      n[s - 1] = arguments[s];
    this.observers[e] && Array.from(this.observers[e].entries()).forEach((a) => {
      let [o, l] = a;
      for (let c = 0; c < l; c++)
        o(...n);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((a) => {
      let [o, l] = a;
      for (let c = 0; c < l; c++)
        o.apply(o, [e, ...n]);
    });
  }
}
class Li extends Mn {
  constructor(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = e || {}, this.options = r, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const r = this.options.ns.indexOf(e);
    r > -1 && this.options.ns.splice(r, 1);
  }
  getResource(e, r, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator, a = s.ignoreJSONStructure !== void 0 ? s.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let o;
    e.indexOf(".") > -1 ? o = e.split(".") : (o = [e, r], n && (Array.isArray(n) ? o.push(...n) : H(n) && i ? o.push(...n.split(i)) : o.push(n)));
    const l = Cn(this.data, o);
    return !l && !r && !n && e.indexOf(".") > -1 && (e = o[0], r = o[1], n = o.slice(2).join(".")), l || !a || !H(n) ? l : ys(this.data && this.data[e] && this.data[e][r], n, i);
  }
  addResource(e, r, n, s) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const a = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let o = [e, r];
    n && (o = o.concat(a ? n.split(a) : n)), e.indexOf(".") > -1 && (o = e.split("."), s = r, r = o[1]), this.addNamespaces(r), Mi(this.data, o, s), i.silent || this.emit("added", e, r, n, s);
  }
  addResources(e, r, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const i in n)
      (H(n[i]) || Array.isArray(n[i])) && this.addResource(e, r, i, n[i], {
        silent: !0
      });
    s.silent || this.emit("added", e, r, n);
  }
  addResourceBundle(e, r, n, s, i) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, o = [e, r];
    e.indexOf(".") > -1 && (o = e.split("."), s = n, n = r, r = o[1]), this.addNamespaces(r);
    let l = Cn(this.data, o) || {};
    a.skipCopy || (n = JSON.parse(JSON.stringify(n))), s ? io(l, n, i) : l = {
      ...l,
      ...n
    }, Mi(this.data, o, l), a.silent || this.emit("added", e, r, n);
  }
  removeResourceBundle(e, r) {
    this.hasResourceBundle(e, r) && delete this.data[e][r], this.removeNamespaces(r), this.emit("removed", e, r);
  }
  hasResourceBundle(e, r) {
    return this.getResource(e, r) !== void 0;
  }
  getResourceBundle(e, r) {
    return r || (r = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(e, r)
    } : this.getResource(e, r);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const r = this.getDataByLanguage(e);
    return !!(r && Object.keys(r) || []).find((s) => r[s] && Object.keys(r[s]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var ao = {
  processors: {},
  addPostProcessor(t) {
    this.processors[t.name] = t;
  },
  handle(t, e, r, n, s) {
    return t.forEach((i) => {
      this.processors[i] && (e = this.processors[i].process(e, r, n, s));
    }), e;
  }
};
const Ui = {};
class _n extends Mn {
  constructor(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), ou(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = r, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = et.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (e == null)
      return !1;
    const n = this.resolve(e, r);
    return n && n.res !== void 0;
  }
  extractFromKey(e, r) {
    let n = r.nsSeparator !== void 0 ? r.nsSeparator : this.options.nsSeparator;
    n === void 0 && (n = ":");
    const s = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
    let i = r.ns || this.options.defaultNS || [];
    const a = n && e.indexOf(n) > -1, o = !this.options.userDefinedKeySeparator && !r.keySeparator && !this.options.userDefinedNsSeparator && !r.nsSeparator && !gu(e, n, s);
    if (a && !o) {
      const l = e.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: e,
          namespaces: H(i) ? [i] : i
        };
      const c = e.split(n);
      (n !== s || n === s && this.options.ns.indexOf(c[0]) > -1) && (i = c.shift()), e = c.join(s);
    }
    return {
      key: e,
      namespaces: H(i) ? [i] : i
    };
  }
  translate(e, r, n) {
    if (typeof r != "object" && this.options.overloadTranslationOptionHandler && (r = this.options.overloadTranslationOptionHandler(arguments)), typeof r == "object" && (r = {
      ...r
    }), r || (r = {}), e == null)
      return "";
    Array.isArray(e) || (e = [String(e)]);
    const s = r.returnDetails !== void 0 ? r.returnDetails : this.options.returnDetails, i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, {
      key: a,
      namespaces: o
    } = this.extractFromKey(e[e.length - 1], r), l = o[o.length - 1], c = r.lng || this.language, u = r.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (c && c.toLowerCase() === "cimode") {
      if (u) {
        const P = r.nsSeparator || this.options.nsSeparator;
        return s ? {
          res: `${l}${P}${a}`,
          usedKey: a,
          exactUsedKey: a,
          usedLng: c,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(r)
        } : `${l}${P}${a}`;
      }
      return s ? {
        res: a,
        usedKey: a,
        exactUsedKey: a,
        usedLng: c,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(r)
      } : a;
    }
    const d = this.resolve(e, r);
    let h = d && d.res;
    const m = d && d.usedKey || a, f = d && d.exactUsedKey || a, y = Object.prototype.toString.apply(h), p = ["[object Number]", "[object Function]", "[object RegExp]"], S = r.joinArrays !== void 0 ? r.joinArrays : this.options.joinArrays, x = !this.i18nFormat || this.i18nFormat.handleAsObject, C = !H(h) && typeof h != "boolean" && typeof h != "number";
    if (x && h && C && p.indexOf(y) < 0 && !(H(S) && Array.isArray(h))) {
      if (!r.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const P = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(m, h, {
          ...r,
          ns: o
        }) : `key '${a} (${this.language})' returned an object instead of string.`;
        return s ? (d.res = P, d.usedParams = this.getUsedParamsDetails(r), d) : P;
      }
      if (i) {
        const P = Array.isArray(h), j = P ? [] : {}, w = P ? f : m;
        for (const _ in h)
          if (Object.prototype.hasOwnProperty.call(h, _)) {
            const O = `${w}${i}${_}`;
            j[_] = this.translate(O, {
              ...r,
              joinArrays: !1,
              ns: o
            }), j[_] === O && (j[_] = h[_]);
          }
        h = j;
      }
    } else if (x && H(S) && Array.isArray(h))
      h = h.join(S), h && (h = this.extendTranslation(h, e, r, n));
    else {
      let P = !1, j = !1;
      const w = r.count !== void 0 && !H(r.count), _ = _n.hasDefaultValue(r), O = w ? this.pluralResolver.getSuffix(c, r.count, r) : "", R = r.ordinal && w ? this.pluralResolver.getSuffix(c, r.count, {
        ordinal: !1
      }) : "", N = w && !r.ordinal && r.count === 0 && this.pluralResolver.shouldUseIntlApi(), k = N && r[`defaultValue${this.options.pluralSeparator}zero`] || r[`defaultValue${O}`] || r[`defaultValue${R}`] || r.defaultValue;
      !this.isValidLookup(h) && _ && (P = !0, h = k), this.isValidLookup(h) || (j = !0, h = a);
      const z = (r.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && j ? void 0 : h, U = _ && k !== h && this.options.updateMissing;
      if (j || P || U) {
        if (this.logger.log(U ? "updateKey" : "missingKey", c, l, a, U ? k : h), i) {
          const $ = this.resolve(a, {
            ...r,
            keySeparator: !1
          });
          $ && $.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let M = [];
        const re = this.languageUtils.getFallbackCodes(this.options.fallbackLng, r.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && re && re[0])
          for (let $ = 0; $ < re.length; $++)
            M.push(re[$]);
        else
          this.options.saveMissingTo === "all" ? M = this.languageUtils.toResolveHierarchy(r.lng || this.language) : M.push(r.lng || this.language);
        const ce = ($, K, ne) => {
          const W = _ && ne !== h ? ne : z;
          this.options.missingKeyHandler ? this.options.missingKeyHandler($, l, K, W, U, r) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing($, l, K, W, U, r), this.emit("missingKey", $, l, K, h);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && w ? M.forEach(($) => {
          const K = this.pluralResolver.getSuffixes($, r);
          N && r[`defaultValue${this.options.pluralSeparator}zero`] && K.indexOf(`${this.options.pluralSeparator}zero`) < 0 && K.push(`${this.options.pluralSeparator}zero`), K.forEach((ne) => {
            ce([$], a + ne, r[`defaultValue${ne}`] || k);
          });
        }) : ce(M, a, k));
      }
      h = this.extendTranslation(h, e, r, d, n), j && h === a && this.options.appendNamespaceToMissingKey && (h = `${l}:${a}`), (j || P) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? h = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${a}` : a, P ? h : void 0) : h = this.options.parseMissingKeyHandler(h));
    }
    return s ? (d.res = h, d.usedParams = this.getUsedParamsDetails(r), d) : h;
  }
  extendTranslation(e, r, n, s, i) {
    var a = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...n
      }, n.lng || this.language || s.usedLng, s.usedNS, s.usedKey, {
        resolved: s
      });
    else if (!n.skipInterpolation) {
      n.interpolation && this.interpolator.init({
        ...n,
        interpolation: {
          ...this.options.interpolation,
          ...n.interpolation
        }
      });
      const c = H(e) && (n && n.interpolation && n.interpolation.skipOnVariables !== void 0 ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (c) {
        const h = e.match(this.interpolator.nestingRegexp);
        u = h && h.length;
      }
      let d = n.replace && !H(n.replace) ? n.replace : n;
      if (this.options.interpolation.defaultVariables && (d = {
        ...this.options.interpolation.defaultVariables,
        ...d
      }), e = this.interpolator.interpolate(e, d, n.lng || this.language || s.usedLng, n), c) {
        const h = e.match(this.interpolator.nestingRegexp), m = h && h.length;
        u < m && (n.nest = !1);
      }
      !n.lng && this.options.compatibilityAPI !== "v1" && s && s.res && (n.lng = this.language || s.usedLng), n.nest !== !1 && (e = this.interpolator.nest(e, function() {
        for (var h = arguments.length, m = new Array(h), f = 0; f < h; f++)
          m[f] = arguments[f];
        return i && i[0] === m[0] && !n.context ? (a.logger.warn(`It seems you are nesting recursively key: ${m[0]} in key: ${r[0]}`), null) : a.translate(...m, r);
      }, n)), n.interpolation && this.interpolator.reset();
    }
    const o = n.postProcess || this.options.postProcess, l = H(o) ? [o] : o;
    return e != null && l && l.length && n.applyPostProcessor !== !1 && (e = ao.handle(l, e, r, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...s,
        usedParams: this.getUsedParamsDetails(n)
      },
      ...n
    } : n, this)), e;
  }
  resolve(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n, s, i, a, o;
    return H(e) && (e = [e]), e.forEach((l) => {
      if (this.isValidLookup(n))
        return;
      const c = this.extractFromKey(l, r), u = c.key;
      s = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const h = r.count !== void 0 && !H(r.count), m = h && !r.ordinal && r.count === 0 && this.pluralResolver.shouldUseIntlApi(), f = r.context !== void 0 && (H(r.context) || typeof r.context == "number") && r.context !== "", y = r.lngs ? r.lngs : this.languageUtils.toResolveHierarchy(r.lng || this.language, r.fallbackLng);
      d.forEach((p) => {
        this.isValidLookup(n) || (o = p, !Ui[`${y[0]}-${p}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(o) && (Ui[`${y[0]}-${p}`] = !0, this.logger.warn(`key "${s}" for languages "${y.join(", ")}" won't get resolved as namespace "${o}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), y.forEach((S) => {
          if (this.isValidLookup(n))
            return;
          a = S;
          const x = [u];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(x, u, S, p, r);
          else {
            let P;
            h && (P = this.pluralResolver.getSuffix(S, r.count, r));
            const j = `${this.options.pluralSeparator}zero`, w = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (h && (x.push(u + P), r.ordinal && P.indexOf(w) === 0 && x.push(u + P.replace(w, this.options.pluralSeparator)), m && x.push(u + j)), f) {
              const _ = `${u}${this.options.contextSeparator}${r.context}`;
              x.push(_), h && (x.push(_ + P), r.ordinal && P.indexOf(w) === 0 && x.push(_ + P.replace(w, this.options.pluralSeparator)), m && x.push(_ + j));
            }
          }
          let C;
          for (; C = x.pop(); )
            this.isValidLookup(n) || (i = C, n = this.getResource(S, p, C, r));
        }));
      });
    }), {
      res: n,
      usedKey: s,
      exactUsedKey: i,
      usedLng: a,
      usedNS: o
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, r, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, r, n, s) : this.resourceStore.getResource(e, r, n, s);
  }
  getUsedParamsDetails() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const r = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], n = e.replace && !H(e.replace);
    let s = n ? e.replace : e;
    if (n && typeof e.count < "u" && (s.count = e.count), this.options.interpolation.defaultVariables && (s = {
      ...this.options.interpolation.defaultVariables,
      ...s
    }), !n) {
      s = {
        ...s
      };
      for (const i of r)
        delete s[i];
    }
    return s;
  }
  static hasDefaultValue(e) {
    const r = "defaultValue";
    for (const n in e)
      if (Object.prototype.hasOwnProperty.call(e, n) && r === n.substring(0, r.length) && e[n] !== void 0)
        return !0;
    return !1;
  }
}
const ts = (t) => t.charAt(0).toUpperCase() + t.slice(1);
class zi {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = et.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = On(e), !e || e.indexOf("-") < 0)
      return null;
    const r = e.split("-");
    return r.length === 2 || (r.pop(), r[r.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(r.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = On(e), !e || e.indexOf("-") < 0)
      return e;
    const r = e.split("-");
    return this.formatLanguageCode(r[0]);
  }
  formatLanguageCode(e) {
    if (H(e) && e.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let s = Intl.getCanonicalLocales(e)[0];
          if (s && this.options.lowerCaseLng && (s = s.toLowerCase()), s)
            return s;
        } catch {
        }
      const r = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let n = e.split("-");
      return this.options.lowerCaseLng ? n = n.map((s) => s.toLowerCase()) : n.length === 2 ? (n[0] = n[0].toLowerCase(), n[1] = n[1].toUpperCase(), r.indexOf(n[1].toLowerCase()) > -1 && (n[1] = ts(n[1].toLowerCase()))) : n.length === 3 && (n[0] = n[0].toLowerCase(), n[1].length === 2 && (n[1] = n[1].toUpperCase()), n[0] !== "sgn" && n[2].length === 2 && (n[2] = n[2].toUpperCase()), r.indexOf(n[1].toLowerCase()) > -1 && (n[1] = ts(n[1].toLowerCase())), r.indexOf(n[2].toLowerCase()) > -1 && (n[2] = ts(n[2].toLowerCase()))), n.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e)
      return null;
    let r;
    return e.forEach((n) => {
      if (r)
        return;
      const s = this.formatLanguageCode(n);
      (!this.options.supportedLngs || this.isSupportedCode(s)) && (r = s);
    }), !r && this.options.supportedLngs && e.forEach((n) => {
      if (r)
        return;
      const s = this.getLanguagePartFromCode(n);
      if (this.isSupportedCode(s))
        return r = s;
      r = this.options.supportedLngs.find((i) => {
        if (i === s)
          return i;
        if (!(i.indexOf("-") < 0 && s.indexOf("-") < 0) && (i.indexOf("-") > 0 && s.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === s || i.indexOf(s) === 0 && s.length > 1))
          return i;
      });
    }), r || (r = this.getFallbackCodes(this.options.fallbackLng)[0]), r;
  }
  getFallbackCodes(e, r) {
    if (!e)
      return [];
    if (typeof e == "function" && (e = e(r)), H(e) && (e = [e]), Array.isArray(e))
      return e;
    if (!r)
      return e.default || [];
    let n = e[r];
    return n || (n = e[this.getScriptPartFromCode(r)]), n || (n = e[this.formatLanguageCode(r)]), n || (n = e[this.getLanguagePartFromCode(r)]), n || (n = e.default), n || [];
  }
  toResolveHierarchy(e, r) {
    const n = this.getFallbackCodes(r || this.options.fallbackLng || [], e), s = [], i = (a) => {
      a && (this.isSupportedCode(a) ? s.push(a) : this.logger.warn(`rejecting language code not found in supportedLngs: ${a}`));
    };
    return H(e) && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(e))) : H(e) && i(this.formatLanguageCode(e)), n.forEach((a) => {
      s.indexOf(a) < 0 && i(this.formatLanguageCode(a));
    }), s;
  }
}
let bu = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], vu = {
  1: (t) => +(t > 1),
  2: (t) => +(t != 1),
  3: (t) => 0,
  4: (t) => t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2,
  5: (t) => t == 0 ? 0 : t == 1 ? 1 : t == 2 ? 2 : t % 100 >= 3 && t % 100 <= 10 ? 3 : t % 100 >= 11 ? 4 : 5,
  6: (t) => t == 1 ? 0 : t >= 2 && t <= 4 ? 1 : 2,
  7: (t) => t == 1 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2,
  8: (t) => t == 1 ? 0 : t == 2 ? 1 : t != 8 && t != 11 ? 2 : 3,
  9: (t) => +(t >= 2),
  10: (t) => t == 1 ? 0 : t == 2 ? 1 : t < 7 ? 2 : t < 11 ? 3 : 4,
  11: (t) => t == 1 || t == 11 ? 0 : t == 2 || t == 12 ? 1 : t > 2 && t < 20 ? 2 : 3,
  12: (t) => +(t % 10 != 1 || t % 100 == 11),
  13: (t) => +(t !== 0),
  14: (t) => t == 1 ? 0 : t == 2 ? 1 : t == 3 ? 2 : 3,
  15: (t) => t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2,
  16: (t) => t % 10 == 1 && t % 100 != 11 ? 0 : t !== 0 ? 1 : 2,
  17: (t) => t == 1 || t % 10 == 1 && t % 100 != 11 ? 0 : 1,
  18: (t) => t == 0 ? 0 : t == 1 ? 1 : 2,
  19: (t) => t == 1 ? 0 : t == 0 || t % 100 > 1 && t % 100 < 11 ? 1 : t % 100 > 10 && t % 100 < 20 ? 2 : 3,
  20: (t) => t == 1 ? 0 : t == 0 || t % 100 > 0 && t % 100 < 20 ? 1 : 2,
  21: (t) => t % 100 == 1 ? 1 : t % 100 == 2 ? 2 : t % 100 == 3 || t % 100 == 4 ? 3 : 0,
  22: (t) => t == 1 ? 0 : t == 2 ? 1 : (t < 0 || t > 10) && t % 10 == 0 ? 2 : 3
};
const wu = ["v1", "v2", "v3"], xu = ["v4"], Bi = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Su = () => {
  const t = {};
  return bu.forEach((e) => {
    e.lngs.forEach((r) => {
      t[r] = {
        numbers: e.nr,
        plurals: vu[e.fc]
      };
    });
  }), t;
};
class Eu {
  constructor(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = e, this.options = r, this.logger = et.create("pluralResolver"), (!this.options.compatibilityJSON || xu.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = Su(), this.pluralRulesCache = {};
  }
  addRule(e, r) {
    this.rules[e] = r;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const n = On(e === "dev" ? "en" : e), s = r.ordinal ? "ordinal" : "cardinal", i = JSON.stringify({
        cleanedCode: n,
        type: s
      });
      if (i in this.pluralRulesCache)
        return this.pluralRulesCache[i];
      let a;
      try {
        a = new Intl.PluralRules(n, {
          type: s
        });
      } catch {
        if (!e.match(/-|_/))
          return;
        const l = this.languageUtils.getLanguagePartFromCode(e);
        a = this.getRule(l, r);
      }
      return this.pluralRulesCache[i] = a, a;
    }
    return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
  }
  needsPlural(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const n = this.getRule(e, r);
    return this.shouldUseIntlApi() ? n && n.resolvedOptions().pluralCategories.length > 1 : n && n.numbers.length > 1;
  }
  getPluralFormsOfKey(e, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(e, n).map((s) => `${r}${s}`);
  }
  getSuffixes(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const n = this.getRule(e, r);
    return n ? this.shouldUseIntlApi() ? n.resolvedOptions().pluralCategories.sort((s, i) => Bi[s] - Bi[i]).map((s) => `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${s}`) : n.numbers.map((s) => this.getSuffix(e, s, r)) : [];
  }
  getSuffix(e, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const s = this.getRule(e, n);
    return s ? this.shouldUseIntlApi() ? `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${s.select(r)}` : this.getSuffixRetroCompatible(s, r) : (this.logger.warn(`no plural rule found for: ${e}`), "");
  }
  getSuffixRetroCompatible(e, r) {
    const n = e.noAbs ? e.plurals(r) : e.plurals(Math.abs(r));
    let s = e.numbers[n];
    this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 && (s === 2 ? s = "plural" : s === 1 && (s = ""));
    const i = () => this.options.prepend && s.toString() ? this.options.prepend + s.toString() : s.toString();
    return this.options.compatibilityJSON === "v1" ? s === 1 ? "" : typeof s == "number" ? `_plural_${s.toString()}` : i() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 ? i() : this.options.prepend && n.toString() ? this.options.prepend + n.toString() : n.toString();
  }
  shouldUseIntlApi() {
    return !wu.includes(this.options.compatibilityJSON);
  }
}
const $i = function(t, e, r) {
  let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = uu(t, e, r);
  return !i && s && H(r) && (i = ys(t, r, n), i === void 0 && (i = ys(e, r, n))), i;
}, rs = (t) => t.replace(/\$/g, "$$$$");
class Cu {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = et.create("interpolator"), this.options = e, this.format = e.interpolation && e.interpolation.format || ((r) => r), this.init(e);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: r,
      escapeValue: n,
      useRawValueToEscape: s,
      prefix: i,
      prefixEscaped: a,
      suffix: o,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: h,
      nestingPrefixEscaped: m,
      nestingSuffix: f,
      nestingSuffixEscaped: y,
      nestingOptionsSeparator: p,
      maxReplaces: S,
      alwaysFormat: x
    } = e.interpolation;
    this.escape = r !== void 0 ? r : du, this.escapeValue = n !== void 0 ? n : !0, this.useRawValueToEscape = s !== void 0 ? s : !1, this.prefix = i ? Yt(i) : a || "{{", this.suffix = o ? Yt(o) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = h ? Yt(h) : m || Yt("$t("), this.nestingSuffix = f ? Yt(f) : y || Yt(")"), this.nestingOptionsSeparator = p || ",", this.maxReplaces = S || 1e3, this.alwaysFormat = x !== void 0 ? x : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (r, n) => r && r.source === n ? (r.lastIndex = 0, r) : new RegExp(n, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, r, n, s) {
    let i, a, o;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (m) => {
      if (m.indexOf(this.formatSeparator) < 0) {
        const S = $i(r, l, m, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(S, void 0, n, {
          ...s,
          ...r,
          interpolationkey: m
        }) : S;
      }
      const f = m.split(this.formatSeparator), y = f.shift().trim(), p = f.join(this.formatSeparator).trim();
      return this.format($i(r, l, y, this.options.keySeparator, this.options.ignoreJSONStructure), p, n, {
        ...s,
        ...r,
        interpolationkey: y
      });
    };
    this.resetRegExp();
    const u = s && s.missingInterpolationHandler || this.options.missingInterpolationHandler, d = s && s.interpolation && s.interpolation.skipOnVariables !== void 0 ? s.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (m) => rs(m)
    }, {
      regex: this.regexp,
      safeValue: (m) => this.escapeValue ? rs(this.escape(m)) : rs(m)
    }].forEach((m) => {
      for (o = 0; i = m.regex.exec(e); ) {
        const f = i[1].trim();
        if (a = c(f), a === void 0)
          if (typeof u == "function") {
            const p = u(e, i, s);
            a = H(p) ? p : "";
          } else if (s && Object.prototype.hasOwnProperty.call(s, f))
            a = "";
          else if (d) {
            a = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${f} for interpolating ${e}`), a = "";
        else
          !H(a) && !this.useRawValueToEscape && (a = Ai(a));
        const y = m.safeValue(a);
        if (e = e.replace(i[0], y), d ? (m.regex.lastIndex += a.length, m.regex.lastIndex -= i[0].length) : m.regex.lastIndex = 0, o++, o >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s, i, a;
    const o = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0)
        return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let h = `{${d[1]}`;
      l = d[0], h = this.interpolate(h, a);
      const m = h.match(/'/g), f = h.match(/"/g);
      (m && m.length % 2 === 0 && !f || f.length % 2 !== 0) && (h = h.replace(/'/g, '"'));
      try {
        a = JSON.parse(h), c && (a = {
          ...c,
          ...a
        });
      } catch (y) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, y), `${l}${u}${h}`;
      }
      return a.defaultValue && a.defaultValue.indexOf(this.prefix) > -1 && delete a.defaultValue, l;
    };
    for (; s = this.nestingRegexp.exec(e); ) {
      let l = [];
      a = {
        ...n
      }, a = a.replace && !H(a.replace) ? a.replace : a, a.applyPostProcessor = !1, delete a.defaultValue;
      let c = !1;
      if (s[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(s[1])) {
        const u = s[1].split(this.formatSeparator).map((d) => d.trim());
        s[1] = u.shift(), l = u, c = !0;
      }
      if (i = r(o.call(this, s[1].trim(), a), a), i && s[0] === e && !H(i))
        return i;
      H(i) || (i = Ai(i)), i || (this.logger.warn(`missed to resolve ${s[1]} for nesting ${e}`), i = ""), c && (i = l.reduce((u, d) => this.format(u, d, n.lng, {
        ...n,
        interpolationkey: s[1].trim()
      }), i.trim())), e = e.replace(s[0], i), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const Ou = (t) => {
  let e = t.toLowerCase().trim();
  const r = {};
  if (t.indexOf("(") > -1) {
    const n = t.split("(");
    e = n[0].toLowerCase().trim();
    const s = n[1].substring(0, n[1].length - 1);
    e === "currency" && s.indexOf(":") < 0 ? r.currency || (r.currency = s.trim()) : e === "relativetime" && s.indexOf(":") < 0 ? r.range || (r.range = s.trim()) : s.split(";").forEach((a) => {
      if (a) {
        const [o, ...l] = a.split(":"), c = l.join(":").trim().replace(/^'+|'+$/g, ""), u = o.trim();
        r[u] || (r[u] = c), c === "false" && (r[u] = !1), c === "true" && (r[u] = !0), isNaN(c) || (r[u] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: r
  };
}, Xt = (t) => {
  const e = {};
  return (r, n, s) => {
    let i = s;
    s && s.interpolationkey && s.formatParams && s.formatParams[s.interpolationkey] && s[s.interpolationkey] && (i = {
      ...i,
      [s.interpolationkey]: void 0
    });
    const a = n + JSON.stringify(i);
    let o = e[a];
    return o || (o = t(On(n), s), e[a] = o), o(r);
  };
};
class Ru {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = et.create("formatter"), this.options = e, this.formats = {
      number: Xt((r, n) => {
        const s = new Intl.NumberFormat(r, {
          ...n
        });
        return (i) => s.format(i);
      }),
      currency: Xt((r, n) => {
        const s = new Intl.NumberFormat(r, {
          ...n,
          style: "currency"
        });
        return (i) => s.format(i);
      }),
      datetime: Xt((r, n) => {
        const s = new Intl.DateTimeFormat(r, {
          ...n
        });
        return (i) => s.format(i);
      }),
      relativetime: Xt((r, n) => {
        const s = new Intl.RelativeTimeFormat(r, {
          ...n
        });
        return (i) => s.format(i, n.range || "day");
      }),
      list: Xt((r, n) => {
        const s = new Intl.ListFormat(r, {
          ...n
        });
        return (i) => s.format(i);
      })
    }, this.init(e);
  }
  init(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = r.interpolation.formatSeparator || ",";
  }
  add(e, r) {
    this.formats[e.toLowerCase().trim()] = r;
  }
  addCached(e, r) {
    this.formats[e.toLowerCase().trim()] = Xt(r);
  }
  format(e, r, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = r.split(this.formatSeparator);
    if (i.length > 1 && i[0].indexOf("(") > 1 && i[0].indexOf(")") < 0 && i.find((o) => o.indexOf(")") > -1)) {
      const o = i.findIndex((l) => l.indexOf(")") > -1);
      i[0] = [i[0], ...i.splice(1, o)].join(this.formatSeparator);
    }
    return i.reduce((o, l) => {
      const {
        formatName: c,
        formatOptions: u
      } = Ou(l);
      if (this.formats[c]) {
        let d = o;
        try {
          const h = s && s.formatParams && s.formatParams[s.interpolationkey] || {}, m = h.locale || h.lng || s.locale || s.lng || n;
          d = this.formats[c](o, m, {
            ...u,
            ...s,
            ...h
          });
        } catch (h) {
          this.logger.warn(h);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return o;
    }, e);
  }
}
const _u = (t, e) => {
  t.pending[e] !== void 0 && (delete t.pending[e], t.pendingCount--);
};
class Pu extends Mn {
  constructor(e, r, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = e, this.store = r, this.services = n, this.languageUtils = n.languageUtils, this.options = s, this.logger = et.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = s.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = s.maxRetries >= 0 ? s.maxRetries : 5, this.retryTimeout = s.retryTimeout >= 1 ? s.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(n, s.backend, s);
  }
  queueLoad(e, r, n, s) {
    const i = {}, a = {}, o = {}, l = {};
    return e.forEach((c) => {
      let u = !0;
      r.forEach((d) => {
        const h = `${c}|${d}`;
        !n.reload && this.store.hasResourceBundle(c, d) ? this.state[h] = 2 : this.state[h] < 0 || (this.state[h] === 1 ? a[h] === void 0 && (a[h] = !0) : (this.state[h] = 1, u = !1, a[h] === void 0 && (a[h] = !0), i[h] === void 0 && (i[h] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (o[c] = !0);
    }), (Object.keys(i).length || Object.keys(a).length) && this.queue.push({
      pending: a,
      pendingCount: Object.keys(a).length,
      loaded: {},
      errors: [],
      callback: s
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(a),
      toLoadLanguages: Object.keys(o),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(e, r, n) {
    const s = e.split("|"), i = s[0], a = s[1];
    r && this.emit("failedLoading", i, a, r), !r && n && this.store.addResourceBundle(i, a, n, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = r ? -1 : 2, r && n && (this.state[e] = 0);
    const o = {};
    this.queue.forEach((l) => {
      cu(l.loaded, [i], a), _u(l, e), r && l.errors.push(r), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        o[c] || (o[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          o[c][d] === void 0 && (o[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", o), this.queue = this.queue.filter((l) => !l.done);
  }
  read(e, r, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, a = arguments.length > 5 ? arguments[5] : void 0;
    if (!e.length)
      return a(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: r,
        fcName: n,
        tried: s,
        wait: i,
        callback: a
      });
      return;
    }
    this.readingCalls++;
    const o = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && s < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, r, n, s + 1, i * 2, a);
        }, i);
        return;
      }
      a(c, u);
    }, l = this.backend[n].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(e, r);
        c && typeof c.then == "function" ? c.then((u) => o(null, u)).catch(o) : o(null, c);
      } catch (c) {
        o(c);
      }
      return;
    }
    return l(e, r, o);
  }
  prepareLoading(e, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), s && s();
    H(e) && (e = this.languageUtils.toResolveHierarchy(e)), H(r) && (r = [r]);
    const i = this.queueLoad(e, r, n, s);
    if (!i.toLoad.length)
      return i.pending.length || s(), null;
    i.toLoad.forEach((a) => {
      this.loadOne(a);
    });
  }
  load(e, r, n) {
    this.prepareLoading(e, r, {}, n);
  }
  reload(e, r, n) {
    this.prepareLoading(e, r, {
      reload: !0
    }, n);
  }
  loadOne(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const n = e.split("|"), s = n[0], i = n[1];
    this.read(s, i, "read", void 0, void 0, (a, o) => {
      a && this.logger.warn(`${r}loading namespace ${i} for language ${s} failed`, a), !a && o && this.logger.log(`${r}loaded namespace ${i} for language ${s}`, o), this.loaded(e, a, o);
    });
  }
  saveMissing(e, r, n, s, i) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(r)) {
      this.logger.warn(`did not save key "${n}" as the namespace "${r}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(n == null || n === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...a,
          isUpdate: i
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(e, r, n, s, l) : u = c(e, r, n, s), u && typeof u.then == "function" ? u.then((d) => o(null, d)).catch(o) : o(null, u);
          } catch (u) {
            o(u);
          }
        else
          c(e, r, n, s, o, l);
      }
      !e || !e[0] || this.store.addResource(e[0], r, n, s);
    }
  }
}
const Hi = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (t) => {
    let e = {};
    if (typeof t[1] == "object" && (e = t[1]), H(t[1]) && (e.defaultValue = t[1]), H(t[2]) && (e.tDescription = t[2]), typeof t[2] == "object" || typeof t[3] == "object") {
      const r = t[3] || t[2];
      Object.keys(r).forEach((n) => {
        e[n] = r[n];
      });
    }
    return e;
  },
  interpolation: {
    escapeValue: !0,
    format: (t) => t,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), Wi = (t) => (H(t.ns) && (t.ns = [t.ns]), H(t.fallbackLng) && (t.fallbackLng = [t.fallbackLng]), H(t.fallbackNS) && (t.fallbackNS = [t.fallbackNS]), t.supportedLngs && t.supportedLngs.indexOf("cimode") < 0 && (t.supportedLngs = t.supportedLngs.concat(["cimode"])), t), yn = () => {
}, Tu = (t) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(t)).forEach((r) => {
    typeof t[r] == "function" && (t[r] = t[r].bind(t));
  });
};
class Br extends Mn {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = Wi(e), this.services = {}, this.logger = et, this.modules = {
      external: []
    }, Tu(this), r && !this.isInitialized && !e.isClone) {
      if (!this.options.initImmediate)
        return this.init(e, r), this;
      setTimeout(() => {
        this.init(e, r);
      }, 0);
    }
  }
  init() {
    var e = this;
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof r == "function" && (n = r, r = {}), !r.defaultNS && r.defaultNS !== !1 && r.ns && (H(r.ns) ? r.defaultNS = r.ns : r.ns.indexOf("translation") < 0 && (r.defaultNS = r.ns[0]));
    const s = Hi();
    this.options = {
      ...s,
      ...this.options,
      ...Wi(r)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...s.interpolation,
      ...this.options.interpolation
    }), r.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = r.keySeparator), r.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = r.nsSeparator);
    const i = (u) => u ? typeof u == "function" ? new u() : u : null;
    if (!this.options.isClone) {
      this.modules.logger ? et.init(i(this.modules.logger), this.options) : et.init(null, this.options);
      let u;
      this.modules.formatter ? u = this.modules.formatter : typeof Intl < "u" && (u = Ru);
      const d = new zi(this.options);
      this.store = new Li(this.options.resources, this.options);
      const h = this.services;
      h.logger = et, h.resourceStore = this.store, h.languageUtils = d, h.pluralResolver = new Eu(d, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), u && (!this.options.interpolation.format || this.options.interpolation.format === s.interpolation.format) && (h.formatter = i(u), h.formatter.init(h, this.options), this.options.interpolation.format = h.formatter.format.bind(h.formatter)), h.interpolator = new Cu(this.options), h.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, h.backendConnector = new Pu(i(this.modules.backend), h.resourceStore, h, this.options), h.backendConnector.on("*", function(m) {
        for (var f = arguments.length, y = new Array(f > 1 ? f - 1 : 0), p = 1; p < f; p++)
          y[p - 1] = arguments[p];
        e.emit(m, ...y);
      }), this.modules.languageDetector && (h.languageDetector = i(this.modules.languageDetector), h.languageDetector.init && h.languageDetector.init(h, this.options.detection, this.options)), this.modules.i18nFormat && (h.i18nFormat = i(this.modules.i18nFormat), h.i18nFormat.init && h.i18nFormat.init(this)), this.translator = new _n(this.services, this.options), this.translator.on("*", function(m) {
        for (var f = arguments.length, y = new Array(f > 1 ? f - 1 : 0), p = 1; p < f; p++)
          y[p - 1] = arguments[p];
        e.emit(m, ...y);
      }), this.modules.external.forEach((m) => {
        m.init && m.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, n || (n = yn), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const u = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      u.length > 0 && u[0] !== "dev" && (this.options.lng = u[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((u) => {
      this[u] = function() {
        return e.store[u](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((u) => {
      this[u] = function() {
        return e.store[u](...arguments), e;
      };
    });
    const l = Dr(), c = () => {
      const u = (d, h) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(h), n(d, h);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return u(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, u);
    };
    return this.options.resources || !this.options.initImmediate ? c() : setTimeout(c, 0), l;
  }
  loadResources(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : yn;
    const s = H(e) ? e : this.language;
    if (typeof e == "function" && (n = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (s && s.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return n();
      const i = [], a = (o) => {
        if (!o || o === "cimode")
          return;
        this.services.languageUtils.toResolveHierarchy(o).forEach((c) => {
          c !== "cimode" && i.indexOf(c) < 0 && i.push(c);
        });
      };
      s ? a(s) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => a(l)), this.options.preload && this.options.preload.forEach((o) => a(o)), this.services.backendConnector.load(i, this.options.ns, (o) => {
        !o && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), n(o);
      });
    } else
      n(null);
  }
  reloadResources(e, r, n) {
    const s = Dr();
    return typeof e == "function" && (n = e, e = void 0), typeof r == "function" && (n = r, r = void 0), e || (e = this.languages), r || (r = this.options.ns), n || (n = yn), this.services.backendConnector.reload(e, r, (i) => {
      s.resolve(), n(i);
    }), s;
  }
  use(e) {
    if (!e)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && ao.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1))
      for (let r = 0; r < this.languages.length; r++) {
        const n = this.languages[r];
        if (!(["cimode", "dev"].indexOf(n) > -1) && this.store.hasLanguageSomeTranslations(n)) {
          this.resolvedLanguage = n;
          break;
        }
      }
  }
  changeLanguage(e, r) {
    var n = this;
    this.isLanguageChangingTo = e;
    const s = Dr();
    this.emit("languageChanging", e);
    const i = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, a = (l, c) => {
      c ? (i(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, s.resolve(function() {
        return n.t(...arguments);
      }), r && r(l, function() {
        return n.t(...arguments);
      });
    }, o = (l) => {
      !e && !l && this.services.languageDetector && (l = []);
      const c = H(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      c && (this.language || i(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(c)), this.loadResources(c, (u) => {
        a(u, c);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? o(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(o) : this.services.languageDetector.detect(o) : o(e), s;
  }
  getFixedT(e, r, n) {
    var s = this;
    const i = function(a, o) {
      let l;
      if (typeof o != "object") {
        for (var c = arguments.length, u = new Array(c > 2 ? c - 2 : 0), d = 2; d < c; d++)
          u[d - 2] = arguments[d];
        l = s.options.overloadTranslationOptionHandler([a, o].concat(u));
      } else
        l = {
          ...o
        };
      l.lng = l.lng || i.lng, l.lngs = l.lngs || i.lngs, l.ns = l.ns || i.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || n || i.keyPrefix);
      const h = s.options.keySeparator || ".";
      let m;
      return l.keyPrefix && Array.isArray(a) ? m = a.map((f) => `${l.keyPrefix}${h}${f}`) : m = l.keyPrefix ? `${l.keyPrefix}${h}${a}` : a, s.t(m, l);
    };
    return H(e) ? i.lng = e : i.lngs = e, i.ns = r, i.keyPrefix = n, i;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const n = r.lng || this.resolvedLanguage || this.languages[0], s = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (n.toLowerCase() === "cimode")
      return !0;
    const a = (o, l) => {
      const c = this.services.backendConnector.state[`${o}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (r.precheck) {
      const o = r.precheck(this, a);
      if (o !== void 0)
        return o;
    }
    return !!(this.hasResourceBundle(n, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || a(n, e) && (!s || a(i, e)));
  }
  loadNamespaces(e, r) {
    const n = Dr();
    return this.options.ns ? (H(e) && (e = [e]), e.forEach((s) => {
      this.options.ns.indexOf(s) < 0 && this.options.ns.push(s);
    }), this.loadResources((s) => {
      n.resolve(), r && r(s);
    }), n) : (r && r(), Promise.resolve());
  }
  loadLanguages(e, r) {
    const n = Dr();
    H(e) && (e = [e]);
    const s = this.options.preload || [], i = e.filter((a) => s.indexOf(a) < 0 && this.services.languageUtils.isSupportedCode(a));
    return i.length ? (this.options.preload = s.concat(i), this.loadResources((a) => {
      n.resolve(), r && r(a);
    }), n) : (r && r(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !e)
      return "rtl";
    const r = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], n = this.services && this.services.languageUtils || new zi(Hi());
    return r.indexOf(n.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    return new Br(e, r);
  }
  cloneInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : yn;
    const n = e.forkResourceStore;
    n && delete e.forkResourceStore;
    const s = {
      ...this.options,
      ...e,
      isClone: !0
    }, i = new Br(s);
    return (e.debug !== void 0 || e.prefix !== void 0) && (i.logger = i.logger.clone(e)), ["store", "services", "language"].forEach((o) => {
      i[o] = this[o];
    }), i.services = {
      ...this.services
    }, i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, n && (i.store = new Li(this.store.data, s), i.services.resourceStore = i.store), i.translator = new _n(i.services, s), i.translator.on("*", function(o) {
      for (var l = arguments.length, c = new Array(l > 1 ? l - 1 : 0), u = 1; u < l; u++)
        c[u - 1] = arguments[u];
      i.emit(o, ...c);
    }), i.init(s, r), i.translator.options = s, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const ye = Br.createInstance();
ye.createInstance = Br.createInstance;
ye.createInstance;
ye.dir;
ye.init;
ye.loadResources;
ye.reloadResources;
ye.use;
ye.changeLanguage;
ye.getFixedT;
const Nu = ye.t;
ye.exists;
ye.setDefaultNamespace;
ye.hasLoadedNamespace;
ye.loadNamespaces;
ye.loadLanguages;
function $r(t) {
  "@babel/helpers - typeof";
  return $r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, $r(t);
}
function ju(t, e) {
  if ($r(t) != "object" || !t)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if ($r(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function oo(t) {
  var e = ju(t, "string");
  return $r(e) == "symbol" ? e : e + "";
}
function lo(t, e, r) {
  return (e = oo(e)) in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function Du(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Fu(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, oo(n.key), n);
  }
}
function Au(t, e, r) {
  return e && Fu(t.prototype, e), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
var ku = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Iu = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, Mu = function(e) {
  return Iu[e];
}, Lu = function(e) {
  return e.replace(ku, Mu);
};
function Vi(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function qi(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Vi(Object(r), !0).forEach(function(n) {
      lo(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Vi(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var bs = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Lu
}, co, Uu = Ga();
function zu() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  bs = qi(qi({}, bs), t);
}
function Bu() {
  return bs;
}
var $u = function() {
  function t() {
    Du(this, t), this.usedNamespaces = {};
  }
  return Au(t, [{
    key: "addUsedNamespaces",
    value: function(r) {
      var n = this;
      r.forEach(function(s) {
        n.usedNamespaces[s] || (n.usedNamespaces[s] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), t;
}();
function Hu(t) {
  co = t;
}
function Wu() {
  return co;
}
var Vu = {
  type: "3rdParty",
  init: function(e) {
    zu(e.options.react), Hu(e);
  }
};
function qu() {
  if (console && console.warn) {
    for (var t, e = arguments.length, r = new Array(e), n = 0; n < e; n++)
      r[n] = arguments[n];
    typeof r[0] == "string" && (r[0] = "react-i18next:: ".concat(r[0])), (t = console).warn.apply(t, r);
  }
}
var Ki = {};
function vs() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  typeof e[0] == "string" && Ki[e[0]] || (typeof e[0] == "string" && (Ki[e[0]] = /* @__PURE__ */ new Date()), qu.apply(void 0, e));
}
function Qi(t, e, r) {
  t.loadNamespaces(e, function() {
    if (t.isInitialized)
      r();
    else {
      var n = function s() {
        setTimeout(function() {
          t.off("initialized", s);
        }, 0), r();
      };
      t.on("initialized", n);
    }
  });
}
function Ku(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = e.languages[0], s = e.options ? e.options.fallbackLng : !1, i = e.languages[e.languages.length - 1];
  if (n.toLowerCase() === "cimode")
    return !0;
  var a = function(l, c) {
    var u = e.services.backendConnector.state["".concat(l, "|").concat(c)];
    return u === -1 || u === 2;
  };
  return r.bindI18n && r.bindI18n.indexOf("languageChanging") > -1 && e.services.backendConnector.backend && e.isLanguageChangingTo && !a(e.isLanguageChangingTo, t) ? !1 : !!(e.hasResourceBundle(n, t) || !e.services.backendConnector.backend || e.options.resources && !e.options.partialBundledLanguages || a(n, t) && (!s || a(i, t)));
}
function Qu(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (!e.languages || !e.languages.length)
    return vs("i18n.languages were undefined or empty", e.languages), !0;
  var n = e.options.ignoreJSONStructure !== void 0;
  return n ? e.hasLoadedNamespace(t, {
    precheck: function(i, a) {
      if (r.bindI18n && r.bindI18n.indexOf("languageChanging") > -1 && i.services.backendConnector.backend && i.isLanguageChangingTo && !a(i.isLanguageChangingTo, t))
        return !1;
    }
  }) : Ku(t, e, r);
}
function Yu(t) {
  if (Array.isArray(t))
    return t;
}
function Xu(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, s, i, a, o = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e !== 0)
        for (; !(l = (n = i.call(r)).done) && (o.push(n.value), o.length !== e); l = !0)
          ;
    } catch (u) {
      c = !0, s = u;
    } finally {
      try {
        if (!l && r.return != null && (a = r.return(), Object(a) !== a))
          return;
      } finally {
        if (c)
          throw s;
      }
    }
    return o;
  }
}
function Yi(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function Gu(t, e) {
  if (t) {
    if (typeof t == "string")
      return Yi(t, e);
    var r = {}.toString.call(t).slice(8, -1);
    return r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set" ? Array.from(t) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Yi(t, e) : void 0;
  }
}
function Ju() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Zu(t, e) {
  return Yu(t) || Xu(t, e) || Gu(t, e) || Ju();
}
function Xi(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ns(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Xi(Object(r), !0).forEach(function(n) {
      lo(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Xi(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var eh = function(e, r) {
  var n = Le();
  return We(function() {
    n.current = e;
  }, [e, r]), n.current;
};
function th(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e.i18n, n = Ql(Uu) || {}, s = n.i18n, i = n.defaultNS, a = r || s || Wu();
  if (a && !a.reportNamespaces && (a.reportNamespaces = new $u()), !a) {
    vs("You will need to pass in an i18next instance by using initReactI18next");
    var o = function(R) {
      return Array.isArray(R) ? R[R.length - 1] : R;
    }, l = [o, {}, !1];
    return l.t = o, l.i18n = {}, l.ready = !1, l;
  }
  a.options.react && a.options.react.wait !== void 0 && vs("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  var c = ns(ns(ns({}, Bu()), a.options.react), e), u = c.useSuspense, d = c.keyPrefix, h = t || i || a.options && a.options.defaultNS;
  h = typeof h == "string" ? [h] : h || ["translation"], a.reportNamespaces.addUsedNamespaces && a.reportNamespaces.addUsedNamespaces(h);
  var m = (a.isInitialized || a.initializedStoreOnce) && h.every(function(O) {
    return Qu(O, a, c);
  });
  function f() {
    return a.getFixedT(null, c.nsMode === "fallback" ? h : h[0], d);
  }
  var y = te(f), p = Zu(y, 2), S = p[0], x = p[1], C = h.join(), P = eh(C), j = Le(!0);
  We(function() {
    var O = c.bindI18n, R = c.bindI18nStore;
    j.current = !0, !m && !u && Qi(a, h, function() {
      j.current && x(f);
    }), m && P && P !== C && j.current && x(f);
    function N() {
      j.current && x(f);
    }
    return O && a && a.on(O, N), R && a && a.store.on(R, N), function() {
      j.current = !1, O && a && O.split(" ").forEach(function(k) {
        return a.off(k, N);
      }), R && a && R.split(" ").forEach(function(k) {
        return a.store.off(k, N);
      });
    };
  }, [a, C]);
  var w = Le(!0);
  We(function() {
    j.current && !w.current && x(f), w.current = !1;
  }, [a, d]);
  var _ = [S, a, m];
  if (_.t = S, _.i18n = a, _.ready = m, m || !m && !u)
    return _;
  throw new Promise(function(O) {
    Qi(a, h, function() {
      O();
    });
  });
}
const uo = {
  title: "File Manager",
  file_upload: {
    file_not_supported: "File type not supported",
    drop_files_here: "Drag and drop your files here, or click to browse",
    upload_files: "Upload files",
    uploaded_successfully: "Successfully uploaded",
    crop_file: "Crop image ",
    crop_and_select_file: "Crop and select an image",
    upload_and_select_file: "Upload and select"
  },
  cancelled: "Cancelled",
  error: "Error",
  something_went_wrong: "Something went wrong",
  confirm_action: "Confirm action",
  confirm: "Confirm",
  cancel: "Cancel",
  file_details: "File details",
  download: "Download",
  rename: "Rename",
  delete: "Delete",
  name: "Name",
  size: "Size",
  file_source: {
    editor: "Editor",
    community: "Community",
    block_preview: "Block preview",
    membership: "Membership",
    marketplace: "Marketplace",
    settings: "Settings",
    email: "Email",
    ckeditor: "CKEditor",
    blog_post: "Blog post",
    page_template: "Page template",
    page_template_preview: "Page template preview",
    blog_template_preview: "Blog template preview",
    email_template: "Email template",
    product: "Product",
    funnel_template_preview: "Funnel template preview",
    digital_store: "Digital store",
    digital_product_resource: "Digital product resource",
    file_manager: "File manager",
    calendar_host_avatar: "Calendar",
    text_editor: "Text editor",
    website_template: "Website template",
    white_label: "White Label"
  },
  file_type: {
    image: "Image",
    image_other: "Other image",
    video: "Video",
    audio: "Audio",
    font: "Font",
    document: "Document"
  },
  select: "Select",
  file_selector: {
    files_selected: "file selected",
    search_file: "Search file",
    rename_file: "Rename file",
    file_name: "File name",
    enter_new_file_name: "Enter a new file name",
    failed_rename_file: "Failed to rename file",
    failed_delete_file: "Failed to delete file",
    failed_download_file: "Failed to download file",
    file_deletion_confirmation_text: 'Are you sure you want to delete "{{file}}"?',
    choose_file: "Choose a file"
  },
  search: "Search",
  upload: "Upload",
  file: "File",
  select_type: "Select file type",
  select_source: "Select source",
  type: "Type",
  created_at: "Created at",
  processing_size: "Processing",
  preview: "Preview",
  image_cropper: {
    aspect_ratio: {
      need_to_crop: "Crop image before selecting",
      need_to_crop_note: "The image has a different aspect ratio. Please crop it to match the required one"
    }
  },
  errors: {
    payload_to_large_error_message: "The file size is too big",
    conflict_error_message: "Sorry, but someone else has already changed this entity. Please reload the page and try again!",
    fields_toast_message: "Some fields contain invalid data, scroll down to resolve the issue",
    internal_error_message: "Something went wrong. Please try again"
  },
  file_renamed_successfully: "Renamed successfully",
  file_deleted_successfully: "Deleted successfully"
}, ho = {
  file_manager: uo
}, rh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ho,
  file_manager: uo
}, Symbol.toStringTag, { value: "Module" })), Ln = ["common"], ri = Ln[0], nh = Object.values(ps), sh = {
  en: { common: ho }
}, ih = {
  supportedLngs: nh,
  load: "languageOnly",
  debug: !1,
  defaultNS: ri,
  react: { useSuspense: !1 },
  ns: Ln,
  fallbackLng: ps.ENGLISH,
  lng: ps.ENGLISH,
  interpolation: {
    escapeValue: !1
  },
  resources: sh,
  returnEmptyString: !1
};
ye.use(Vu).init(ih);
const ah = async (t) => {
  const e = await au(/* @__PURE__ */ Object.assign({ "./assets/translations/locales/ar/common.json": () => import("./common-DUMcuKJ9.mjs"), "./assets/translations/locales/bn/common.json": () => import("./common-Cf8cnWXR.mjs"), "./assets/translations/locales/cs/common.json": () => import("./common-L0rV3tWV.mjs"), "./assets/translations/locales/da/common.json": () => import("./common-D8NkktBw.mjs"), "./assets/translations/locales/de/common.json": () => import("./common-CEe2UHk9.mjs"), "./assets/translations/locales/el/common.json": () => import("./common-DMKwE51w.mjs"), "./assets/translations/locales/en/common.json": () => Promise.resolve().then(() => rh), "./assets/translations/locales/es/common.json": () => import("./common-ZgjHcTBK.mjs"), "./assets/translations/locales/fi/common.json": () => import("./common-nFhhyX73.mjs"), "./assets/translations/locales/fr/common.json": () => import("./common-0tPdgbQ1.mjs"), "./assets/translations/locales/he/common.json": () => import("./common-CDV5oKY1.mjs"), "./assets/translations/locales/hi/common.json": () => import("./common-LsLzJAcM.mjs"), "./assets/translations/locales/hu/common.json": () => import("./common-CqMlX4gU.mjs"), "./assets/translations/locales/id/common.json": () => import("./common-C2J_ZsIt.mjs"), "./assets/translations/locales/it/common.json": () => import("./common-Cd_KsYxg.mjs"), "./assets/translations/locales/ja/common.json": () => import("./common-fzCYHZ7A.mjs"), "./assets/translations/locales/ms/common.json": () => import("./common-Dlh2pv83.mjs"), "./assets/translations/locales/nl/common.json": () => import("./common-CxLTTXnx.mjs"), "./assets/translations/locales/no/common.json": () => import("./common-C9Mu05Z3.mjs"), "./assets/translations/locales/pl/common.json": () => import("./common-wxiuhqHs.mjs"), "./assets/translations/locales/pt/common.json": () => import("./common-BwjaBfEr.mjs"), "./assets/translations/locales/ro/common.json": () => import("./common-BDSz_939.mjs"), "./assets/translations/locales/ru/common.json": () => import("./common-DzMxRCSG.mjs"), "./assets/translations/locales/sk/common.json": () => import("./common-_Q38Ihnu.mjs"), "./assets/translations/locales/sl/common.json": () => import("./common-uW78h8oG.mjs"), "./assets/translations/locales/sq/common.json": () => import("./common-BaY1NKe6.mjs"), "./assets/translations/locales/sr/common.json": () => import("./common-BQo1AVZ-.mjs"), "./assets/translations/locales/sv/common.json": () => import("./common-BWiPyq1w.mjs"), "./assets/translations/locales/th/common.json": () => import("./common-DGej3E5E.mjs"), "./assets/translations/locales/tl/common.json": () => import("./common-B5GA4du1.mjs"), "./assets/translations/locales/tr/common.json": () => import("./common-DVuJuDmW.mjs"), "./assets/translations/locales/uk/common.json": () => import("./common-BDYb4Mj7.mjs"), "./assets/translations/locales/zh/common.json": () => import("./common-fPNr3qjR.mjs") }), `./assets/translations/locales/${t}/common.json`);
  return ye.addResourceBundle(t, ri, {
    file_manager: e.default.file_manager
  }), e;
}, fo = () => Ln, po = (t) => t.startsWith("core.error.") ? t.replace("core.error.", "file_manager.errors.") : t.replace(/^(global\.|core\.)/g, "file_manager."), mo = dc(Nu, fo, po), Pe = fc({
  useTranslation: th,
  defaultNamespaces: Ln,
  namespaceMapper: fo,
  assetKeyMapper: po
}), ni = gc;
pc();
const nr = mc({
  httpClient: ni,
  useLocoTranslation: Pe,
  useRouter: () => ({
    push: async (t) => (window.location.assign(t), !0),
    replace: async (t) => (window.location.replace(t), !0)
  })
});
function oh(t, e = 2, r) {
  if (t < 0)
    return (r == null ? void 0 : r.whenNegative) ?? mo("file_manager.processing_size");
  if (t === 0)
    return "0 Bytes";
  const n = 1024, s = e < 0 ? 0 : e, i = ["Bytes", "KB", "MB", "GB"], a = Math.floor(Math.log(t) / Math.log(n));
  return parseFloat((t / Math.pow(n, a)).toFixed(s)) + " " + i[a];
}
const lh = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg", "tiff", "ico", "avif"];
function ws(t) {
  var r;
  const e = (r = t.name.split(".").pop()) == null ? void 0 : r.toLowerCase();
  return t.type.startsWith("image/") || lh.includes(e ?? "-");
}
async function go(t) {
  return new Promise((e, r) => {
    const n = new Image();
    n.src = t, n.crossOrigin = "Anonymous", n.onload = () => {
      const s = n.width / n.height;
      e([n, s]);
    }, n.onerror = (s) => {
      r(new Error("Failed to load image"));
    };
  });
}
function yo(t, e, r = 0.02) {
  return Math.abs(t - e) < r;
}
function bo(t, e = 0.02) {
  const n = [
    { label: "(1:1)", value: 1 },
    { label: "(16:9)", value: 1.7777777777777777 },
    { label: "(21:9)", value: 2.3333333333333335 },
    { label: "(4:3)", value: 1.3333333333333333 },
    { label: "(1.43:1)", value: 1.43 },
    { label: "(32:9)", value: 3.5555555555555554 },
    { label: "(1.41:1)", value: 1.41 },
    { label: "(9:16)", value: 0.5625 },
    { label: "(19.5:9)", value: 2.1666666666666665 },
    { label: "(12:7)", value: 1.7142857142857142 }
  ].find((s) => Math.abs(t - s.value) < e);
  return n == null ? void 0 : n.label;
}
function ch(t, e = 0.02) {
  const r = bo(t, e);
  let n = mo("file_manager.image_cropper.aspect_ratio.need_to_crop");
  return r && (n += ` ${r}`), n;
}
function Gi(t, e) {
  if (!e || isNaN(e))
    return t;
  const r = bo(e);
  if (!r)
    return t;
  const n = r.replace(/[\s:]+/g, "_"), s = t.name.split(".").pop(), a = `${t.name.replace(/\.[^.]+$/, "")}_${n}.${s}`;
  return new File([t], a, {
    type: t.type,
    lastModified: t.lastModified
  });
}
function uh(t, e) {
  return {
    id: t.id,
    name: t.filename,
    filename: t.filename,
    path: t.path,
    thumbnail: t.thumbnail || null,
    source: e,
    size: t.size,
    type: t.type,
    createdAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}
async function hh(t, e, r = "image/png") {
  const n = new OffscreenCanvas(t.width, t.height), s = n.getContext("2d");
  if (!s)
    throw new Error("Canvas context is not available");
  s.drawImage(t, 0, 0);
  const i = await n.convertToBlob({ type: r });
  return new File([i], e, { type: r });
}
function Ji(t, e) {
  const r = Le(null);
  We(() => {
    r.current !== null && e(r.current, t), r.current = t;
  }, [t]);
}
function Zi(t, e) {
  return {
    added: e.filter((r) => !t.includes(r)),
    removed: t.filter((r) => !e.includes(r))
  };
}
async function dh(t) {
  const e = await t.arrayBuffer(), r = await crypto.subtle.digest("SHA-256", e);
  return Array.from(new Uint8Array(r)).map((i) => i.toString(16).padStart(2, "0")).join("");
}
function ea(t, e) {
  const s = `${t.name.replace(/\.[^.]+$/, "")}.png`;
  return new File([e], s, {
    type: "image/png",
    lastModified: t.lastModified
  });
}
const cm = {
  image: ["image/*"],
  csv: ["text/csv", "application/vnd.ms-excel", "application/csv", ".csv"]
}, ta = (t, e) => e.some((r) => {
  if (r.includes("*")) {
    const n = r.replace("*", ".*");
    return new RegExp(`^${n}$`).test(t);
  } else
    return t.toLowerCase() === r.toLowerCase();
}), fh = (t) => t.join(", ");
function um(t) {
  var l;
  const e = (l = t.split(".").pop()) == null ? void 0 : l.toLowerCase();
  if (!e)
    return ie.Document;
  const r = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"], n = ["tiff", "heic", "raw"], s = ["mp4", "mov", "avi", "mkv", "webm"], i = ["mp3", "wav", "ogg", "aac", "flac"], a = ["ttf", "otf", "woff", "woff2"], o = ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt", "csv"];
  return r.includes(e) ? ie.Image : n.includes(e) ? ie.ImageOther : s.includes(e) ? ie.Video : i.includes(e) ? ie.Audio : a.includes(e) ? ie.Font : (o.includes(e), ie.Document);
}
function ph({
  fileType: t,
  src: e,
  alt: r,
  name: n,
  size: s,
  className: i,
  onClose: a,
  showCloseButton: o = !0,
  isFetching: l
}) {
  const { t: c } = Pe();
  return l ? /* @__PURE__ */ v.jsxs("div", { className: ge("flex w-full flex-col items-end", i), children: [
    o && /* @__PURE__ */ v.jsx("button", { type: "button", onClick: a, className: "mb-5", children: /* @__PURE__ */ v.jsx(Ri, { width: 17, height: 17, className: "fill-text-primary cursor-pointer" }) }),
    /* @__PURE__ */ v.jsxs("div", { className: "flex w-full flex-col", children: [
      /* @__PURE__ */ v.jsx("div", { className: "bg-background-tertiary h-[300px] w-full animate-pulse rounded-md" }),
      /* @__PURE__ */ v.jsx("div", { className: "bg-background-tertiary mt-5 h-4 w-16 animate-pulse rounded-sm" }),
      /* @__PURE__ */ v.jsx("div", { className: "bg-background-tertiary mt-2 h-6 w-full animate-pulse rounded-sm" }),
      /* @__PURE__ */ v.jsx("div", { className: "bg-background-tertiary mt-2 h-4 w-16 animate-pulse rounded-sm" }),
      /* @__PURE__ */ v.jsx("div", { className: "bg-background-tertiary mt-2 h-6 w-full animate-pulse rounded-sm" })
    ] })
  ] }) : /* @__PURE__ */ v.jsxs("div", { className: ge("flex w-full flex-col items-end", i), children: [
    o && /* @__PURE__ */ v.jsx("button", { type: "button", onClick: a, className: "mb-5", children: /* @__PURE__ */ v.jsx(Ri, { width: 17, height: 17, className: "fill-text-primary cursor-pointer" }) }),
    /* @__PURE__ */ v.jsxs("div", { className: "flex w-full flex-col", children: [
      /* @__PURE__ */ v.jsx(zt, { src: e ?? "", fileType: t, alt: r }),
      n && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        /* @__PURE__ */ v.jsx(
          "div",
          {
            className: "text-text-secondary mt-5 overflow-clip truncate text-sm",
            style: { lineHeight: 1.1 },
            children: c("file_manager.name")
          }
        ),
        /* @__PURE__ */ v.jsx(
          "div",
          {
            className: "text-text-tertiary mt-2 truncate text-base font-semibold ",
            title: n,
            style: { lineHeight: 1.1 },
            children: n
          }
        )
      ] }),
      typeof s == "number" && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        /* @__PURE__ */ v.jsx(
          "div",
          {
            className: "text-text-secondary mt-[10px] overflow-clip truncate text-sm",
            style: { lineHeight: 1.1 },
            children: c("file_manager.size")
          }
        ),
        /* @__PURE__ */ v.jsx(
          "div",
          {
            className: "text-text-tertiary mt-2 text-base font-semibold",
            style: { lineHeight: 1.1 },
            children: oh(s)
          }
        )
      ] })
    ] })
  ] });
}
const vo = Ae.memo(({ file: t, className: e }) => t.type.startsWith("image/") ? /* @__PURE__ */ v.jsx(
  zt,
  {
    src: URL.createObjectURL(t),
    fileType: ie.Image,
    alt: t.name,
    className: e,
    isThumbnail: !0,
    title: t.name
  }
) : t.type === "application/pdf" ? /* @__PURE__ */ v.jsx(
  "div",
  {
    className: ge(
      "pointer-events-none flex select-none items-center justify-center overflow-hidden rounded-md",
      e
    ),
    title: t.name,
    children: /* @__PURE__ */ v.jsx(
      "embed",
      {
        src: URL.createObjectURL(t),
        type: t.type,
        className: "h-full w-full",
        style: { border: "none" }
      }
    )
  }
) : t.type.startsWith("video/") ? /* @__PURE__ */ v.jsx(
  zt,
  {
    src: URL.createObjectURL(t),
    fileType: ie.Video,
    alt: t.name,
    className: e,
    isThumbnail: !0,
    title: t.name
  }
) : /* @__PURE__ */ v.jsx(
  zt,
  {
    src: "",
    fileType: ie.Document,
    className: e,
    isThumbnail: !0,
    title: t.name
  }
));
vo.displayName = "FilePreviewFromOS";
function ra({
  opened: t,
  onClose: e,
  onConfirm: r,
  onDecline: n,
  title: s,
  confirmationText: i = "",
  className: a,
  cancelButtonCaption: o,
  confirmButtonCaption: l,
  buttonClassName: c,
  buttonTextClassName: u,
  confirmationContent: d,
  afterLeave: h
}) {
  const { t: m } = Pe(), [f, y] = te(""), [p, S] = te(!1), [x, C] = te(!1), P = async () => {
    try {
      S(!0), await r(), S(!1), C(!0);
    } catch {
      S(!1), y(m("file_manager.something_went_wrong"));
    }
  }, j = () => {
    y(""), C(!1);
  };
  return /* @__PURE__ */ v.jsx(
    kn,
    {
      opened: t,
      onClose: () => {
        !x && n && n(), e();
      },
      title: s || m("file_manager.confirm_action"),
      afterLeave: () => {
        h && h(), j();
      },
      isFetching: p,
      isCentered: !0,
      className: a,
      children: /* @__PURE__ */ v.jsxs("form", { className: "flex flex-col gap-6 lg:gap-10", children: [
        i && /* @__PURE__ */ v.jsx("div", { className: "flex justify-center", children: /* @__PURE__ */ v.jsx("p", { className: "text-text-primary text-base", children: i }) }),
        d,
        /* @__PURE__ */ v.jsxs("div", { className: "flex justify-center gap-4", children: [
          /* @__PURE__ */ v.jsx(
            an,
            {
              isFetching: p,
              className: ge("w-full", c),
              buttonTextClassName: u,
              width: "large",
              onClick: async (w) => {
                w.preventDefault(), await P();
              },
              type: "submit",
              children: l || m("file_manager.confirm")
            }
          ),
          /* @__PURE__ */ v.jsx(
            Ja,
            {
              className: ge("w-full", c),
              width: "large",
              buttonTextClassName: u,
              onClick: (w) => {
                w.preventDefault(), n && n(), e();
              },
              disabled: p,
              children: o || m("file_manager.cancel")
            }
          )
        ] }),
        /* @__PURE__ */ v.jsx(En, { error: f, errorClassName: "text-center" })
      ] })
    }
  );
}
function mh({ label: t, ...e }) {
  const { t: r } = Pe();
  return /* @__PURE__ */ v.jsx(
    In,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: t ?? /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-2 text-text-primary group-hover:text-brand-primary main-transition-colors", children: [
        /* @__PURE__ */ v.jsx(
          ec,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        r("file_manager.file_details")
      ] }),
      ...e,
      onClick: e.onClick,
      children: void 0
    }
  );
}
function gh({ label: t, ...e }) {
  const { t: r } = Pe();
  return /* @__PURE__ */ v.jsx(
    In,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: t ?? /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-2 text-text-primary group-hover:text-brand-primary main-transition-colors", children: [
        /* @__PURE__ */ v.jsx(
          tc,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        r("file_manager.delete")
      ] }),
      ...e,
      onClick: e.onClick,
      children: void 0
    }
  );
}
function yh({ label: t, ...e }) {
  const { t: r } = Pe();
  return /* @__PURE__ */ v.jsx(
    In,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: t ?? /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-2 text-text-primary group-hover:text-brand-primary main-transition-colors", children: [
        /* @__PURE__ */ v.jsx(
          rc,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        r("file_manager.rename")
      ] }),
      ...e,
      onClick: e.onClick,
      children: void 0
    }
  );
}
function bh({ label: t, ...e }) {
  const { t: r } = Pe();
  return /* @__PURE__ */ v.jsx(
    In,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: t ?? /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-2 text-text-primary group-hover:text-brand-primary main-transition-colors", children: [
        /* @__PURE__ */ v.jsx(
          nc,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        r("file_manager.download")
      ] }),
      ...e,
      onClick: e.onClick,
      children: void 0
    }
  );
}
var on = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(t) {
    return this.listeners.add(t), this.onSubscribe(), () => {
      this.listeners.delete(t), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, $t = typeof window > "u" || "Deno" in globalThis;
function He() {
}
function vh(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function xs(t) {
  return typeof t == "number" && t >= 0 && t !== 1 / 0;
}
function wo(t, e) {
  return Math.max(t + (e || 0) - Date.now(), 0);
}
function sr(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Ke(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function na(t, e) {
  const {
    type: r = "all",
    exact: n,
    fetchStatus: s,
    predicate: i,
    queryKey: a,
    stale: o
  } = t;
  if (a) {
    if (n) {
      if (e.queryHash !== si(a, e.options))
        return !1;
    } else if (!Wr(e.queryKey, a))
      return !1;
  }
  if (r !== "all") {
    const l = e.isActive();
    if (r === "active" && !l || r === "inactive" && l)
      return !1;
  }
  return !(typeof o == "boolean" && e.isStale() !== o || s && s !== e.state.fetchStatus || i && !i(e));
}
function sa(t, e) {
  const { exact: r, status: n, predicate: s, mutationKey: i } = t;
  if (i) {
    if (!e.options.mutationKey)
      return !1;
    if (r) {
      if (Hr(e.options.mutationKey) !== Hr(i))
        return !1;
    } else if (!Wr(e.options.mutationKey, i))
      return !1;
  }
  return !(n && e.state.status !== n || s && !s(e));
}
function si(t, e) {
  return ((e == null ? void 0 : e.queryKeyHashFn) || Hr)(t);
}
function Hr(t) {
  return JSON.stringify(
    t,
    (e, r) => Cs(r) ? Object.keys(r).sort().reduce((n, s) => (n[s] = r[s], n), {}) : r
  );
}
function Wr(t, e) {
  return t === e ? !0 : typeof t != typeof e ? !1 : t && e && typeof t == "object" && typeof e == "object" ? !Object.keys(e).some((r) => !Wr(t[r], e[r])) : !1;
}
function Ss(t, e) {
  if (t === e)
    return t;
  const r = ia(t) && ia(e);
  if (r || Cs(t) && Cs(e)) {
    const n = r ? t : Object.keys(t), s = n.length, i = r ? e : Object.keys(e), a = i.length, o = r ? [] : {};
    let l = 0;
    for (let c = 0; c < a; c++) {
      const u = r ? c : i[c];
      (!r && n.includes(u) || r) && t[u] === void 0 && e[u] === void 0 ? (o[u] = void 0, l++) : (o[u] = Ss(t[u], e[u]), o[u] === t[u] && t[u] !== void 0 && l++);
    }
    return s === a && l === s ? t : o;
  }
  return e;
}
function Es(t, e) {
  if (!e || Object.keys(t).length !== Object.keys(e).length)
    return !1;
  for (const r in t)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
function ia(t) {
  return Array.isArray(t) && t.length === Object.keys(t).length;
}
function Cs(t) {
  if (!aa(t))
    return !1;
  const e = t.constructor;
  if (e === void 0)
    return !0;
  const r = e.prototype;
  return !(!aa(r) || !r.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(t) !== Object.prototype);
}
function aa(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function wh(t) {
  return new Promise((e) => {
    setTimeout(e, t);
  });
}
function Os(t, e, r) {
  if (typeof r.structuralSharing == "function")
    return r.structuralSharing(t, e);
  if (r.structuralSharing !== !1) {
    if (process.env.NODE_ENV !== "production")
      try {
        return Ss(t, e);
      } catch (n) {
        console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${r.queryHash}]: ${n}`
        );
      }
    return Ss(t, e);
  }
  return e;
}
function xh(t, e, r = 0) {
  const n = [...t, e];
  return r && n.length > r ? n.slice(1) : n;
}
function Sh(t, e, r = 0) {
  const n = [e, ...t];
  return r && n.length > r ? n.slice(0, -1) : n;
}
var Pn = Symbol();
function xo(t, e) {
  return process.env.NODE_ENV !== "production" && t.queryFn === Pn && console.error(
    `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${t.queryHash}'`
  ), !t.queryFn && (e != null && e.initialPromise) ? () => e.initialPromise : !t.queryFn || t.queryFn === Pn ? () => Promise.reject(new Error(`Missing queryFn: '${t.queryHash}'`)) : t.queryFn;
}
var Dt, mt, or, $a, Eh = ($a = class extends on {
  constructor() {
    super();
    L(this, Dt, void 0);
    L(this, mt, void 0);
    L(this, or, void 0);
    I(this, or, (e) => {
      if (!$t && window.addEventListener) {
        const r = () => e();
        return window.addEventListener("visibilitychange", r, !1), () => {
          window.removeEventListener("visibilitychange", r);
        };
      }
    });
  }
  onSubscribe() {
    b(this, mt) || this.setEventListener(b(this, or));
  }
  onUnsubscribe() {
    var e;
    this.hasListeners() || ((e = b(this, mt)) == null || e.call(this), I(this, mt, void 0));
  }
  setEventListener(e) {
    var r;
    I(this, or, e), (r = b(this, mt)) == null || r.call(this), I(this, mt, e((n) => {
      typeof n == "boolean" ? this.setFocused(n) : this.onFocus();
    }));
  }
  setFocused(e) {
    b(this, Dt) !== e && (I(this, Dt, e), this.onFocus());
  }
  onFocus() {
    const e = this.isFocused();
    this.listeners.forEach((r) => {
      r(e);
    });
  }
  isFocused() {
    var e;
    return typeof b(this, Dt) == "boolean" ? b(this, Dt) : ((e = globalThis.document) == null ? void 0 : e.visibilityState) !== "hidden";
  }
}, Dt = new WeakMap(), mt = new WeakMap(), or = new WeakMap(), $a), ii = new Eh(), lr, gt, cr, Ha, Ch = (Ha = class extends on {
  constructor() {
    super();
    L(this, lr, !0);
    L(this, gt, void 0);
    L(this, cr, void 0);
    I(this, cr, (e) => {
      if (!$t && window.addEventListener) {
        const r = () => e(!0), n = () => e(!1);
        return window.addEventListener("online", r, !1), window.addEventListener("offline", n, !1), () => {
          window.removeEventListener("online", r), window.removeEventListener("offline", n);
        };
      }
    });
  }
  onSubscribe() {
    b(this, gt) || this.setEventListener(b(this, cr));
  }
  onUnsubscribe() {
    var e;
    this.hasListeners() || ((e = b(this, gt)) == null || e.call(this), I(this, gt, void 0));
  }
  setEventListener(e) {
    var r;
    I(this, cr, e), (r = b(this, gt)) == null || r.call(this), I(this, gt, e(this.setOnline.bind(this)));
  }
  setOnline(e) {
    b(this, lr) !== e && (I(this, lr, e), this.listeners.forEach((n) => {
      n(e);
    }));
  }
  isOnline() {
    return b(this, lr);
  }
}, lr = new WeakMap(), gt = new WeakMap(), cr = new WeakMap(), Ha), Tn = new Ch();
function Rs() {
  let t, e;
  const r = new Promise((s, i) => {
    t = s, e = i;
  });
  r.status = "pending", r.catch(() => {
  });
  function n(s) {
    Object.assign(r, s), delete r.resolve, delete r.reject;
  }
  return r.resolve = (s) => {
    n({
      status: "fulfilled",
      value: s
    }), t(s);
  }, r.reject = (s) => {
    n({
      status: "rejected",
      reason: s
    }), e(s);
  }, r;
}
function Oh(t) {
  return Math.min(1e3 * 2 ** t, 3e4);
}
function So(t) {
  return (t ?? "online") === "online" ? Tn.isOnline() : !0;
}
var Eo = class extends Error {
  constructor(t) {
    super("CancelledError"), this.revert = t == null ? void 0 : t.revert, this.silent = t == null ? void 0 : t.silent;
  }
};
function ss(t) {
  return t instanceof Eo;
}
function Co(t) {
  let e = !1, r = 0, n = !1, s;
  const i = Rs(), a = (y) => {
    var p;
    n || (h(new Eo(y)), (p = t.abort) == null || p.call(t));
  }, o = () => {
    e = !0;
  }, l = () => {
    e = !1;
  }, c = () => ii.isFocused() && (t.networkMode === "always" || Tn.isOnline()) && t.canRun(), u = () => So(t.networkMode) && t.canRun(), d = (y) => {
    var p;
    n || (n = !0, (p = t.onSuccess) == null || p.call(t, y), s == null || s(), i.resolve(y));
  }, h = (y) => {
    var p;
    n || (n = !0, (p = t.onError) == null || p.call(t, y), s == null || s(), i.reject(y));
  }, m = () => new Promise((y) => {
    var p;
    s = (S) => {
      (n || c()) && y(S);
    }, (p = t.onPause) == null || p.call(t);
  }).then(() => {
    var y;
    s = void 0, n || (y = t.onContinue) == null || y.call(t);
  }), f = () => {
    if (n)
      return;
    let y;
    const p = r === 0 ? t.initialPromise : void 0;
    try {
      y = p ?? t.fn();
    } catch (S) {
      y = Promise.reject(S);
    }
    Promise.resolve(y).then(d).catch((S) => {
      var w;
      if (n)
        return;
      const x = t.retry ?? ($t ? 0 : 3), C = t.retryDelay ?? Oh, P = typeof C == "function" ? C(r, S) : C, j = x === !0 || typeof x == "number" && r < x || typeof x == "function" && x(r, S);
      if (e || !j) {
        h(S);
        return;
      }
      r++, (w = t.onFail) == null || w.call(t, r, S), wh(P).then(() => c() ? void 0 : m()).then(() => {
        e ? h(S) : f();
      });
    });
  };
  return {
    promise: i,
    cancel: a,
    continue: () => (s == null || s(), i),
    cancelRetry: o,
    continueRetry: l,
    canStart: u,
    start: () => (u() ? f() : m().then(f), i)
  };
}
function Rh() {
  let t = [], e = 0, r = (o) => {
    o();
  }, n = (o) => {
    o();
  }, s = (o) => setTimeout(o, 0);
  const i = (o) => {
    e ? t.push(o) : s(() => {
      r(o);
    });
  }, a = () => {
    const o = t;
    t = [], o.length && s(() => {
      n(() => {
        o.forEach((l) => {
          r(l);
        });
      });
    });
  };
  return {
    batch: (o) => {
      let l;
      e++;
      try {
        l = o();
      } finally {
        e--, e || a();
      }
      return l;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (o) => (...l) => {
      i(() => {
        o(...l);
      });
    },
    schedule: i,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (o) => {
      r = o;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (o) => {
      n = o;
    },
    setScheduler: (o) => {
      s = o;
    }
  };
}
var xe = Rh(), Ft, Wa, Oo = (Wa = class {
  constructor() {
    L(this, Ft, void 0);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), xs(this.gcTime) && I(this, Ft, setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(t) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      t ?? ($t ? 1 / 0 : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    b(this, Ft) && (clearTimeout(b(this, Ft)), I(this, Ft, void 0));
  }
}, Ft = new WeakMap(), Wa), ur, hr, $e, Ee, Qr, At, qe, at, Va, _h = (Va = class extends Oo {
  constructor(e) {
    super();
    L(this, qe);
    L(this, ur, void 0);
    L(this, hr, void 0);
    L(this, $e, void 0);
    L(this, Ee, void 0);
    L(this, Qr, void 0);
    L(this, At, void 0);
    I(this, At, !1), I(this, Qr, e.defaultOptions), this.setOptions(e.options), this.observers = [], I(this, $e, e.cache), this.queryKey = e.queryKey, this.queryHash = e.queryHash, I(this, ur, Ph(this.options)), this.state = e.state ?? b(this, ur), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    var e;
    return (e = b(this, Ee)) == null ? void 0 : e.promise;
  }
  setOptions(e) {
    this.options = { ...b(this, Qr), ...e }, this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && b(this, $e).remove(this);
  }
  setData(e, r) {
    const n = Os(this.state.data, e, this.options);
    return G(this, qe, at).call(this, {
      data: n,
      type: "success",
      dataUpdatedAt: r == null ? void 0 : r.updatedAt,
      manual: r == null ? void 0 : r.manual
    }), n;
  }
  setState(e, r) {
    G(this, qe, at).call(this, { type: "setState", state: e, setStateOptions: r });
  }
  cancel(e) {
    var n, s;
    const r = (n = b(this, Ee)) == null ? void 0 : n.promise;
    return (s = b(this, Ee)) == null || s.cancel(e), r ? r.then(He).catch(He) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(b(this, ur));
  }
  isActive() {
    return this.observers.some(
      (e) => Ke(e.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === Pn || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
  }
  isStale() {
    return this.state.isInvalidated ? !0 : this.getObserversCount() > 0 ? this.observers.some(
      (e) => e.getCurrentResult().isStale
    ) : this.state.data === void 0;
  }
  isStaleByTime(e = 0) {
    return this.state.isInvalidated || this.state.data === void 0 || !wo(this.state.dataUpdatedAt, e);
  }
  onFocus() {
    var r;
    const e = this.observers.find((n) => n.shouldFetchOnWindowFocus());
    e == null || e.refetch({ cancelRefetch: !1 }), (r = b(this, Ee)) == null || r.continue();
  }
  onOnline() {
    var r;
    const e = this.observers.find((n) => n.shouldFetchOnReconnect());
    e == null || e.refetch({ cancelRefetch: !1 }), (r = b(this, Ee)) == null || r.continue();
  }
  addObserver(e) {
    this.observers.includes(e) || (this.observers.push(e), this.clearGcTimeout(), b(this, $e).notify({ type: "observerAdded", query: this, observer: e }));
  }
  removeObserver(e) {
    this.observers.includes(e) && (this.observers = this.observers.filter((r) => r !== e), this.observers.length || (b(this, Ee) && (b(this, At) ? b(this, Ee).cancel({ revert: !0 }) : b(this, Ee).cancelRetry()), this.scheduleGc()), b(this, $e).notify({ type: "observerRemoved", query: this, observer: e }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || G(this, qe, at).call(this, { type: "invalidate" });
  }
  fetch(e, r) {
    var l, c, u;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && (r != null && r.cancelRefetch))
        this.cancel({ silent: !0 });
      else if (b(this, Ee))
        return b(this, Ee).continueRetry(), b(this, Ee).promise;
    }
    if (e && this.setOptions(e), !this.options.queryFn) {
      const d = this.observers.find((h) => h.options.queryFn);
      d && this.setOptions(d.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const n = new AbortController(), s = (d) => {
      Object.defineProperty(d, "signal", {
        enumerable: !0,
        get: () => (I(this, At, !0), n.signal)
      });
    }, i = () => {
      const d = xo(this.options, r), h = {
        queryKey: this.queryKey,
        meta: this.meta
      };
      return s(h), I(this, At, !1), this.options.persister ? this.options.persister(
        d,
        h,
        this
      ) : d(h);
    }, a = {
      fetchOptions: r,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: i
    };
    s(a), (l = this.options.behavior) == null || l.onFetch(
      a,
      this
    ), I(this, hr, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((c = a.fetchOptions) == null ? void 0 : c.meta)) && G(this, qe, at).call(this, { type: "fetch", meta: (u = a.fetchOptions) == null ? void 0 : u.meta });
    const o = (d) => {
      var h, m, f, y;
      ss(d) && d.silent || G(this, qe, at).call(this, {
        type: "error",
        error: d
      }), ss(d) || ((m = (h = b(this, $e).config).onError) == null || m.call(
        h,
        d,
        this
      ), (y = (f = b(this, $e).config).onSettled) == null || y.call(
        f,
        this.state.data,
        d,
        this
      )), this.scheduleGc();
    };
    return I(this, Ee, Co({
      initialPromise: r == null ? void 0 : r.initialPromise,
      fn: a.fetchFn,
      abort: n.abort.bind(n),
      onSuccess: (d) => {
        var h, m, f, y;
        if (d === void 0) {
          process.env.NODE_ENV !== "production" && console.error(
            `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
          ), o(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        try {
          this.setData(d);
        } catch (p) {
          o(p);
          return;
        }
        (m = (h = b(this, $e).config).onSuccess) == null || m.call(h, d, this), (y = (f = b(this, $e).config).onSettled) == null || y.call(
          f,
          d,
          this.state.error,
          this
        ), this.scheduleGc();
      },
      onError: o,
      onFail: (d, h) => {
        G(this, qe, at).call(this, { type: "failed", failureCount: d, error: h });
      },
      onPause: () => {
        G(this, qe, at).call(this, { type: "pause" });
      },
      onContinue: () => {
        G(this, qe, at).call(this, { type: "continue" });
      },
      retry: a.options.retry,
      retryDelay: a.options.retryDelay,
      networkMode: a.options.networkMode,
      canRun: () => !0
    })), b(this, Ee).start();
  }
}, ur = new WeakMap(), hr = new WeakMap(), $e = new WeakMap(), Ee = new WeakMap(), Qr = new WeakMap(), At = new WeakMap(), qe = new WeakSet(), at = function(e) {
  const r = (n) => {
    switch (e.type) {
      case "failed":
        return {
          ...n,
          fetchFailureCount: e.failureCount,
          fetchFailureReason: e.error
        };
      case "pause":
        return {
          ...n,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...n,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...n,
          ...Ro(n.data, this.options),
          fetchMeta: e.meta ?? null
        };
      case "success":
        return {
          ...n,
          data: e.data,
          dataUpdateCount: n.dataUpdateCount + 1,
          dataUpdatedAt: e.dataUpdatedAt ?? Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success",
          ...!e.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
      case "error":
        const s = e.error;
        return ss(s) && s.revert && b(this, hr) ? { ...b(this, hr), fetchStatus: "idle" } : {
          ...n,
          error: s,
          errorUpdateCount: n.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: n.fetchFailureCount + 1,
          fetchFailureReason: s,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...n,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...n,
          ...e.state
        };
    }
  };
  this.state = r(this.state), xe.batch(() => {
    this.observers.forEach((n) => {
      n.onQueryUpdate();
    }), b(this, $e).notify({ query: this, type: "updated", action: e });
  });
}, Va);
function Ro(t, e) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: So(e.networkMode) ? "fetching" : "paused",
    ...t === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function Ph(t) {
  const e = typeof t.initialData == "function" ? t.initialData() : t.initialData, r = e !== void 0, n = r ? typeof t.initialDataUpdatedAt == "function" ? t.initialDataUpdatedAt() : t.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: r ? n ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: r ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var Xe, qa, Th = (qa = class extends on {
  constructor(e = {}) {
    super();
    L(this, Xe, void 0);
    this.config = e, I(this, Xe, /* @__PURE__ */ new Map());
  }
  build(e, r, n) {
    const s = r.queryKey, i = r.queryHash ?? si(s, r);
    let a = this.get(i);
    return a || (a = new _h({
      cache: this,
      queryKey: s,
      queryHash: i,
      options: e.defaultQueryOptions(r),
      state: n,
      defaultOptions: e.getQueryDefaults(s)
    }), this.add(a)), a;
  }
  add(e) {
    b(this, Xe).has(e.queryHash) || (b(this, Xe).set(e.queryHash, e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const r = b(this, Xe).get(e.queryHash);
    r && (e.destroy(), r === e && b(this, Xe).delete(e.queryHash), this.notify({ type: "removed", query: e }));
  }
  clear() {
    xe.batch(() => {
      this.getAll().forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return b(this, Xe).get(e);
  }
  getAll() {
    return [...b(this, Xe).values()];
  }
  find(e) {
    const r = { exact: !0, ...e };
    return this.getAll().find(
      (n) => na(r, n)
    );
  }
  findAll(e = {}) {
    const r = this.getAll();
    return Object.keys(e).length > 0 ? r.filter((n) => na(e, n)) : r;
  }
  notify(e) {
    xe.batch(() => {
      this.listeners.forEach((r) => {
        r(e);
      });
    });
  }
  onFocus() {
    xe.batch(() => {
      this.getAll().forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    xe.batch(() => {
      this.getAll().forEach((e) => {
        e.onOnline();
      });
    });
  }
}, Xe = new WeakMap(), qa), Ge, Re, kt, Je, pt, Ka, Nh = (Ka = class extends Oo {
  constructor(e) {
    super();
    L(this, Je);
    L(this, Ge, void 0);
    L(this, Re, void 0);
    L(this, kt, void 0);
    this.mutationId = e.mutationId, I(this, Re, e.mutationCache), I(this, Ge, []), this.state = e.state || jh(), this.setOptions(e.options), this.scheduleGc();
  }
  setOptions(e) {
    this.options = e, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(e) {
    b(this, Ge).includes(e) || (b(this, Ge).push(e), this.clearGcTimeout(), b(this, Re).notify({
      type: "observerAdded",
      mutation: this,
      observer: e
    }));
  }
  removeObserver(e) {
    I(this, Ge, b(this, Ge).filter((r) => r !== e)), this.scheduleGc(), b(this, Re).notify({
      type: "observerRemoved",
      mutation: this,
      observer: e
    });
  }
  optionalRemove() {
    b(this, Ge).length || (this.state.status === "pending" ? this.scheduleGc() : b(this, Re).remove(this));
  }
  continue() {
    var e;
    return ((e = b(this, kt)) == null ? void 0 : e.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(e) {
    var s, i, a, o, l, c, u, d, h, m, f, y, p, S, x, C, P, j, w, _;
    I(this, kt, Co({
      fn: () => this.options.mutationFn ? this.options.mutationFn(e) : Promise.reject(new Error("No mutationFn found")),
      onFail: (O, R) => {
        G(this, Je, pt).call(this, { type: "failed", failureCount: O, error: R });
      },
      onPause: () => {
        G(this, Je, pt).call(this, { type: "pause" });
      },
      onContinue: () => {
        G(this, Je, pt).call(this, { type: "continue" });
      },
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => b(this, Re).canRun(this)
    }));
    const r = this.state.status === "pending", n = !b(this, kt).canStart();
    try {
      if (!r) {
        G(this, Je, pt).call(this, { type: "pending", variables: e, isPaused: n }), await ((i = (s = b(this, Re).config).onMutate) == null ? void 0 : i.call(
          s,
          e,
          this
        ));
        const R = await ((o = (a = this.options).onMutate) == null ? void 0 : o.call(a, e));
        R !== this.state.context && G(this, Je, pt).call(this, {
          type: "pending",
          context: R,
          variables: e,
          isPaused: n
        });
      }
      const O = await b(this, kt).start();
      return await ((c = (l = b(this, Re).config).onSuccess) == null ? void 0 : c.call(
        l,
        O,
        e,
        this.state.context,
        this
      )), await ((d = (u = this.options).onSuccess) == null ? void 0 : d.call(u, O, e, this.state.context)), await ((m = (h = b(this, Re).config).onSettled) == null ? void 0 : m.call(
        h,
        O,
        null,
        this.state.variables,
        this.state.context,
        this
      )), await ((y = (f = this.options).onSettled) == null ? void 0 : y.call(f, O, null, e, this.state.context)), G(this, Je, pt).call(this, { type: "success", data: O }), O;
    } catch (O) {
      try {
        throw await ((S = (p = b(this, Re).config).onError) == null ? void 0 : S.call(
          p,
          O,
          e,
          this.state.context,
          this
        )), await ((C = (x = this.options).onError) == null ? void 0 : C.call(
          x,
          O,
          e,
          this.state.context
        )), await ((j = (P = b(this, Re).config).onSettled) == null ? void 0 : j.call(
          P,
          void 0,
          O,
          this.state.variables,
          this.state.context,
          this
        )), await ((_ = (w = this.options).onSettled) == null ? void 0 : _.call(
          w,
          void 0,
          O,
          e,
          this.state.context
        )), O;
      } finally {
        G(this, Je, pt).call(this, { type: "error", error: O });
      }
    } finally {
      b(this, Re).runNext(this);
    }
  }
}, Ge = new WeakMap(), Re = new WeakMap(), kt = new WeakMap(), Je = new WeakSet(), pt = function(e) {
  const r = (n) => {
    switch (e.type) {
      case "failed":
        return {
          ...n,
          failureCount: e.failureCount,
          failureReason: e.error
        };
      case "pause":
        return {
          ...n,
          isPaused: !0
        };
      case "continue":
        return {
          ...n,
          isPaused: !1
        };
      case "pending":
        return {
          ...n,
          context: e.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: e.isPaused,
          status: "pending",
          variables: e.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...n,
          data: e.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        };
      case "error":
        return {
          ...n,
          data: void 0,
          error: e.error,
          failureCount: n.failureCount + 1,
          failureReason: e.error,
          isPaused: !1,
          status: "error"
        };
    }
  };
  this.state = r(this.state), xe.batch(() => {
    b(this, Ge).forEach((n) => {
      n.onMutationUpdate(e);
    }), b(this, Re).notify({
      mutation: this,
      type: "updated",
      action: e
    });
  });
}, Ka);
function jh() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var Ie, Yr, Qa, Dh = (Qa = class extends on {
  constructor(e = {}) {
    super();
    L(this, Ie, void 0);
    L(this, Yr, void 0);
    this.config = e, I(this, Ie, /* @__PURE__ */ new Map()), I(this, Yr, Date.now());
  }
  build(e, r, n) {
    const s = new Nh({
      mutationCache: this,
      mutationId: ++gn(this, Yr)._,
      options: e.defaultMutationOptions(r),
      state: n
    });
    return this.add(s), s;
  }
  add(e) {
    const r = bn(e), n = b(this, Ie).get(r) ?? [];
    n.push(e), b(this, Ie).set(r, n), this.notify({ type: "added", mutation: e });
  }
  remove(e) {
    var n;
    const r = bn(e);
    if (b(this, Ie).has(r)) {
      const s = (n = b(this, Ie).get(r)) == null ? void 0 : n.filter((i) => i !== e);
      s && (s.length === 0 ? b(this, Ie).delete(r) : b(this, Ie).set(r, s));
    }
    this.notify({ type: "removed", mutation: e });
  }
  canRun(e) {
    var n;
    const r = (n = b(this, Ie).get(bn(e))) == null ? void 0 : n.find((s) => s.state.status === "pending");
    return !r || r === e;
  }
  runNext(e) {
    var n;
    const r = (n = b(this, Ie).get(bn(e))) == null ? void 0 : n.find((s) => s !== e && s.state.isPaused);
    return (r == null ? void 0 : r.continue()) ?? Promise.resolve();
  }
  clear() {
    xe.batch(() => {
      this.getAll().forEach((e) => {
        this.remove(e);
      });
    });
  }
  getAll() {
    return [...b(this, Ie).values()].flat();
  }
  find(e) {
    const r = { exact: !0, ...e };
    return this.getAll().find(
      (n) => sa(r, n)
    );
  }
  findAll(e = {}) {
    return this.getAll().filter((r) => sa(e, r));
  }
  notify(e) {
    xe.batch(() => {
      this.listeners.forEach((r) => {
        r(e);
      });
    });
  }
  resumePausedMutations() {
    const e = this.getAll().filter((r) => r.state.isPaused);
    return xe.batch(
      () => Promise.all(
        e.map((r) => r.continue().catch(He))
      )
    );
  }
}, Ie = new WeakMap(), Yr = new WeakMap(), Qa);
function bn(t) {
  var e;
  return ((e = t.options.scope) == null ? void 0 : e.id) ?? String(t.mutationId);
}
function Nn(t) {
  return {
    onFetch: (e, r) => {
      var u, d, h, m, f;
      const n = e.options, s = (h = (d = (u = e.fetchOptions) == null ? void 0 : u.meta) == null ? void 0 : d.fetchMore) == null ? void 0 : h.direction, i = ((m = e.state.data) == null ? void 0 : m.pages) || [], a = ((f = e.state.data) == null ? void 0 : f.pageParams) || [];
      let o = { pages: [], pageParams: [] }, l = 0;
      const c = async () => {
        let y = !1;
        const p = (C) => {
          Object.defineProperty(C, "signal", {
            enumerable: !0,
            get: () => (e.signal.aborted ? y = !0 : e.signal.addEventListener("abort", () => {
              y = !0;
            }), e.signal)
          });
        }, S = xo(e.options, e.fetchOptions), x = async (C, P, j) => {
          if (y)
            return Promise.reject();
          if (P == null && C.pages.length)
            return Promise.resolve(C);
          const w = {
            queryKey: e.queryKey,
            pageParam: P,
            direction: j ? "backward" : "forward",
            meta: e.options.meta
          };
          p(w);
          const _ = await S(
            w
          ), { maxPages: O } = e.options, R = j ? Sh : xh;
          return {
            pages: R(C.pages, _, O),
            pageParams: R(C.pageParams, P, O)
          };
        };
        if (s && i.length) {
          const C = s === "backward", P = C ? _o : _s, j = {
            pages: i,
            pageParams: a
          }, w = P(n, j);
          o = await x(j, w, C);
        } else {
          const C = t ?? i.length;
          do {
            const P = l === 0 ? a[0] ?? n.initialPageParam : _s(n, o);
            if (l > 0 && P == null)
              break;
            o = await x(o, P), l++;
          } while (l < C);
        }
        return o;
      };
      e.options.persister ? e.fetchFn = () => {
        var y, p;
        return (p = (y = e.options).persister) == null ? void 0 : p.call(
          y,
          c,
          {
            queryKey: e.queryKey,
            meta: e.options.meta,
            signal: e.signal
          },
          r
        );
      } : e.fetchFn = c;
    }
  };
}
function _s(t, { pages: e, pageParams: r }) {
  const n = e.length - 1;
  return e.length > 0 ? t.getNextPageParam(
    e[n],
    e,
    r[n],
    r
  ) : void 0;
}
function _o(t, { pages: e, pageParams: r }) {
  var n;
  return e.length > 0 ? (n = t.getPreviousPageParam) == null ? void 0 : n.call(t, e[0], e, r[0], r) : void 0;
}
function Fh(t, e) {
  return e ? _s(t, e) != null : !1;
}
function Ah(t, e) {
  return !e || !t.getPreviousPageParam ? !1 : _o(t, e) != null;
}
var fe, yt, bt, dr, fr, vt, pr, mr, Ya, kh = (Ya = class {
  constructor(t = {}) {
    L(this, fe, void 0);
    L(this, yt, void 0);
    L(this, bt, void 0);
    L(this, dr, void 0);
    L(this, fr, void 0);
    L(this, vt, void 0);
    L(this, pr, void 0);
    L(this, mr, void 0);
    I(this, fe, t.queryCache || new Th()), I(this, yt, t.mutationCache || new Dh()), I(this, bt, t.defaultOptions || {}), I(this, dr, /* @__PURE__ */ new Map()), I(this, fr, /* @__PURE__ */ new Map()), I(this, vt, 0);
  }
  mount() {
    gn(this, vt)._++, b(this, vt) === 1 && (I(this, pr, ii.subscribe(async (t) => {
      t && (await this.resumePausedMutations(), b(this, fe).onFocus());
    })), I(this, mr, Tn.subscribe(async (t) => {
      t && (await this.resumePausedMutations(), b(this, fe).onOnline());
    })));
  }
  unmount() {
    var t, e;
    gn(this, vt)._--, b(this, vt) === 0 && ((t = b(this, pr)) == null || t.call(this), I(this, pr, void 0), (e = b(this, mr)) == null || e.call(this), I(this, mr, void 0));
  }
  isFetching(t) {
    return b(this, fe).findAll({ ...t, fetchStatus: "fetching" }).length;
  }
  isMutating(t) {
    return b(this, yt).findAll({ ...t, status: "pending" }).length;
  }
  getQueryData(t) {
    var r;
    const e = this.defaultQueryOptions({ queryKey: t });
    return (r = b(this, fe).get(e.queryHash)) == null ? void 0 : r.state.data;
  }
  ensureQueryData(t) {
    const e = this.getQueryData(t.queryKey);
    if (e === void 0)
      return this.fetchQuery(t);
    {
      const r = this.defaultQueryOptions(t), n = b(this, fe).build(this, r);
      return t.revalidateIfStale && n.isStaleByTime(sr(r.staleTime, n)) && this.prefetchQuery(r), Promise.resolve(e);
    }
  }
  getQueriesData(t) {
    return b(this, fe).findAll(t).map(({ queryKey: e, state: r }) => {
      const n = r.data;
      return [e, n];
    });
  }
  setQueryData(t, e, r) {
    const n = this.defaultQueryOptions({ queryKey: t }), s = b(this, fe).get(
      n.queryHash
    ), i = s == null ? void 0 : s.state.data, a = vh(e, i);
    if (a !== void 0)
      return b(this, fe).build(this, n).setData(a, { ...r, manual: !0 });
  }
  setQueriesData(t, e, r) {
    return xe.batch(
      () => b(this, fe).findAll(t).map(({ queryKey: n }) => [
        n,
        this.setQueryData(n, e, r)
      ])
    );
  }
  getQueryState(t) {
    var r;
    const e = this.defaultQueryOptions({ queryKey: t });
    return (r = b(this, fe).get(e.queryHash)) == null ? void 0 : r.state;
  }
  removeQueries(t) {
    const e = b(this, fe);
    xe.batch(() => {
      e.findAll(t).forEach((r) => {
        e.remove(r);
      });
    });
  }
  resetQueries(t, e) {
    const r = b(this, fe), n = {
      type: "active",
      ...t
    };
    return xe.batch(() => (r.findAll(t).forEach((s) => {
      s.reset();
    }), this.refetchQueries(n, e)));
  }
  cancelQueries(t = {}, e = {}) {
    const r = { revert: !0, ...e }, n = xe.batch(
      () => b(this, fe).findAll(t).map((s) => s.cancel(r))
    );
    return Promise.all(n).then(He).catch(He);
  }
  invalidateQueries(t = {}, e = {}) {
    return xe.batch(() => {
      if (b(this, fe).findAll(t).forEach((n) => {
        n.invalidate();
      }), t.refetchType === "none")
        return Promise.resolve();
      const r = {
        ...t,
        type: t.refetchType ?? t.type ?? "active"
      };
      return this.refetchQueries(r, e);
    });
  }
  refetchQueries(t = {}, e) {
    const r = {
      ...e,
      cancelRefetch: (e == null ? void 0 : e.cancelRefetch) ?? !0
    }, n = xe.batch(
      () => b(this, fe).findAll(t).filter((s) => !s.isDisabled()).map((s) => {
        let i = s.fetch(void 0, r);
        return r.throwOnError || (i = i.catch(He)), s.state.fetchStatus === "paused" ? Promise.resolve() : i;
      })
    );
    return Promise.all(n).then(He);
  }
  fetchQuery(t) {
    const e = this.defaultQueryOptions(t);
    e.retry === void 0 && (e.retry = !1);
    const r = b(this, fe).build(this, e);
    return r.isStaleByTime(
      sr(e.staleTime, r)
    ) ? r.fetch(e) : Promise.resolve(r.state.data);
  }
  prefetchQuery(t) {
    return this.fetchQuery(t).then(He).catch(He);
  }
  fetchInfiniteQuery(t) {
    return t.behavior = Nn(t.pages), this.fetchQuery(t);
  }
  prefetchInfiniteQuery(t) {
    return this.fetchInfiniteQuery(t).then(He).catch(He);
  }
  ensureInfiniteQueryData(t) {
    return t.behavior = Nn(t.pages), this.ensureQueryData(t);
  }
  resumePausedMutations() {
    return Tn.isOnline() ? b(this, yt).resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return b(this, fe);
  }
  getMutationCache() {
    return b(this, yt);
  }
  getDefaultOptions() {
    return b(this, bt);
  }
  setDefaultOptions(t) {
    I(this, bt, t);
  }
  setQueryDefaults(t, e) {
    b(this, dr).set(Hr(t), {
      queryKey: t,
      defaultOptions: e
    });
  }
  getQueryDefaults(t) {
    const e = [...b(this, dr).values()];
    let r = {};
    return e.forEach((n) => {
      Wr(t, n.queryKey) && (r = { ...r, ...n.defaultOptions });
    }), r;
  }
  setMutationDefaults(t, e) {
    b(this, fr).set(Hr(t), {
      mutationKey: t,
      defaultOptions: e
    });
  }
  getMutationDefaults(t) {
    const e = [...b(this, fr).values()];
    let r = {};
    return e.forEach((n) => {
      Wr(t, n.mutationKey) && (r = { ...r, ...n.defaultOptions });
    }), r;
  }
  defaultQueryOptions(t) {
    if (t._defaulted)
      return t;
    const e = {
      ...b(this, bt).queries,
      ...this.getQueryDefaults(t.queryKey),
      ...t,
      _defaulted: !0
    };
    return e.queryHash || (e.queryHash = si(
      e.queryKey,
      e
    )), e.refetchOnReconnect === void 0 && (e.refetchOnReconnect = e.networkMode !== "always"), e.throwOnError === void 0 && (e.throwOnError = !!e.suspense), !e.networkMode && e.persister && (e.networkMode = "offlineFirst"), e.enabled !== !0 && e.queryFn === Pn && (e.enabled = !1), e;
  }
  defaultMutationOptions(t) {
    return t != null && t._defaulted ? t : {
      ...b(this, bt).mutations,
      ...(t == null ? void 0 : t.mutationKey) && this.getMutationDefaults(t.mutationKey),
      ...t,
      _defaulted: !0
    };
  }
  clear() {
    b(this, fe).clear(), b(this, yt).clear();
  }
}, fe = new WeakMap(), yt = new WeakMap(), bt = new WeakMap(), dr = new WeakMap(), fr = new WeakMap(), vt = new WeakMap(), pr = new WeakMap(), mr = new WeakMap(), Ya), je, J, Xr, _e, It, gr, wt, Ze, Gr, yr, br, Mt, Lt, xt, vr, Ut, Lr, Jr, Ps, Zr, Ts, en, Ns, tn, js, rn, Ds, nn, Fs, sn, As, An, To, Xa, Po = (Xa = class extends on {
  constructor(e, r) {
    super();
    L(this, Ut);
    L(this, Jr);
    L(this, Zr);
    L(this, en);
    L(this, tn);
    L(this, rn);
    L(this, nn);
    L(this, sn);
    L(this, An);
    L(this, je, void 0);
    L(this, J, void 0);
    L(this, Xr, void 0);
    L(this, _e, void 0);
    L(this, It, void 0);
    L(this, gr, void 0);
    L(this, wt, void 0);
    L(this, Ze, void 0);
    L(this, Gr, void 0);
    L(this, yr, void 0);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    L(this, br, void 0);
    L(this, Mt, void 0);
    L(this, Lt, void 0);
    L(this, xt, void 0);
    L(this, vr, /* @__PURE__ */ new Set());
    this.options = r, I(this, je, e), I(this, Ze, null), I(this, wt, Rs()), this.options.experimental_prefetchInRender || b(this, wt).reject(
      new Error("experimental_prefetchInRender feature flag is not enabled")
    ), this.bindMethods(), this.setOptions(r);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (b(this, J).addObserver(this), oa(b(this, J), this.options) ? G(this, Ut, Lr).call(this) : this.updateResult(), G(this, tn, js).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return ks(
      b(this, J),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return ks(
      b(this, J),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), G(this, rn, Ds).call(this), G(this, nn, Fs).call(this), b(this, J).removeObserver(this);
  }
  setOptions(e, r) {
    const n = this.options, s = b(this, J);
    if (this.options = b(this, je).defaultQueryOptions(e), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof Ke(this.options.enabled, b(this, J)) != "boolean")
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    G(this, sn, As).call(this), b(this, J).setOptions(this.options), n._defaulted && !Es(this.options, n) && b(this, je).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: b(this, J),
      observer: this
    });
    const i = this.hasListeners();
    i && la(
      b(this, J),
      s,
      this.options,
      n
    ) && G(this, Ut, Lr).call(this), this.updateResult(r), i && (b(this, J) !== s || Ke(this.options.enabled, b(this, J)) !== Ke(n.enabled, b(this, J)) || sr(this.options.staleTime, b(this, J)) !== sr(n.staleTime, b(this, J))) && G(this, Jr, Ps).call(this);
    const a = G(this, Zr, Ts).call(this);
    i && (b(this, J) !== s || Ke(this.options.enabled, b(this, J)) !== Ke(n.enabled, b(this, J)) || a !== b(this, xt)) && G(this, en, Ns).call(this, a);
  }
  getOptimisticResult(e) {
    const r = b(this, je).getQueryCache().build(b(this, je), e), n = this.createResult(r, e);
    return Mh(this, n) && (I(this, _e, n), I(this, gr, this.options), I(this, It, b(this, J).state)), n;
  }
  getCurrentResult() {
    return b(this, _e);
  }
  trackResult(e, r) {
    const n = {};
    return Object.keys(e).forEach((s) => {
      Object.defineProperty(n, s, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackProp(s), r == null || r(s), e[s])
      });
    }), n;
  }
  trackProp(e) {
    b(this, vr).add(e);
  }
  getCurrentQuery() {
    return b(this, J);
  }
  refetch({ ...e } = {}) {
    return this.fetch({
      ...e
    });
  }
  fetchOptimistic(e) {
    const r = b(this, je).defaultQueryOptions(e), n = b(this, je).getQueryCache().build(b(this, je), r);
    return n.fetch().then(() => this.createResult(n, r));
  }
  fetch(e) {
    return G(this, Ut, Lr).call(this, {
      ...e,
      cancelRefetch: e.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), b(this, _e)));
  }
  createResult(e, r) {
    var O;
    const n = b(this, J), s = this.options, i = b(this, _e), a = b(this, It), o = b(this, gr), c = e !== n ? e.state : b(this, Xr), { state: u } = e;
    let d = { ...u }, h = !1, m;
    if (r._optimisticResults) {
      const R = this.hasListeners(), N = !R && oa(e, r), k = R && la(e, n, r, s);
      (N || k) && (d = {
        ...d,
        ...Ro(u.data, e.options)
      }), r._optimisticResults === "isRestoring" && (d.fetchStatus = "idle");
    }
    let { error: f, errorUpdatedAt: y, status: p } = d;
    if (r.select && d.data !== void 0)
      if (i && d.data === (a == null ? void 0 : a.data) && r.select === b(this, Gr))
        m = b(this, yr);
      else
        try {
          I(this, Gr, r.select), m = r.select(d.data), m = Os(i == null ? void 0 : i.data, m, r), I(this, yr, m), I(this, Ze, null);
        } catch (R) {
          I(this, Ze, R);
        }
    else
      m = d.data;
    if (r.placeholderData !== void 0 && m === void 0 && p === "pending") {
      let R;
      if (i != null && i.isPlaceholderData && r.placeholderData === (o == null ? void 0 : o.placeholderData))
        R = i.data;
      else if (R = typeof r.placeholderData == "function" ? r.placeholderData(
        (O = b(this, br)) == null ? void 0 : O.state.data,
        b(this, br)
      ) : r.placeholderData, r.select && R !== void 0)
        try {
          R = r.select(R), I(this, Ze, null);
        } catch (N) {
          I(this, Ze, N);
        }
      R !== void 0 && (p = "success", m = Os(
        i == null ? void 0 : i.data,
        R,
        r
      ), h = !0);
    }
    b(this, Ze) && (f = b(this, Ze), m = b(this, yr), y = Date.now(), p = "error");
    const S = d.fetchStatus === "fetching", x = p === "pending", C = p === "error", P = x && S, j = m !== void 0, _ = {
      status: p,
      fetchStatus: d.fetchStatus,
      isPending: x,
      isSuccess: p === "success",
      isError: C,
      isInitialLoading: P,
      isLoading: P,
      data: m,
      dataUpdatedAt: d.dataUpdatedAt,
      error: f,
      errorUpdatedAt: y,
      failureCount: d.fetchFailureCount,
      failureReason: d.fetchFailureReason,
      errorUpdateCount: d.errorUpdateCount,
      isFetched: d.dataUpdateCount > 0 || d.errorUpdateCount > 0,
      isFetchedAfterMount: d.dataUpdateCount > c.dataUpdateCount || d.errorUpdateCount > c.errorUpdateCount,
      isFetching: S,
      isRefetching: S && !x,
      isLoadingError: C && !j,
      isPaused: d.fetchStatus === "paused",
      isPlaceholderData: h,
      isRefetchError: C && j,
      isStale: ai(e, r),
      refetch: this.refetch,
      promise: b(this, wt)
    };
    if (this.options.experimental_prefetchInRender) {
      const R = (D) => {
        _.status === "error" ? D.reject(_.error) : _.data !== void 0 && D.resolve(_.data);
      }, N = () => {
        const D = I(this, wt, _.promise = Rs());
        R(D);
      }, k = b(this, wt);
      switch (k.status) {
        case "pending":
          e.queryHash === n.queryHash && R(k);
          break;
        case "fulfilled":
          (_.status === "error" || _.data !== k.value) && N();
          break;
        case "rejected":
          (_.status !== "error" || _.error !== k.reason) && N();
          break;
      }
    }
    return _;
  }
  updateResult(e) {
    const r = b(this, _e), n = this.createResult(b(this, J), this.options);
    if (I(this, It, b(this, J).state), I(this, gr, this.options), b(this, It).data !== void 0 && I(this, br, b(this, J)), Es(n, r))
      return;
    I(this, _e, n);
    const s = {}, i = () => {
      if (!r)
        return !0;
      const { notifyOnChangeProps: a } = this.options, o = typeof a == "function" ? a() : a;
      if (o === "all" || !o && !b(this, vr).size)
        return !0;
      const l = new Set(
        o ?? b(this, vr)
      );
      return this.options.throwOnError && l.add("error"), Object.keys(b(this, _e)).some((c) => {
        const u = c;
        return b(this, _e)[u] !== r[u] && l.has(u);
      });
    };
    (e == null ? void 0 : e.listeners) !== !1 && i() && (s.listeners = !0), G(this, An, To).call(this, { ...s, ...e });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && G(this, tn, js).call(this);
  }
}, je = new WeakMap(), J = new WeakMap(), Xr = new WeakMap(), _e = new WeakMap(), It = new WeakMap(), gr = new WeakMap(), wt = new WeakMap(), Ze = new WeakMap(), Gr = new WeakMap(), yr = new WeakMap(), br = new WeakMap(), Mt = new WeakMap(), Lt = new WeakMap(), xt = new WeakMap(), vr = new WeakMap(), Ut = new WeakSet(), Lr = function(e) {
  G(this, sn, As).call(this);
  let r = b(this, J).fetch(
    this.options,
    e
  );
  return e != null && e.throwOnError || (r = r.catch(He)), r;
}, Jr = new WeakSet(), Ps = function() {
  G(this, rn, Ds).call(this);
  const e = sr(
    this.options.staleTime,
    b(this, J)
  );
  if ($t || b(this, _e).isStale || !xs(e))
    return;
  const n = wo(b(this, _e).dataUpdatedAt, e) + 1;
  I(this, Mt, setTimeout(() => {
    b(this, _e).isStale || this.updateResult();
  }, n));
}, Zr = new WeakSet(), Ts = function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(b(this, J)) : this.options.refetchInterval) ?? !1;
}, en = new WeakSet(), Ns = function(e) {
  G(this, nn, Fs).call(this), I(this, xt, e), !($t || Ke(this.options.enabled, b(this, J)) === !1 || !xs(b(this, xt)) || b(this, xt) === 0) && I(this, Lt, setInterval(() => {
    (this.options.refetchIntervalInBackground || ii.isFocused()) && G(this, Ut, Lr).call(this);
  }, b(this, xt)));
}, tn = new WeakSet(), js = function() {
  G(this, Jr, Ps).call(this), G(this, en, Ns).call(this, G(this, Zr, Ts).call(this));
}, rn = new WeakSet(), Ds = function() {
  b(this, Mt) && (clearTimeout(b(this, Mt)), I(this, Mt, void 0));
}, nn = new WeakSet(), Fs = function() {
  b(this, Lt) && (clearInterval(b(this, Lt)), I(this, Lt, void 0));
}, sn = new WeakSet(), As = function() {
  const e = b(this, je).getQueryCache().build(b(this, je), this.options);
  if (e === b(this, J))
    return;
  const r = b(this, J);
  I(this, J, e), I(this, Xr, e.state), this.hasListeners() && (r == null || r.removeObserver(this), e.addObserver(this));
}, An = new WeakSet(), To = function(e) {
  xe.batch(() => {
    e.listeners && this.listeners.forEach((r) => {
      r(b(this, _e));
    }), b(this, je).getQueryCache().notify({
      query: b(this, J),
      type: "observerResultsUpdated"
    });
  });
}, Xa);
function Ih(t, e) {
  return Ke(e.enabled, t) !== !1 && t.state.data === void 0 && !(t.state.status === "error" && e.retryOnMount === !1);
}
function oa(t, e) {
  return Ih(t, e) || t.state.data !== void 0 && ks(t, e, e.refetchOnMount);
}
function ks(t, e, r) {
  if (Ke(e.enabled, t) !== !1) {
    const n = typeof r == "function" ? r(t) : r;
    return n === "always" || n !== !1 && ai(t, e);
  }
  return !1;
}
function la(t, e, r, n) {
  return (t !== e || Ke(n.enabled, t) === !1) && (!r.suspense || t.state.status !== "error") && ai(t, r);
}
function ai(t, e) {
  return Ke(e.enabled, t) !== !1 && t.isStaleByTime(sr(e.staleTime, t));
}
function Mh(t, e) {
  return !Es(t.getCurrentResult(), e);
}
var Lh = class extends Po {
  constructor(t, e) {
    super(t, e);
  }
  bindMethods() {
    super.bindMethods(), this.fetchNextPage = this.fetchNextPage.bind(this), this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  }
  setOptions(t, e) {
    super.setOptions(
      {
        ...t,
        behavior: Nn()
      },
      e
    );
  }
  getOptimisticResult(t) {
    return t.behavior = Nn(), super.getOptimisticResult(t);
  }
  fetchNextPage(t) {
    return this.fetch({
      ...t,
      meta: {
        fetchMore: { direction: "forward" }
      }
    });
  }
  fetchPreviousPage(t) {
    return this.fetch({
      ...t,
      meta: {
        fetchMore: { direction: "backward" }
      }
    });
  }
  createResult(t, e) {
    var f, y;
    const { state: r } = t, n = super.createResult(t, e), { isFetching: s, isRefetching: i, isError: a, isRefetchError: o } = n, l = (y = (f = r.fetchMeta) == null ? void 0 : f.fetchMore) == null ? void 0 : y.direction, c = a && l === "forward", u = s && l === "forward", d = a && l === "backward", h = s && l === "backward";
    return {
      ...n,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: Fh(e, r.data),
      hasPreviousPage: Ah(e, r.data),
      isFetchNextPageError: c,
      isFetchingNextPage: u,
      isFetchPreviousPageError: d,
      isFetchingPreviousPage: h,
      isRefetchError: o && !c && !d,
      isRefetching: i && !u && !h
    };
  }
}, No = Se.createContext(
  void 0
), Un = (t) => {
  const e = Se.useContext(No);
  if (!e)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return e;
}, Uh = ({
  client: t,
  children: e
}) => (Se.useEffect(() => (t.mount(), () => {
  t.unmount();
}), [t]), /* @__PURE__ */ v.jsx(No.Provider, { value: t, children: e })), jo = Se.createContext(!1), zh = () => Se.useContext(jo);
jo.Provider;
function Bh() {
  let t = !1;
  return {
    clearReset: () => {
      t = !1;
    },
    reset: () => {
      t = !0;
    },
    isReset: () => t
  };
}
var $h = Se.createContext(Bh()), Hh = () => Se.useContext($h);
function Wh(t, e) {
  return typeof t == "function" ? t(...e) : !!t;
}
function Vh() {
}
var qh = (t, e) => {
  (t.suspense || t.throwOnError || t.experimental_prefetchInRender) && (e.isReset() || (t.retryOnMount = !1));
}, Kh = (t) => {
  Se.useEffect(() => {
    t.clearReset();
  }, [t]);
}, Qh = ({
  result: t,
  errorResetBoundary: e,
  throwOnError: r,
  query: n
}) => t.isError && !e.isReset() && !t.isFetching && n && Wh(r, [t.error, n]), Yh = (t) => {
  t.suspense && (t.staleTime === void 0 && (t.staleTime = 1e3), typeof t.gcTime == "number" && (t.gcTime = Math.max(t.gcTime, 1e3)));
}, Xh = (t, e) => t.isLoading && t.isFetching && !e, Gh = (t, e) => (t == null ? void 0 : t.suspense) && e.isPending, ca = (t, e, r) => e.fetchOptimistic(t).catch(() => {
  r.clearReset();
});
function Do(t, e, r) {
  var u, d, h, m, f;
  if (process.env.NODE_ENV !== "production" && (typeof t != "object" || Array.isArray(t)))
    throw new Error(
      'Bad argument type. Starting with v5, only the "Object" form is allowed when calling query related functions. Please use the error stack to find the culprit call. More info here: https://tanstack.com/query/latest/docs/react/guides/migrating-to-v5#supports-a-single-signature-one-object'
    );
  const n = Un(), s = zh(), i = Hh(), a = n.defaultQueryOptions(t);
  (d = (u = n.getDefaultOptions().queries) == null ? void 0 : u._experimental_beforeQuery) == null || d.call(
    u,
    a
  ), a._optimisticResults = s ? "isRestoring" : "optimistic", Yh(a), qh(a, i), Kh(i);
  const o = !n.getQueryCache().get(a.queryHash), [l] = Se.useState(
    () => new e(
      n,
      a
    )
  ), c = l.getOptimisticResult(a);
  if (Se.useSyncExternalStore(
    Se.useCallback(
      (y) => {
        const p = s ? () => {
        } : l.subscribe(xe.batchCalls(y));
        return l.updateResult(), p;
      },
      [l, s]
    ),
    () => l.getCurrentResult(),
    () => l.getCurrentResult()
  ), Se.useEffect(() => {
    l.setOptions(a, { listeners: !1 });
  }, [a, l]), Gh(a, c))
    throw ca(a, l, i);
  if (Qh({
    result: c,
    errorResetBoundary: i,
    throwOnError: a.throwOnError,
    query: n.getQueryCache().get(a.queryHash)
  }))
    throw c.error;
  if ((m = (h = n.getDefaultOptions().queries) == null ? void 0 : h._experimental_afterQuery) == null || m.call(
    h,
    a,
    c
  ), a.experimental_prefetchInRender && !$t && Xh(c, s)) {
    const y = o ? (
      // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
      ca(a, l, i)
    ) : (
      // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
      (f = n.getQueryCache().get(a.queryHash)) == null ? void 0 : f.promise
    );
    y == null || y.catch(Vh).finally(() => {
      l.updateResult();
    });
  }
  return a.notifyOnChangeProps ? c : l.trackResult(c);
}
function Fo(t, e) {
  return Do(t, Po);
}
function Jh(t, e) {
  return Do(
    t,
    Lh
  );
}
const Zh = new kh({
  defaultOptions: {
    queries: {
      retry: !1,
      refetchInterval: !1,
      refetchOnWindowFocus: !1,
      refetchOnMount: !1,
      refetchIntervalInBackground: !1
    }
  }
});
function hm({ children: t }) {
  return /* @__PURE__ */ v.jsx(Uh, { client: Zh, children: t });
}
const ed = Ga(null), dm = ({
  children: t,
  languageCode: e
}) => {
  const [r, n] = te(e), s = Yl((i) => {
    ye.hasResourceBundle(i, ri) ? (ye.changeLanguage(i), n(i)) : ah(i).then(() => {
      ye.changeLanguage(i), n(i);
    });
  }, []);
  return We(() => {
    ye.isInitialized && s(e);
  }, [e, s]), /* @__PURE__ */ v.jsx(ed.Provider, { value: { currentLanguageCode: r, changeLocale: s }, children: t });
}, Ao = async ({
  startFrom: t,
  limit: e,
  order: r,
  sortColumn: n,
  sortDirection: s,
  filter: i
}) => {
  var o, l;
  return (await ni.get(
    "/api/dashboard/customer/data-files?" + (i != null && i.name ? `&filter[names][]=${i == null ? void 0 : i.name}` : "") + ((o = i == null ? void 0 : i.source) != null && o.length ? i.source.map((c) => `&filter[sources][]=${encodeURIComponent(c)}`).join("") : "") + ((l = i == null ? void 0 : i.type) != null && l.length ? i.type.map((c) => `&filter[types][]=${encodeURIComponent(c)}`).join("") : "") + (t ? `&pagination[startFrom]=${t}` : "") + (n ? `&pagination[sortColumn]=${n}` : "") + (s ? `&pagination[sortDirection]=${s}` : "") + (e ? `&pagination[limit]=${e}` : "") + (r ? `&pagination[order]=${r}` : "")
  )).data;
}, fm = ({
  startFrom: t,
  limit: e = 10,
  order: r = ei.Next,
  sortColumn: n,
  sortDirection: s,
  filter: i
}, a) => {
  const o = Un(), l = ["data-files"], c = [
    "data-files",
    { startFrom: t, limit: e, order: r, sortColumn: n, sortDirection: s, filter: i }
  ];
  return {
    ...Fo({
      queryKey: c,
      queryFn: () => Ao({ startFrom: t, limit: e, order: r, sortColumn: n, sortDirection: s, filter: i }),
      ...a
    }),
    resetAndRefetch: () => {
      o.invalidateQueries({ queryKey: l });
    },
    triggerFetch: () => {
      o.fetchQuery({ queryKey: c });
    },
    deleteItemFromData: (y) => {
      o.getQueryCache().findAll({ queryKey: l }).forEach((S) => {
        o.setQueryData(
          S.queryKey,
          (x) => {
            if (x)
              return {
                ...x,
                items: x.items.filter((C) => C.id !== y)
              };
          }
        );
      });
    },
    renameItemFromData: ({ id: y, name: p }) => {
      o.getQueryCache().findAll({ queryKey: l }).forEach((x) => {
        o.setQueryData(
          x.queryKey,
          (C) => {
            if (C)
              return {
                ...C,
                items: C.items.map((P) => P.id === y ? { ...P, name: p } : P)
              };
          }
        );
      });
    }
  };
}, td = ({
  limit: t = 10,
  order: e = ei.Next,
  sortColumn: r,
  sortDirection: n,
  filter: s
}, i) => {
  const a = Un(), o = [
    "infinite-data-files",
    { limit: t, order: e, sortColumn: r, sortDirection: n, filter: s }
  ];
  return { ...Jh({
    initialPageParam: void 0,
    queryKey: o,
    queryFn: ({ pageParam: h }) => Ao({
      startFrom: typeof h == "string" ? h : void 0,
      limit: t,
      order: e,
      sortColumn: r,
      sortDirection: n,
      filter: s
    }),
    getPreviousPageParam: (h) => {
      if (!h.hasMore)
        return;
      const m = h.items[0];
      if (m)
        return encodeURIComponent(
          JSON.stringify({
            id: m.id,
            field: m[r ?? "name"]
          })
        );
    },
    getNextPageParam: (h) => {
      if (!h.hasMore)
        return;
      const m = h.items[h.items.length - 1];
      if (m)
        return encodeURIComponent(
          JSON.stringify({
            id: m.id,
            field: m[r ?? "name"]
          })
        );
    },
    ...i
  }), resetAndRefetch: () => {
    a.invalidateQueries({ queryKey: o });
  }, deleteItemFromData: (h) => {
    a.setQueryData(o, (m) => m && {
      ...m,
      pages: m.pages.map((f) => ({
        ...f,
        items: f.items.filter((y) => y.id !== h)
      }))
    });
  }, renameItemFromData: ({ id: h, name: m }) => {
    a.setQueryData(o, (f) => f && {
      ...f,
      pages: f.pages.map((y) => ({
        ...y,
        items: y.items.map((p) => p.id === h ? { ...p, name: m } : p)
      }))
    });
  } };
}, rd = ({ id: t }, e) => {
  const r = Un(), n = ["file-details", { id: t }];
  return { ...Fo({
    queryKey: n,
    retry: !1,
    refetchInterval: !1,
    refetchOnWindowFocus: !1,
    enabled: typeof t < "u",
    queryFn: async ({ queryKey: a }) => {
      const [, { id: o }] = a;
      return (await ni.get("/api/dashboard/customer/data-files/" + o)).data;
    },
    ...e
  }), resetAndRefetch: () => {
    r.invalidateQueries({ queryKey: n });
  } };
}, ko = () => {
  const { fetcher: t } = nr({
    method: tr.delete
  }), { fetcher: e } = nr({
    method: tr.get
  }), { fetcher: r } = nr({
    method: tr.post
  });
  return { deleteFile: async ({ id: a }) => {
    await t("/api/dashboard/customer/data-files/" + a);
  }, downloadFile: async ({ id: a }) => {
    const { link: o } = await e(`/api/dashboard/customer/data-files/${a}/download-link`), l = document.createElement("a");
    l.setAttribute("href", o), l.setAttribute("download", ""), l.click();
  }, renameFile: async ({ id: a, name: o }) => await r(`/api/dashboard/customer/data-files/${a}/rename`, {
    name: o
  }) };
};
function nd({
  isFetching: t,
  values: e,
  disabled: r,
  disabledFileSourceSelect: n,
  disabledFileTypeSelect: s,
  onChange: i,
  onSubmit: a
}) {
  const { t: o } = Pe();
  return /* @__PURE__ */ v.jsxs(
    "form",
    {
      onSubmit: (l) => {
        l.preventDefault(), l.stopPropagation(), a();
      },
      className: "flex flex-col gap-2 sm:grid sm:grid-cols-2 lg:flex lg:flex-row lg:items-end lg:flex-wrap",
      children: [
        /* @__PURE__ */ v.jsx(
          sc,
          {
            disabled: t || r,
            label: o("file_manager.file_selector.search_file"),
            placeholder: o("file_manager.search"),
            value: e.name,
            onClear: () => i == null ? void 0 : i({ ...e, name: "" }),
            onChange: (l) => i == null ? void 0 : i({ ...e, name: l.target.value }),
            showSearchIcon: !0,
            className: "lg:flex-2",
            labelClassName: "text-text-primary text-lg font-bold",
            searchIconClassName: "left-3 top-[31px]",
            closeIconClassName: "top-[31px]",
            inputClassName: "!pl-[40px] pr-4"
          }
        ),
        /* @__PURE__ */ v.jsx(
          _i,
          {
            disabled: t || r || n,
            placeholder: o("file_manager.select_source"),
            value: e.source,
            data: Object.values(oe).filter((l) => l !== oe.BlockPreview && l !== oe.Community).map((l) => ({
              id: l,
              caption: o(Sc[l])
            })),
            onChange: (l) => i == null ? void 0 : i({ ...e, source: l }),
            containerClassName: "self-auto sm:self-end"
          }
        ),
        /* @__PURE__ */ v.jsx(
          _i,
          {
            disabled: t || r || s,
            placeholder: o("file_manager.select_type"),
            value: e.type,
            data: Object.values(ie).map((l) => ({
              id: l,
              caption: o(Ec[l])
            })),
            onChange: (l) => i == null ? void 0 : i({ ...e, type: l }),
            containerClassName: "self-auto sm:self-end"
          }
        ),
        /* @__PURE__ */ v.jsx(
          an,
          {
            type: "submit",
            isFetching: t,
            disabled: r,
            className: "min-w-14",
            children: o("file_manager.search")
          }
        )
      ]
    }
  );
}
function Gt(t, e, r) {
  let n = r.initialDeps ?? [], s;
  return () => {
    var i, a, o, l;
    let c;
    r.key && ((i = r.debug) != null && i.call(r)) && (c = Date.now());
    const u = t();
    if (!(u.length !== n.length || u.some((m, f) => n[f] !== m)))
      return s;
    n = u;
    let h;
    if (r.key && ((a = r.debug) != null && a.call(r)) && (h = Date.now()), s = e(...u), r.key && ((o = r.debug) != null && o.call(r))) {
      const m = Math.round((Date.now() - c) * 100) / 100, f = Math.round((Date.now() - h) * 100) / 100, y = f / 16, p = (S, x) => {
        for (S = String(S); S.length < x; )
          S = " " + S;
        return S;
      };
      console.info(
        `%c⏱ ${p(f, 5)} /${p(m, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * y, 120)
        )}deg 100% 31%);`,
        r == null ? void 0 : r.key
      );
    }
    return (l = r == null ? void 0 : r.onChange) == null || l.call(r, s), s;
  };
}
function is(t, e) {
  if (t === void 0)
    throw new Error("Unexpected undefined");
  return t;
}
const sd = (t, e) => Math.abs(t - e) < 1, id = (t, e, r) => {
  let n;
  return function(...s) {
    t.clearTimeout(n), n = t.setTimeout(() => e.apply(this, s), r);
  };
}, ad = (t) => t, od = (t) => {
  const e = Math.max(t.startIndex - t.overscan, 0), r = Math.min(t.endIndex + t.overscan, t.count - 1), n = [];
  for (let s = e; s <= r; s++)
    n.push(s);
  return n;
}, ld = (t, e) => {
  const r = t.scrollElement;
  if (!r)
    return;
  const n = t.targetWindow;
  if (!n)
    return;
  const s = (a) => {
    const { width: o, height: l } = a;
    e({ width: Math.round(o), height: Math.round(l) });
  };
  if (s(r.getBoundingClientRect()), !n.ResizeObserver)
    return () => {
    };
  const i = new n.ResizeObserver((a) => {
    const o = a[0];
    if (o != null && o.borderBoxSize) {
      const l = o.borderBoxSize[0];
      if (l) {
        s({ width: l.inlineSize, height: l.blockSize });
        return;
      }
    }
    s(r.getBoundingClientRect());
  });
  return i.observe(r, { box: "border-box" }), () => {
    i.unobserve(r);
  };
}, ua = {
  passive: !0
}, cd = typeof window > "u" ? !0 : "onscrollend" in window, ud = (t, e) => {
  const r = t.scrollElement;
  if (!r)
    return;
  const n = t.targetWindow;
  if (!n)
    return;
  let s = 0;
  const i = cd ? () => {
  } : id(
    n,
    () => {
      e(s, !1);
    },
    t.options.isScrollingResetDelay
  ), a = (c) => () => {
    const { horizontal: u, isRtl: d } = t.options;
    s = u ? r.scrollLeft * (d && -1 || 1) : r.scrollTop, i(), e(s, c);
  }, o = a(!0), l = a(!1);
  return l(), r.addEventListener("scroll", o, ua), r.addEventListener("scrollend", l, ua), () => {
    r.removeEventListener("scroll", o), r.removeEventListener("scrollend", l);
  };
}, hd = (t, e, r) => {
  if (e != null && e.borderBoxSize) {
    const n = e.borderBoxSize[0];
    if (n)
      return Math.round(
        n[r.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    t.getBoundingClientRect()[r.options.horizontal ? "width" : "height"]
  );
}, dd = (t, {
  adjustments: e = 0,
  behavior: r
}, n) => {
  var s, i;
  const a = t + e;
  (i = (s = n.scrollElement) == null ? void 0 : s.scrollTo) == null || i.call(s, {
    [n.options.horizontal ? "left" : "top"]: a,
    behavior: r
  });
};
class fd {
  constructor(e) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let r = null;
      const n = () => r || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : r = new this.targetWindow.ResizeObserver((s) => {
        s.forEach((i) => {
          this._measureElement(i.target, i);
        });
      }));
      return {
        disconnect: () => {
          var s;
          (s = n()) == null || s.disconnect(), r = null;
        },
        observe: (s) => {
          var i;
          return (i = n()) == null ? void 0 : i.observe(s, { box: "border-box" });
        },
        unobserve: (s) => {
          var i;
          return (i = n()) == null ? void 0 : i.unobserve(s);
        }
      };
    })(), this.range = null, this.setOptions = (r) => {
      Object.entries(r).forEach(([n, s]) => {
        typeof s > "u" && delete r[n];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: ad,
        rangeExtractor: od,
        onChange: () => {
        },
        measureElement: hd,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        ...r
      };
    }, this.notify = (r) => {
      var n, s;
      (s = (n = this.options).onChange) == null || s.call(n, this, r);
    }, this.maybeNotify = Gt(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (r) => {
        this.notify(r);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((r) => r()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var r;
      const n = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== n) {
        if (this.cleanup(), !n) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = n, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((r = this.scrollElement) == null ? void 0 : r.window) ?? null, this.elementsCache.forEach((s) => {
          this.observer.observe(s);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (s) => {
            this.scrollRect = s, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (s, i) => {
            this.scrollAdjustments = 0, this.scrollDirection = i ? this.getScrollOffset() < s ? "forward" : "backward" : null, this.scrollOffset = s, this.isScrolling = i, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (r, n) => {
      const s = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
      for (let a = n - 1; a >= 0; a--) {
        const o = r[a];
        if (s.has(o.lane))
          continue;
        const l = i.get(
          o.lane
        );
        if (l == null || o.end > l.end ? i.set(o.lane, o) : o.end < l.end && s.set(o.lane, !0), s.size === this.options.lanes)
          break;
      }
      return i.size === this.options.lanes ? Array.from(i.values()).sort((a, o) => a.end === o.end ? a.index - o.index : a.end - o.end)[0] : void 0;
    }, this.getMeasurementOptions = Gt(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (r, n, s, i, a) => (this.pendingMeasuredCacheIndexes = [], {
        count: r,
        paddingStart: n,
        scrollMargin: s,
        getItemKey: i,
        enabled: a
      }),
      {
        key: !1
      }
    ), this.getMeasurements = Gt(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: r, paddingStart: n, scrollMargin: s, getItemKey: i, enabled: a }, o) => {
        if (!a)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((u) => {
          this.itemSizeCache.set(u.key, u.size);
        }));
        const l = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const c = this.measurementsCache.slice(0, l);
        for (let u = l; u < r; u++) {
          const d = i(u), h = this.options.lanes === 1 ? c[u - 1] : this.getFurthestMeasurement(c, u), m = h ? h.end + this.options.gap : n + s, f = o.get(d), y = typeof f == "number" ? f : this.options.estimateSize(u), p = m + y, S = h ? h.lane : u % this.options.lanes;
          c[u] = {
            index: u,
            start: m,
            size: y,
            end: p,
            key: d,
            lane: S
          };
        }
        return this.measurementsCache = c, c;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = Gt(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (r, n, s) => this.range = r.length > 0 && n > 0 ? pd({
        measurements: r,
        outerSize: n,
        scrollOffset: s
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getIndexes = Gt(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (r, n, s, i) => n === null ? [] : r({
        startIndex: n.startIndex,
        endIndex: n.endIndex,
        overscan: s,
        count: i
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (r) => {
      const n = this.options.indexAttribute, s = r.getAttribute(n);
      return s ? parseInt(s, 10) : (console.warn(
        `Missing attribute name '${n}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (r, n) => {
      const s = this.indexFromElement(r), i = this.measurementsCache[s];
      if (!i)
        return;
      const a = i.key, o = this.elementsCache.get(a);
      o !== r && (o && this.observer.unobserve(o), this.observer.observe(r), this.elementsCache.set(a, r)), r.isConnected && this.resizeItem(s, this.options.measureElement(r, n, this));
    }, this.resizeItem = (r, n) => {
      const s = this.measurementsCache[r];
      if (!s)
        return;
      const i = this.itemSizeCache.get(s.key) ?? s.size, a = n - i;
      a !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(s, a, this) : s.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", a), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += a,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(s.index), this.itemSizeCache = new Map(this.itemSizeCache.set(s.key, n)), this.notify(!1));
    }, this.measureElement = (r) => {
      if (!r) {
        this.elementsCache.forEach((n, s) => {
          n.isConnected || (this.observer.unobserve(n), this.elementsCache.delete(s));
        });
        return;
      }
      this._measureElement(r, void 0);
    }, this.getVirtualItems = Gt(
      () => [this.getIndexes(), this.getMeasurements()],
      (r, n) => {
        const s = [];
        for (let i = 0, a = r.length; i < a; i++) {
          const o = r[i], l = n[o];
          s.push(l);
        }
        return s;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (r) => {
      const n = this.getMeasurements();
      if (n.length !== 0)
        return is(
          n[Io(
            0,
            n.length - 1,
            (s) => is(n[s]).start,
            r
          )]
        );
    }, this.getOffsetForAlignment = (r, n) => {
      const s = this.getSize(), i = this.getScrollOffset();
      n === "auto" && (r <= i ? n = "start" : r >= i + s ? n = "end" : n = "start"), n === "start" ? r = r : n === "end" ? r = r - s : n === "center" && (r = r - s / 2);
      const a = this.options.horizontal ? "scrollWidth" : "scrollHeight", l = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[a] : this.scrollElement[a] : 0) - s;
      return Math.max(Math.min(l, r), 0);
    }, this.getOffsetForIndex = (r, n = "auto") => {
      r = Math.max(0, Math.min(r, this.options.count - 1));
      const s = this.measurementsCache[r];
      if (!s)
        return;
      const i = this.getSize(), a = this.getScrollOffset();
      if (n === "auto")
        if (s.end >= a + i - this.options.scrollPaddingEnd)
          n = "end";
        else if (s.start <= a + this.options.scrollPaddingStart)
          n = "start";
        else
          return [a, n];
      const o = n === "end" ? s.end + this.options.scrollPaddingEnd : s.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(o, n), n];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (r, { align: n = "start", behavior: s } = {}) => {
      this.cancelScrollToIndex(), s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(r, n), {
        adjustments: void 0,
        behavior: s
      });
    }, this.scrollToIndex = (r, { align: n = "auto", behavior: s } = {}) => {
      r = Math.max(0, Math.min(r, this.options.count - 1)), this.cancelScrollToIndex(), s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const i = this.getOffsetForIndex(r, n);
      if (!i)
        return;
      const [a, o] = i;
      this._scrollToOffset(a, { adjustments: void 0, behavior: s }), s !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(r)
        )) {
          const [c] = is(
            this.getOffsetForIndex(r, o)
          );
          sd(c, this.getScrollOffset()) || this.scrollToIndex(r, { align: o, behavior: s });
        } else
          this.scrollToIndex(r, { align: o, behavior: s });
      }));
    }, this.scrollBy = (r, { behavior: n } = {}) => {
      this.cancelScrollToIndex(), n === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + r, {
        adjustments: void 0,
        behavior: n
      });
    }, this.getTotalSize = () => {
      var r;
      const n = this.getMeasurements();
      let s;
      return n.length === 0 ? s = this.options.paddingStart : s = this.options.lanes === 1 ? ((r = n[n.length - 1]) == null ? void 0 : r.end) ?? 0 : Math.max(
        ...n.slice(-this.options.lanes).map((i) => i.end)
      ), Math.max(
        s - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (r, {
      adjustments: n,
      behavior: s
    }) => {
      this.options.scrollToFn(r, { behavior: s, adjustments: n }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(e);
  }
}
const Io = (t, e, r, n) => {
  for (; t <= e; ) {
    const s = (t + e) / 2 | 0, i = r(s);
    if (i < n)
      t = s + 1;
    else if (i > n)
      e = s - 1;
    else
      return s;
  }
  return t > 0 ? t - 1 : 0;
};
function pd({
  measurements: t,
  outerSize: e,
  scrollOffset: r
}) {
  const n = t.length - 1, i = Io(0, n, (o) => t[o].start, r);
  let a = i;
  for (; a < n && t[a].end < r + e; )
    a++;
  return { startIndex: i, endIndex: a };
}
const md = typeof document < "u" ? Se.useLayoutEffect : Se.useEffect;
function gd(t) {
  const e = Se.useReducer(() => ({}), {})[1], r = {
    ...t,
    onChange: (s, i) => {
      var a;
      i ? bc(e) : e(), (a = t.onChange) == null || a.call(t, s, i);
    }
  }, [n] = Se.useState(
    () => new fd(r)
  );
  return n.setOptions(r), Se.useEffect(() => n._didMount(), []), md(() => n._willUpdate()), n;
}
function ha(t) {
  return gd({
    observeElementRect: ld,
    observeElementOffset: ud,
    scrollToFn: dd,
    ...t
  });
}
const Is = 2, yd = 6, bd = Is * 2 + yd;
function vd({
  initialItemWidth: t = 150,
  initialItemHeight: e = 180,
  rowGap: r = 18,
  columnGap: n = 16,
  columnCount: s = 6,
  dataFilesApi: i,
  specialElementInGrid: a,
  onSelect: o,
  onDetails: l,
  onDelete: c,
  onRename: u,
  onDownload: d
}) {
  var ce;
  const h = Ae.useRef(null), m = Ae.useRef(null), [f, y] = te(s), [p, S] = te(t), [x, C] = te(e), [P, j] = te(), { data: w, fetchNextPage: _, hasNextPage: O, isFetchingNextPage: R, isFetching: N } = i, k = "specialElementInGridId", D = a ? f >= 2 ? [k, k] : [k] : [], z = [...D, ...((ce = w == null ? void 0 : w.pages) == null ? void 0 : ce.flatMap(($) => $.items)) ?? []], U = z.length;
  We(() => {
    const $ = () => {
      if (h.current) {
        const ne = h.current.offsetWidth - bd, W = Math.floor(ne / (t + n));
        y(W || 1);
        const A = (ne - n * (W - 1)) / W;
        S(A), C(A / t * e);
      }
    };
    $();
    const K = new ResizeObserver($);
    return h.current && K.observe(h.current), () => K.disconnect();
  }, [t, e, n]);
  const M = ha({
    count: Math.ceil(U / f),
    gap: r,
    getScrollElement: () => h.current,
    estimateSize: () => x
  }), re = ha({
    count: f,
    gap: n,
    getScrollElement: () => h.current,
    estimateSize: () => p,
    horizontal: !0
  });
  return We(() => {
    if (!m.current || !O || R)
      return;
    const $ = new IntersectionObserver(
      (K) => {
        K[0].isIntersecting && _();
      },
      { root: h.current, threshold: 0.1 }
    );
    return $.observe(m.current), () => {
      m.current && $.unobserve(m.current);
    };
  }, [_, O, R]), We(() => {
    const $ = z.filter(xc).find((K) => K.id === P);
    o == null || o($);
  }, [P]), /* @__PURE__ */ v.jsxs(
    "div",
    {
      ref: h,
      className: "relative overflow-auto w-full h-[400px] customScroll",
      style: { paddingTop: Is, paddingLeft: Is },
      children: [
        /* @__PURE__ */ v.jsxs(
          "div",
          {
            style: {
              height: M.getTotalSize(),
              width: re.getTotalSize()
            },
            className: "relative",
            children: [
              N && !R ? Array.from({ length: 10 }).map(($, K) => /* @__PURE__ */ v.jsx(
                "div",
                {
                  className: "absolute bg-background-tertiary animate-pulse rounded-md",
                  style: {
                    top: Math.floor(K / f) * (x + r),
                    left: K % f * (p + n),
                    height: x,
                    width: p
                  }
                },
                K
              )) : M.getVirtualItems().map(
                ($) => re.getVirtualItems().map((K) => {
                  const ne = $.index * f + K.index, W = z[ne];
                  if (!W)
                    return null;
                  let A = Math.floor(ne / f) * (x + r);
                  const Q = ne % f * (p + n);
                  let Z = 0;
                  switch (f) {
                    case 1:
                      Z = 180;
                      break;
                    case 2:
                      Z = 80;
                      break;
                  }
                  return a && (A = A - Z), k === W ? ne === 0 ? /* @__PURE__ */ v.jsx(
                    "div",
                    {
                      style: {
                        top: 0,
                        left: 0,
                        height: x - Z,
                        width: p * D.length + n * (D.length - 1)
                      },
                      children: a
                    },
                    W + ne
                  ) : null : /* @__PURE__ */ v.jsx(
                    iu,
                    {
                      src: W.thumbnail ?? W.path ?? void 0,
                      alt: W.name,
                      name: W.name,
                      imageWidth: p,
                      imageHeight: p * 0.869,
                      secondaryText: W.type,
                      fileType: W.type,
                      style: {
                        top: A,
                        left: Q,
                        height: x,
                        width: p
                      },
                      selected: P === W.id,
                      onSelect: (Te) => {
                        j(Te ? W.id : void 0);
                      },
                      className: "absolute",
                      actionMenu: {
                        menuItems: [
                          l ? /* @__PURE__ */ v.jsx(
                            mh,
                            {
                              onClick: () => l(W)
                            },
                            "details"
                          ) : void 0,
                          c ? /* @__PURE__ */ v.jsx(
                            gh,
                            {
                              onClick: () => c(W)
                            },
                            "delete"
                          ) : void 0,
                          u ? /* @__PURE__ */ v.jsx(
                            yh,
                            {
                              onClick: () => u(W)
                            },
                            "rename"
                          ) : void 0,
                          d ? /* @__PURE__ */ v.jsx(
                            bh,
                            {
                              onClick: () => d(W)
                            },
                            "download"
                          ) : void 0
                        ].filter(Boolean)
                      }
                    },
                    W.id
                  );
                })
              ),
              O && /* @__PURE__ */ v.jsx("div", { ref: m, className: "absolute bottom-0" })
            ]
          }
        ),
        /* @__PURE__ */ v.jsx("div", { className: "flex items-center justify-center w-full pt-4 h-11", children: R && /* @__PURE__ */ v.jsx(ic, {}) })
      ]
    }
  );
}
function Mo(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: wd } = Object.prototype, { getPrototypeOf: oi } = Object, zn = /* @__PURE__ */ ((t) => (e) => {
  const r = wd.call(e);
  return t[r] || (t[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Ye = (t) => (t = t.toLowerCase(), (e) => zn(e) === t), Bn = (t) => (e) => typeof e === t, { isArray: xr } = Array, Vr = Bn("undefined");
function xd(t) {
  return t !== null && !Vr(t) && t.constructor !== null && !Vr(t.constructor) && Ue(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const Lo = Ye("ArrayBuffer");
function Sd(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && Lo(t.buffer), e;
}
const Ed = Bn("string"), Ue = Bn("function"), Uo = Bn("number"), $n = (t) => t !== null && typeof t == "object", Cd = (t) => t === !0 || t === !1, xn = (t) => {
  if (zn(t) !== "object")
    return !1;
  const e = oi(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}, Od = Ye("Date"), Rd = Ye("File"), _d = Ye("Blob"), Pd = Ye("FileList"), Td = (t) => $n(t) && Ue(t.pipe), Nd = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || Ue(t.append) && ((e = zn(t)) === "formdata" || // detect form-data instance
  e === "object" && Ue(t.toString) && t.toString() === "[object FormData]"));
}, jd = Ye("URLSearchParams"), [Dd, Fd, Ad, kd] = ["ReadableStream", "Request", "Response", "Headers"].map(Ye), Id = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ln(t, e, { allOwnKeys: r = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let n, s;
  if (typeof t != "object" && (t = [t]), xr(t))
    for (n = 0, s = t.length; n < s; n++)
      e.call(null, t[n], n, t);
  else {
    const i = r ? Object.getOwnPropertyNames(t) : Object.keys(t), a = i.length;
    let o;
    for (n = 0; n < a; n++)
      o = i[n], e.call(null, t[o], o, t);
  }
}
function zo(t, e) {
  e = e.toLowerCase();
  const r = Object.keys(t);
  let n = r.length, s;
  for (; n-- > 0; )
    if (s = r[n], e === s.toLowerCase())
      return s;
  return null;
}
const jt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Bo = (t) => !Vr(t) && t !== jt;
function Ms() {
  const { caseless: t } = Bo(this) && this || {}, e = {}, r = (n, s) => {
    const i = t && zo(e, s) || s;
    xn(e[i]) && xn(n) ? e[i] = Ms(e[i], n) : xn(n) ? e[i] = Ms({}, n) : xr(n) ? e[i] = n.slice() : e[i] = n;
  };
  for (let n = 0, s = arguments.length; n < s; n++)
    arguments[n] && ln(arguments[n], r);
  return e;
}
const Md = (t, e, r, { allOwnKeys: n } = {}) => (ln(e, (s, i) => {
  r && Ue(s) ? t[i] = Mo(s, r) : t[i] = s;
}, { allOwnKeys: n }), t), Ld = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), Ud = (t, e, r, n) => {
  t.prototype = Object.create(e.prototype, n), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), r && Object.assign(t.prototype, r);
}, zd = (t, e, r, n) => {
  let s, i, a;
  const o = {};
  if (e = e || {}, t == null)
    return e;
  do {
    for (s = Object.getOwnPropertyNames(t), i = s.length; i-- > 0; )
      a = s[i], (!n || n(a, t, e)) && !o[a] && (e[a] = t[a], o[a] = !0);
    t = r !== !1 && oi(t);
  } while (t && (!r || r(t, e)) && t !== Object.prototype);
  return e;
}, Bd = (t, e, r) => {
  t = String(t), (r === void 0 || r > t.length) && (r = t.length), r -= e.length;
  const n = t.indexOf(e, r);
  return n !== -1 && n === r;
}, $d = (t) => {
  if (!t)
    return null;
  if (xr(t))
    return t;
  let e = t.length;
  if (!Uo(e))
    return null;
  const r = new Array(e);
  for (; e-- > 0; )
    r[e] = t[e];
  return r;
}, Hd = /* @__PURE__ */ ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && oi(Uint8Array)), Wd = (t, e) => {
  const n = (t && t[Symbol.iterator]).call(t);
  let s;
  for (; (s = n.next()) && !s.done; ) {
    const i = s.value;
    e.call(t, i[0], i[1]);
  }
}, Vd = (t, e) => {
  let r;
  const n = [];
  for (; (r = t.exec(e)) !== null; )
    n.push(r);
  return n;
}, qd = Ye("HTMLFormElement"), Kd = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, s) {
    return n.toUpperCase() + s;
  }
), da = (({ hasOwnProperty: t }) => (e, r) => t.call(e, r))(Object.prototype), Qd = Ye("RegExp"), $o = (t, e) => {
  const r = Object.getOwnPropertyDescriptors(t), n = {};
  ln(r, (s, i) => {
    let a;
    (a = e(s, i, t)) !== !1 && (n[i] = a || s);
  }), Object.defineProperties(t, n);
}, Yd = (t) => {
  $o(t, (e, r) => {
    if (Ue(t) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = t[r];
    if (Ue(n)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, Xd = (t, e) => {
  const r = {}, n = (s) => {
    s.forEach((i) => {
      r[i] = !0;
    });
  };
  return xr(t) ? n(t) : n(String(t).split(e)), r;
}, Gd = () => {
}, Jd = (t, e) => t != null && Number.isFinite(t = +t) ? t : e, as = "abcdefghijklmnopqrstuvwxyz", fa = "0123456789", Ho = {
  DIGIT: fa,
  ALPHA: as,
  ALPHA_DIGIT: as + as.toUpperCase() + fa
}, Zd = (t = 16, e = Ho.ALPHA_DIGIT) => {
  let r = "";
  const { length: n } = e;
  for (; t--; )
    r += e[Math.random() * n | 0];
  return r;
};
function ef(t) {
  return !!(t && Ue(t.append) && t[Symbol.toStringTag] === "FormData" && t[Symbol.iterator]);
}
const tf = (t) => {
  const e = new Array(10), r = (n, s) => {
    if ($n(n)) {
      if (e.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        e[s] = n;
        const i = xr(n) ? [] : {};
        return ln(n, (a, o) => {
          const l = r(a, s + 1);
          !Vr(l) && (i[o] = l);
        }), e[s] = void 0, i;
      }
    }
    return n;
  };
  return r(t, 0);
}, rf = Ye("AsyncFunction"), nf = (t) => t && ($n(t) || Ue(t)) && Ue(t.then) && Ue(t.catch), Wo = ((t, e) => t ? setImmediate : e ? ((r, n) => (jt.addEventListener("message", ({ source: s, data: i }) => {
  s === jt && i === r && n.length && n.shift()();
}, !1), (s) => {
  n.push(s), jt.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  Ue(jt.postMessage)
), sf = typeof queueMicrotask < "u" ? queueMicrotask.bind(jt) : typeof process < "u" && process.nextTick || Wo, E = {
  isArray: xr,
  isArrayBuffer: Lo,
  isBuffer: xd,
  isFormData: Nd,
  isArrayBufferView: Sd,
  isString: Ed,
  isNumber: Uo,
  isBoolean: Cd,
  isObject: $n,
  isPlainObject: xn,
  isReadableStream: Dd,
  isRequest: Fd,
  isResponse: Ad,
  isHeaders: kd,
  isUndefined: Vr,
  isDate: Od,
  isFile: Rd,
  isBlob: _d,
  isRegExp: Qd,
  isFunction: Ue,
  isStream: Td,
  isURLSearchParams: jd,
  isTypedArray: Hd,
  isFileList: Pd,
  forEach: ln,
  merge: Ms,
  extend: Md,
  trim: Id,
  stripBOM: Ld,
  inherits: Ud,
  toFlatObject: zd,
  kindOf: zn,
  kindOfTest: Ye,
  endsWith: Bd,
  toArray: $d,
  forEachEntry: Wd,
  matchAll: Vd,
  isHTMLForm: qd,
  hasOwnProperty: da,
  hasOwnProp: da,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: $o,
  freezeMethods: Yd,
  toObjectSet: Xd,
  toCamelCase: Kd,
  noop: Gd,
  toFiniteNumber: Jd,
  findKey: zo,
  global: jt,
  isContextDefined: Bo,
  ALPHABET: Ho,
  generateString: Zd,
  isSpecCompliantForm: ef,
  toJSONObject: tf,
  isAsyncFn: rf,
  isThenable: nf,
  setImmediate: Wo,
  asap: sf
};
function V(t, e, r, n, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), r && (this.config = r), n && (this.request = n), s && (this.response = s);
}
E.inherits(V, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: E.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const Vo = V.prototype, qo = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  qo[t] = { value: t };
});
Object.defineProperties(V, qo);
Object.defineProperty(Vo, "isAxiosError", { value: !0 });
V.from = (t, e, r, n, s, i) => {
  const a = Object.create(Vo);
  return E.toFlatObject(t, a, function(l) {
    return l !== Error.prototype;
  }, (o) => o !== "isAxiosError"), V.call(a, t.message, e, r, n, s), a.cause = t, a.name = t.name, i && Object.assign(a, i), a;
};
const af = null;
function Ls(t) {
  return E.isPlainObject(t) || E.isArray(t);
}
function Ko(t) {
  return E.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function pa(t, e, r) {
  return t ? t.concat(e).map(function(s, i) {
    return s = Ko(s), !r && i ? "[" + s + "]" : s;
  }).join(r ? "." : "") : e;
}
function of(t) {
  return E.isArray(t) && !t.some(Ls);
}
const lf = E.toFlatObject(E, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Hn(t, e, r) {
  if (!E.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), r = E.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(y, p) {
    return !E.isUndefined(p[y]);
  });
  const n = r.metaTokens, s = r.visitor || u, i = r.dots, a = r.indexes, l = (r.Blob || typeof Blob < "u" && Blob) && E.isSpecCompliantForm(e);
  if (!E.isFunction(s))
    throw new TypeError("visitor must be a function");
  function c(f) {
    if (f === null)
      return "";
    if (E.isDate(f))
      return f.toISOString();
    if (!l && E.isBlob(f))
      throw new V("Blob is not supported. Use a Buffer instead.");
    return E.isArrayBuffer(f) || E.isTypedArray(f) ? l && typeof Blob == "function" ? new Blob([f]) : Buffer.from(f) : f;
  }
  function u(f, y, p) {
    let S = f;
    if (f && !p && typeof f == "object") {
      if (E.endsWith(y, "{}"))
        y = n ? y : y.slice(0, -2), f = JSON.stringify(f);
      else if (E.isArray(f) && of(f) || (E.isFileList(f) || E.endsWith(y, "[]")) && (S = E.toArray(f)))
        return y = Ko(y), S.forEach(function(C, P) {
          !(E.isUndefined(C) || C === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? pa([y], P, i) : a === null ? y : y + "[]",
            c(C)
          );
        }), !1;
    }
    return Ls(f) ? !0 : (e.append(pa(p, y, i), c(f)), !1);
  }
  const d = [], h = Object.assign(lf, {
    defaultVisitor: u,
    convertValue: c,
    isVisitable: Ls
  });
  function m(f, y) {
    if (!E.isUndefined(f)) {
      if (d.indexOf(f) !== -1)
        throw Error("Circular reference detected in " + y.join("."));
      d.push(f), E.forEach(f, function(S, x) {
        (!(E.isUndefined(S) || S === null) && s.call(
          e,
          S,
          E.isString(x) ? x.trim() : x,
          y,
          h
        )) === !0 && m(S, y ? y.concat(x) : [x]);
      }), d.pop();
    }
  }
  if (!E.isObject(t))
    throw new TypeError("data must be an object");
  return m(t), e;
}
function ma(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(n) {
    return e[n];
  });
}
function li(t, e) {
  this._pairs = [], t && Hn(t, this, e);
}
const Qo = li.prototype;
Qo.append = function(e, r) {
  this._pairs.push([e, r]);
};
Qo.toString = function(e) {
  const r = e ? function(n) {
    return e.call(this, n, ma);
  } : ma;
  return this._pairs.map(function(s) {
    return r(s[0]) + "=" + r(s[1]);
  }, "").join("&");
};
function cf(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Yo(t, e, r) {
  if (!e)
    return t;
  const n = r && r.encode || cf, s = r && r.serialize;
  let i;
  if (s ? i = s(e, r) : i = E.isURLSearchParams(e) ? e.toString() : new li(e, r).toString(n), i) {
    const a = t.indexOf("#");
    a !== -1 && (t = t.slice(0, a)), t += (t.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return t;
}
class ga {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, r, n) {
    return this.handlers.push({
      fulfilled: e,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    E.forEach(this.handlers, function(n) {
      n !== null && e(n);
    });
  }
}
const Xo = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, uf = typeof URLSearchParams < "u" ? URLSearchParams : li, hf = typeof FormData < "u" ? FormData : null, df = typeof Blob < "u" ? Blob : null, ff = {
  isBrowser: !0,
  classes: {
    URLSearchParams: uf,
    FormData: hf,
    Blob: df
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, ci = typeof window < "u" && typeof document < "u", pf = ((t) => ci && ["ReactNative", "NativeScript", "NS"].indexOf(t) < 0)(typeof navigator < "u" && navigator.product), mf = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", gf = ci && window.location.href || "http://localhost", yf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: ci,
  hasStandardBrowserEnv: pf,
  hasStandardBrowserWebWorkerEnv: mf,
  origin: gf
}, Symbol.toStringTag, { value: "Module" })), Qe = {
  ...yf,
  ...ff
};
function bf(t, e) {
  return Hn(t, new Qe.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, s, i) {
      return Qe.isNode && E.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function vf(t) {
  return E.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function wf(t) {
  const e = {}, r = Object.keys(t);
  let n;
  const s = r.length;
  let i;
  for (n = 0; n < s; n++)
    i = r[n], e[i] = t[i];
  return e;
}
function Go(t) {
  function e(r, n, s, i) {
    let a = r[i++];
    if (a === "__proto__")
      return !0;
    const o = Number.isFinite(+a), l = i >= r.length;
    return a = !a && E.isArray(s) ? s.length : a, l ? (E.hasOwnProp(s, a) ? s[a] = [s[a], n] : s[a] = n, !o) : ((!s[a] || !E.isObject(s[a])) && (s[a] = []), e(r, n, s[a], i) && E.isArray(s[a]) && (s[a] = wf(s[a])), !o);
  }
  if (E.isFormData(t) && E.isFunction(t.entries)) {
    const r = {};
    return E.forEachEntry(t, (n, s) => {
      e(vf(n), s, r, 0);
    }), r;
  }
  return null;
}
function xf(t, e, r) {
  if (E.isString(t))
    try {
      return (e || JSON.parse)(t), E.trim(t);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (0, JSON.stringify)(t);
}
const cn = {
  transitional: Xo,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, r) {
    const n = r.getContentType() || "", s = n.indexOf("application/json") > -1, i = E.isObject(e);
    if (i && E.isHTMLForm(e) && (e = new FormData(e)), E.isFormData(e))
      return s ? JSON.stringify(Go(e)) : e;
    if (E.isArrayBuffer(e) || E.isBuffer(e) || E.isStream(e) || E.isFile(e) || E.isBlob(e) || E.isReadableStream(e))
      return e;
    if (E.isArrayBufferView(e))
      return e.buffer;
    if (E.isURLSearchParams(e))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let o;
    if (i) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return bf(e, this.formSerializer).toString();
      if ((o = E.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return Hn(
          o ? { "files[]": e } : e,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return i || s ? (r.setContentType("application/json", !1), xf(e)) : e;
  }],
  transformResponse: [function(e) {
    const r = this.transitional || cn.transitional, n = r && r.forcedJSONParsing, s = this.responseType === "json";
    if (E.isResponse(e) || E.isReadableStream(e))
      return e;
    if (e && E.isString(e) && (n && !this.responseType || s)) {
      const a = !(r && r.silentJSONParsing) && s;
      try {
        return JSON.parse(e);
      } catch (o) {
        if (a)
          throw o.name === "SyntaxError" ? V.from(o, V.ERR_BAD_RESPONSE, this, null, this.response) : o;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Qe.classes.FormData,
    Blob: Qe.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
E.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  cn.headers[t] = {};
});
const Sf = E.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Ef = (t) => {
  const e = {};
  let r, n, s;
  return t && t.split(`
`).forEach(function(a) {
    s = a.indexOf(":"), r = a.substring(0, s).trim().toLowerCase(), n = a.substring(s + 1).trim(), !(!r || e[r] && Sf[r]) && (r === "set-cookie" ? e[r] ? e[r].push(n) : e[r] = [n] : e[r] = e[r] ? e[r] + ", " + n : n);
  }), e;
}, ya = Symbol("internals");
function Fr(t) {
  return t && String(t).trim().toLowerCase();
}
function Sn(t) {
  return t === !1 || t == null ? t : E.isArray(t) ? t.map(Sn) : String(t);
}
function Cf(t) {
  const e = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(t); )
    e[n[1]] = n[2];
  return e;
}
const Of = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function os(t, e, r, n, s) {
  if (E.isFunction(n))
    return n.call(this, e, r);
  if (s && (e = r), !!E.isString(e)) {
    if (E.isString(n))
      return e.indexOf(n) !== -1;
    if (E.isRegExp(n))
      return n.test(e);
  }
}
function Rf(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, r, n) => r.toUpperCase() + n);
}
function _f(t, e) {
  const r = E.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(t, n + r, {
      value: function(s, i, a) {
        return this[n].call(this, e, s, i, a);
      },
      configurable: !0
    });
  });
}
class ke {
  constructor(e) {
    e && this.set(e);
  }
  set(e, r, n) {
    const s = this;
    function i(o, l, c) {
      const u = Fr(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const d = E.findKey(s, u);
      (!d || s[d] === void 0 || c === !0 || c === void 0 && s[d] !== !1) && (s[d || l] = Sn(o));
    }
    const a = (o, l) => E.forEach(o, (c, u) => i(c, u, l));
    if (E.isPlainObject(e) || e instanceof this.constructor)
      a(e, r);
    else if (E.isString(e) && (e = e.trim()) && !Of(e))
      a(Ef(e), r);
    else if (E.isHeaders(e))
      for (const [o, l] of e.entries())
        i(l, o, n);
    else
      e != null && i(r, e, n);
    return this;
  }
  get(e, r) {
    if (e = Fr(e), e) {
      const n = E.findKey(this, e);
      if (n) {
        const s = this[n];
        if (!r)
          return s;
        if (r === !0)
          return Cf(s);
        if (E.isFunction(r))
          return r.call(this, s, n);
        if (E.isRegExp(r))
          return r.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, r) {
    if (e = Fr(e), e) {
      const n = E.findKey(this, e);
      return !!(n && this[n] !== void 0 && (!r || os(this, this[n], n, r)));
    }
    return !1;
  }
  delete(e, r) {
    const n = this;
    let s = !1;
    function i(a) {
      if (a = Fr(a), a) {
        const o = E.findKey(n, a);
        o && (!r || os(n, n[o], o, r)) && (delete n[o], s = !0);
      }
    }
    return E.isArray(e) ? e.forEach(i) : i(e), s;
  }
  clear(e) {
    const r = Object.keys(this);
    let n = r.length, s = !1;
    for (; n--; ) {
      const i = r[n];
      (!e || os(this, this[i], i, e, !0)) && (delete this[i], s = !0);
    }
    return s;
  }
  normalize(e) {
    const r = this, n = {};
    return E.forEach(this, (s, i) => {
      const a = E.findKey(n, i);
      if (a) {
        r[a] = Sn(s), delete r[i];
        return;
      }
      const o = e ? Rf(i) : String(i).trim();
      o !== i && delete r[i], r[o] = Sn(s), n[o] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const r = /* @__PURE__ */ Object.create(null);
    return E.forEach(this, (n, s) => {
      n != null && n !== !1 && (r[s] = e && E.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, r]) => e + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...r) {
    const n = new this(e);
    return r.forEach((s) => n.set(s)), n;
  }
  static accessor(e) {
    const n = (this[ya] = this[ya] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function i(a) {
      const o = Fr(a);
      n[o] || (_f(s, a), n[o] = !0);
    }
    return E.isArray(e) ? e.forEach(i) : i(e), this;
  }
}
ke.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
E.reduceDescriptors(ke.prototype, ({ value: t }, e) => {
  let r = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(n) {
      this[r] = n;
    }
  };
});
E.freezeMethods(ke);
function ls(t, e) {
  const r = this || cn, n = e || r, s = ke.from(n.headers);
  let i = n.data;
  return E.forEach(t, function(o) {
    i = o.call(r, i, s.normalize(), e ? e.status : void 0);
  }), s.normalize(), i;
}
function Jo(t) {
  return !!(t && t.__CANCEL__);
}
function Sr(t, e, r) {
  V.call(this, t ?? "canceled", V.ERR_CANCELED, e, r), this.name = "CanceledError";
}
E.inherits(Sr, V, {
  __CANCEL__: !0
});
function Zo(t, e, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? t(r) : e(new V(
    "Request failed with status code " + r.status,
    [V.ERR_BAD_REQUEST, V.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function Pf(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function Tf(t, e) {
  t = t || 10;
  const r = new Array(t), n = new Array(t);
  let s = 0, i = 0, a;
  return e = e !== void 0 ? e : 1e3, function(l) {
    const c = Date.now(), u = n[i];
    a || (a = c), r[s] = l, n[s] = c;
    let d = i, h = 0;
    for (; d !== s; )
      h += r[d++], d = d % t;
    if (s = (s + 1) % t, s === i && (i = (i + 1) % t), c - a < e)
      return;
    const m = u && c - u;
    return m ? Math.round(h * 1e3 / m) : void 0;
  };
}
function Nf(t, e) {
  let r = 0, n = 1e3 / e, s, i;
  const a = (c, u = Date.now()) => {
    r = u, s = null, i && (clearTimeout(i), i = null), t.apply(null, c);
  };
  return [(...c) => {
    const u = Date.now(), d = u - r;
    d >= n ? a(c, u) : (s = c, i || (i = setTimeout(() => {
      i = null, a(s);
    }, n - d)));
  }, () => s && a(s)];
}
const jn = (t, e, r = 3) => {
  let n = 0;
  const s = Tf(50, 250);
  return Nf((i) => {
    const a = i.loaded, o = i.lengthComputable ? i.total : void 0, l = a - n, c = s(l), u = a <= o;
    n = a;
    const d = {
      loaded: a,
      total: o,
      progress: o ? a / o : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && o && u ? (o - a) / c : void 0,
      event: i,
      lengthComputable: o != null,
      [e ? "download" : "upload"]: !0
    };
    t(d);
  }, r);
}, ba = (t, e) => {
  const r = t != null;
  return [(n) => e[0]({
    lengthComputable: r,
    total: t,
    loaded: n
  }), e[1]];
}, va = (t) => (...e) => E.asap(() => t(...e)), jf = Qe.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const e = /(msie|trident)/i.test(navigator.userAgent), r = document.createElement("a");
    let n;
    function s(i) {
      let a = i;
      return e && (r.setAttribute("href", a), a = r.href), r.setAttribute("href", a), {
        href: r.href,
        protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
        host: r.host,
        search: r.search ? r.search.replace(/^\?/, "") : "",
        hash: r.hash ? r.hash.replace(/^#/, "") : "",
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
      };
    }
    return n = s(window.location.href), function(a) {
      const o = E.isString(a) ? s(a) : a;
      return o.protocol === n.protocol && o.host === n.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), Df = Qe.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, e, r, n, s, i) {
      const a = [t + "=" + encodeURIComponent(e)];
      E.isNumber(r) && a.push("expires=" + new Date(r).toGMTString()), E.isString(n) && a.push("path=" + n), E.isString(s) && a.push("domain=" + s), i === !0 && a.push("secure"), document.cookie = a.join("; ");
    },
    read(t) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Ff(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function Af(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function el(t, e) {
  return t && !Ff(e) ? Af(t, e) : e;
}
const wa = (t) => t instanceof ke ? { ...t } : t;
function Ht(t, e) {
  e = e || {};
  const r = {};
  function n(c, u, d) {
    return E.isPlainObject(c) && E.isPlainObject(u) ? E.merge.call({ caseless: d }, c, u) : E.isPlainObject(u) ? E.merge({}, u) : E.isArray(u) ? u.slice() : u;
  }
  function s(c, u, d) {
    if (E.isUndefined(u)) {
      if (!E.isUndefined(c))
        return n(void 0, c, d);
    } else
      return n(c, u, d);
  }
  function i(c, u) {
    if (!E.isUndefined(u))
      return n(void 0, u);
  }
  function a(c, u) {
    if (E.isUndefined(u)) {
      if (!E.isUndefined(c))
        return n(void 0, c);
    } else
      return n(void 0, u);
  }
  function o(c, u, d) {
    if (d in e)
      return n(c, u);
    if (d in t)
      return n(void 0, c);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    withXSRFToken: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: o,
    headers: (c, u) => s(wa(c), wa(u), !0)
  };
  return E.forEach(Object.keys(Object.assign({}, t, e)), function(u) {
    const d = l[u] || s, h = d(t[u], e[u], u);
    E.isUndefined(h) && d !== o || (r[u] = h);
  }), r;
}
const tl = (t) => {
  const e = Ht({}, t);
  let { data: r, withXSRFToken: n, xsrfHeaderName: s, xsrfCookieName: i, headers: a, auth: o } = e;
  e.headers = a = ke.from(a), e.url = Yo(el(e.baseURL, e.url), t.params, t.paramsSerializer), o && a.set(
    "Authorization",
    "Basic " + btoa((o.username || "") + ":" + (o.password ? unescape(encodeURIComponent(o.password)) : ""))
  );
  let l;
  if (E.isFormData(r)) {
    if (Qe.hasStandardBrowserEnv || Qe.hasStandardBrowserWebWorkerEnv)
      a.setContentType(void 0);
    else if ((l = a.getContentType()) !== !1) {
      const [c, ...u] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      a.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (Qe.hasStandardBrowserEnv && (n && E.isFunction(n) && (n = n(e)), n || n !== !1 && jf(e.url))) {
    const c = s && i && Df.read(i);
    c && a.set(s, c);
  }
  return e;
}, kf = typeof XMLHttpRequest < "u", If = kf && function(t) {
  return new Promise(function(r, n) {
    const s = tl(t);
    let i = s.data;
    const a = ke.from(s.headers).normalize();
    let { responseType: o, onUploadProgress: l, onDownloadProgress: c } = s, u, d, h, m, f;
    function y() {
      m && m(), f && f(), s.cancelToken && s.cancelToken.unsubscribe(u), s.signal && s.signal.removeEventListener("abort", u);
    }
    let p = new XMLHttpRequest();
    p.open(s.method.toUpperCase(), s.url, !0), p.timeout = s.timeout;
    function S() {
      if (!p)
        return;
      const C = ke.from(
        "getAllResponseHeaders" in p && p.getAllResponseHeaders()
      ), j = {
        data: !o || o === "text" || o === "json" ? p.responseText : p.response,
        status: p.status,
        statusText: p.statusText,
        headers: C,
        config: t,
        request: p
      };
      Zo(function(_) {
        r(_), y();
      }, function(_) {
        n(_), y();
      }, j), p = null;
    }
    "onloadend" in p ? p.onloadend = S : p.onreadystatechange = function() {
      !p || p.readyState !== 4 || p.status === 0 && !(p.responseURL && p.responseURL.indexOf("file:") === 0) || setTimeout(S);
    }, p.onabort = function() {
      p && (n(new V("Request aborted", V.ECONNABORTED, t, p)), p = null);
    }, p.onerror = function() {
      n(new V("Network Error", V.ERR_NETWORK, t, p)), p = null;
    }, p.ontimeout = function() {
      let P = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const j = s.transitional || Xo;
      s.timeoutErrorMessage && (P = s.timeoutErrorMessage), n(new V(
        P,
        j.clarifyTimeoutError ? V.ETIMEDOUT : V.ECONNABORTED,
        t,
        p
      )), p = null;
    }, i === void 0 && a.setContentType(null), "setRequestHeader" in p && E.forEach(a.toJSON(), function(P, j) {
      p.setRequestHeader(j, P);
    }), E.isUndefined(s.withCredentials) || (p.withCredentials = !!s.withCredentials), o && o !== "json" && (p.responseType = s.responseType), c && ([h, f] = jn(c, !0), p.addEventListener("progress", h)), l && p.upload && ([d, m] = jn(l), p.upload.addEventListener("progress", d), p.upload.addEventListener("loadend", m)), (s.cancelToken || s.signal) && (u = (C) => {
      p && (n(!C || C.type ? new Sr(null, t, p) : C), p.abort(), p = null);
    }, s.cancelToken && s.cancelToken.subscribe(u), s.signal && (s.signal.aborted ? u() : s.signal.addEventListener("abort", u)));
    const x = Pf(s.url);
    if (x && Qe.protocols.indexOf(x) === -1) {
      n(new V("Unsupported protocol " + x + ":", V.ERR_BAD_REQUEST, t));
      return;
    }
    p.send(i || null);
  });
}, Mf = (t, e) => {
  let r = new AbortController(), n;
  const s = function(l) {
    if (!n) {
      n = !0, a();
      const c = l instanceof Error ? l : this.reason;
      r.abort(c instanceof V ? c : new Sr(c instanceof Error ? c.message : c));
    }
  };
  let i = e && setTimeout(() => {
    s(new V(`timeout ${e} of ms exceeded`, V.ETIMEDOUT));
  }, e);
  const a = () => {
    t && (i && clearTimeout(i), i = null, t.forEach((l) => {
      l && (l.removeEventListener ? l.removeEventListener("abort", s) : l.unsubscribe(s));
    }), t = null);
  };
  t.forEach((l) => l && l.addEventListener && l.addEventListener("abort", s));
  const { signal: o } = r;
  return o.unsubscribe = a, [o, () => {
    i && clearTimeout(i), i = null;
  }];
}, Lf = function* (t, e) {
  let r = t.byteLength;
  if (r < e) {
    yield t;
    return;
  }
  let n = 0, s;
  for (; n < r; )
    s = n + e, yield t.slice(n, s), n = s;
}, Uf = async function* (t, e, r) {
  for await (const n of t)
    yield* Lf(ArrayBuffer.isView(n) ? n : await r(String(n)), e);
}, xa = (t, e, r, n, s) => {
  const i = Uf(t, e, s);
  let a = 0, o, l = (c) => {
    o || (o = !0, n && n(c));
  };
  return new ReadableStream({
    async pull(c) {
      try {
        const { done: u, value: d } = await i.next();
        if (u) {
          l(), c.close();
          return;
        }
        let h = d.byteLength;
        if (r) {
          let m = a += h;
          r(m);
        }
        c.enqueue(new Uint8Array(d));
      } catch (u) {
        throw l(u), u;
      }
    },
    cancel(c) {
      return l(c), i.return();
    }
  }, {
    highWaterMark: 2
  });
}, Wn = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", rl = Wn && typeof ReadableStream == "function", Us = Wn && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((t) => (e) => t.encode(e))(new TextEncoder()) : async (t) => new Uint8Array(await new Response(t).arrayBuffer())), nl = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, zf = rl && nl(() => {
  let t = !1;
  const e = new Request(Qe.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return t = !0, "half";
    }
  }).headers.has("Content-Type");
  return t && !e;
}), Sa = 64 * 1024, zs = rl && nl(() => E.isReadableStream(new Response("").body)), Dn = {
  stream: zs && ((t) => t.body)
};
Wn && ((t) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !Dn[e] && (Dn[e] = E.isFunction(t[e]) ? (r) => r[e]() : (r, n) => {
      throw new V(`Response type '${e}' is not supported`, V.ERR_NOT_SUPPORT, n);
    });
  });
})(new Response());
const Bf = async (t) => {
  if (t == null)
    return 0;
  if (E.isBlob(t))
    return t.size;
  if (E.isSpecCompliantForm(t))
    return (await new Request(t).arrayBuffer()).byteLength;
  if (E.isArrayBufferView(t) || E.isArrayBuffer(t))
    return t.byteLength;
  if (E.isURLSearchParams(t) && (t = t + ""), E.isString(t))
    return (await Us(t)).byteLength;
}, $f = async (t, e) => {
  const r = E.toFiniteNumber(t.getContentLength());
  return r ?? Bf(e);
}, Hf = Wn && (async (t) => {
  let {
    url: e,
    method: r,
    data: n,
    signal: s,
    cancelToken: i,
    timeout: a,
    onDownloadProgress: o,
    onUploadProgress: l,
    responseType: c,
    headers: u,
    withCredentials: d = "same-origin",
    fetchOptions: h
  } = tl(t);
  c = c ? (c + "").toLowerCase() : "text";
  let [m, f] = s || i || a ? Mf([s, i], a) : [], y, p;
  const S = () => {
    !y && setTimeout(() => {
      m && m.unsubscribe();
    }), y = !0;
  };
  let x;
  try {
    if (l && zf && r !== "get" && r !== "head" && (x = await $f(u, n)) !== 0) {
      let w = new Request(e, {
        method: "POST",
        body: n,
        duplex: "half"
      }), _;
      if (E.isFormData(n) && (_ = w.headers.get("content-type")) && u.setContentType(_), w.body) {
        const [O, R] = ba(
          x,
          jn(va(l))
        );
        n = xa(w.body, Sa, O, R, Us);
      }
    }
    E.isString(d) || (d = d ? "include" : "omit"), p = new Request(e, {
      ...h,
      signal: m,
      method: r.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: n,
      duplex: "half",
      credentials: d
    });
    let C = await fetch(p);
    const P = zs && (c === "stream" || c === "response");
    if (zs && (o || P)) {
      const w = {};
      ["status", "statusText", "headers"].forEach((N) => {
        w[N] = C[N];
      });
      const _ = E.toFiniteNumber(C.headers.get("content-length")), [O, R] = o && ba(
        _,
        jn(va(o), !0)
      ) || [];
      C = new Response(
        xa(C.body, Sa, O, () => {
          R && R(), P && S();
        }, Us),
        w
      );
    }
    c = c || "text";
    let j = await Dn[E.findKey(Dn, c) || "text"](C, t);
    return !P && S(), f && f(), await new Promise((w, _) => {
      Zo(w, _, {
        data: j,
        headers: ke.from(C.headers),
        status: C.status,
        statusText: C.statusText,
        config: t,
        request: p
      });
    });
  } catch (C) {
    throw S(), C && C.name === "TypeError" && /fetch/i.test(C.message) ? Object.assign(
      new V("Network Error", V.ERR_NETWORK, t, p),
      {
        cause: C.cause || C
      }
    ) : V.from(C, C && C.code, t, p);
  }
}), Bs = {
  http: af,
  xhr: If,
  fetch: Hf
};
E.forEach(Bs, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const Ea = (t) => `- ${t}`, Wf = (t) => E.isFunction(t) || t === null || t === !1, sl = {
  getAdapter: (t) => {
    t = E.isArray(t) ? t : [t];
    const { length: e } = t;
    let r, n;
    const s = {};
    for (let i = 0; i < e; i++) {
      r = t[i];
      let a;
      if (n = r, !Wf(r) && (n = Bs[(a = String(r)).toLowerCase()], n === void 0))
        throw new V(`Unknown adapter '${a}'`);
      if (n)
        break;
      s[a || "#" + i] = n;
    }
    if (!n) {
      const i = Object.entries(s).map(
        ([o, l]) => `adapter ${o} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let a = e ? i.length > 1 ? `since :
` + i.map(Ea).join(`
`) : " " + Ea(i[0]) : "as no adapter specified";
      throw new V(
        "There is no suitable adapter to dispatch the request " + a,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: Bs
};
function cs(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new Sr(null, t);
}
function Ca(t) {
  return cs(t), t.headers = ke.from(t.headers), t.data = ls.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), sl.getAdapter(t.adapter || cn.adapter)(t).then(function(n) {
    return cs(t), n.data = ls.call(
      t,
      t.transformResponse,
      n
    ), n.headers = ke.from(n.headers), n;
  }, function(n) {
    return Jo(n) || (cs(t), n && n.response && (n.response.data = ls.call(
      t,
      t.transformResponse,
      n.response
    ), n.response.headers = ke.from(n.response.headers))), Promise.reject(n);
  });
}
const il = "1.7.4", ui = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  ui[t] = function(n) {
    return typeof n === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const Oa = {};
ui.transitional = function(e, r, n) {
  function s(i, a) {
    return "[Axios v" + il + "] Transitional option '" + i + "'" + a + (n ? ". " + n : "");
  }
  return (i, a, o) => {
    if (e === !1)
      throw new V(
        s(a, " has been removed" + (r ? " in " + r : "")),
        V.ERR_DEPRECATED
      );
    return r && !Oa[a] && (Oa[a] = !0, console.warn(
      s(
        a,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), e ? e(i, a, o) : !0;
  };
};
function Vf(t, e, r) {
  if (typeof t != "object")
    throw new V("options must be an object", V.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(t);
  let s = n.length;
  for (; s-- > 0; ) {
    const i = n[s], a = e[i];
    if (a) {
      const o = t[i], l = o === void 0 || a(o, i, t);
      if (l !== !0)
        throw new V("option " + i + " must be " + l, V.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new V("Unknown option " + i, V.ERR_BAD_OPTION);
  }
}
const $s = {
  assertOptions: Vf,
  validators: ui
}, ht = $s.validators;
class Bt {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new ga(),
      response: new ga()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, r) {
    try {
      return await this._request(e, r);
    } catch (n) {
      if (n instanceof Error) {
        let s;
        Error.captureStackTrace ? Error.captureStackTrace(s = {}) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? i && !String(n.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + i) : n.stack = i;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(e, r) {
    typeof e == "string" ? (r = r || {}, r.url = e) : r = e || {}, r = Ht(this.defaults, r);
    const { transitional: n, paramsSerializer: s, headers: i } = r;
    n !== void 0 && $s.assertOptions(n, {
      silentJSONParsing: ht.transitional(ht.boolean),
      forcedJSONParsing: ht.transitional(ht.boolean),
      clarifyTimeoutError: ht.transitional(ht.boolean)
    }, !1), s != null && (E.isFunction(s) ? r.paramsSerializer = {
      serialize: s
    } : $s.assertOptions(s, {
      encode: ht.function,
      serialize: ht.function
    }, !0)), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let a = i && E.merge(
      i.common,
      i[r.method]
    );
    i && E.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (f) => {
        delete i[f];
      }
    ), r.headers = ke.concat(a, i);
    const o = [];
    let l = !0;
    this.interceptors.request.forEach(function(y) {
      typeof y.runWhen == "function" && y.runWhen(r) === !1 || (l = l && y.synchronous, o.unshift(y.fulfilled, y.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(y) {
      c.push(y.fulfilled, y.rejected);
    });
    let u, d = 0, h;
    if (!l) {
      const f = [Ca.bind(this), void 0];
      for (f.unshift.apply(f, o), f.push.apply(f, c), h = f.length, u = Promise.resolve(r); d < h; )
        u = u.then(f[d++], f[d++]);
      return u;
    }
    h = o.length;
    let m = r;
    for (d = 0; d < h; ) {
      const f = o[d++], y = o[d++];
      try {
        m = f(m);
      } catch (p) {
        y.call(this, p);
        break;
      }
    }
    try {
      u = Ca.call(this, m);
    } catch (f) {
      return Promise.reject(f);
    }
    for (d = 0, h = c.length; d < h; )
      u = u.then(c[d++], c[d++]);
    return u;
  }
  getUri(e) {
    e = Ht(this.defaults, e);
    const r = el(e.baseURL, e.url);
    return Yo(r, e.params, e.paramsSerializer);
  }
}
E.forEach(["delete", "get", "head", "options"], function(e) {
  Bt.prototype[e] = function(r, n) {
    return this.request(Ht(n || {}, {
      method: e,
      url: r,
      data: (n || {}).data
    }));
  };
});
E.forEach(["post", "put", "patch"], function(e) {
  function r(n) {
    return function(i, a, o) {
      return this.request(Ht(o || {}, {
        method: e,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: a
      }));
    };
  }
  Bt.prototype[e] = r(), Bt.prototype[e + "Form"] = r(!0);
});
class hi {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(i) {
      r = i;
    });
    const n = this;
    this.promise.then((s) => {
      if (!n._listeners)
        return;
      let i = n._listeners.length;
      for (; i-- > 0; )
        n._listeners[i](s);
      n._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const a = new Promise((o) => {
        n.subscribe(o), i = o;
      }).then(s);
      return a.cancel = function() {
        n.unsubscribe(i);
      }, a;
    }, e(function(i, a, o) {
      n.reason || (n.reason = new Sr(i, a, o), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(e);
    r !== -1 && this._listeners.splice(r, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new hi(function(s) {
        e = s;
      }),
      cancel: e
    };
  }
}
function qf(t) {
  return function(r) {
    return t.apply(null, r);
  };
}
function Kf(t) {
  return E.isObject(t) && t.isAxiosError === !0;
}
const Hs = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Hs).forEach(([t, e]) => {
  Hs[e] = t;
});
function al(t) {
  const e = new Bt(t), r = Mo(Bt.prototype.request, e);
  return E.extend(r, Bt.prototype, e, { allOwnKeys: !0 }), E.extend(r, e, null, { allOwnKeys: !0 }), r.create = function(s) {
    return al(Ht(t, s));
  }, r;
}
const pe = al(cn);
pe.Axios = Bt;
pe.CanceledError = Sr;
pe.CancelToken = hi;
pe.isCancel = Jo;
pe.VERSION = il;
pe.toFormData = Hn;
pe.AxiosError = V;
pe.Cancel = pe.CanceledError;
pe.all = function(e) {
  return Promise.all(e);
};
pe.spread = qf;
pe.isAxiosError = Kf;
pe.mergeConfig = Ht;
pe.AxiosHeaders = ke;
pe.formToJSON = (t) => Go(E.isHTMLForm(t) ? new FormData(t) : t);
pe.getAdapter = sl.getAdapter;
pe.HttpStatusCode = Hs;
pe.default = pe;
const Qf = "/api/dashboard/customer", ol = "/api/dashboard/customer/data-files", Yf = `${ol}/validate-and-get-upload-options`, Xf = (t) => `${ol}/${t}/activate-file`, Gf = (t) => `${Qf}/draft-file/${t}`, ll = "/api/data-files", Jf = `${ll}/validate-and-get-upload-options`, Zf = (t) => `${ll}/${t}/activate-file`, ep = (t = !1) => {
  const { fetcher: e } = nr({
    method: tr.post
  }), { fetcher: r } = nr({
    method: tr.post
  }), { fetcher: n } = nr({
    method: tr.delete
  });
  return {
    validateAndGetUploadOptions: async ({
      file: l,
      isCommon: c,
      source: u,
      mimeType: d,
      cancelToken: h
    }) => await e(
      t ? Jf : Yf,
      {
        source: u,
        fileName: l.name,
        fileSize: l.size,
        mimeType: d,
        isCommon: c
      },
      {
        cancelToken: h
      }
    ),
    uploadToFileStore: async ({
      file: l,
      uploadOptions: c,
      progressHandler: u,
      cancelToken: d
    }) => {
      const h = new FormData();
      return h.append("key", c.key), h.append("acl", c.acl), h.append("X-Amz-Credential", c.credential), h.append("X-Amz-Algorithm", c.algorithm), h.append("X-Amz-Date", c.date), h.append("Policy", c.policy), h.append("X-Amz-Signature", c.signature), h.append("Content-Type", c.contentType), h.append("Cache-Control", c.cacheControl), h.append("file", l), await pe.post(c.url, h, {
        onUploadProgress: u,
        cancelToken: d
      });
    },
    activate: async ({
      fileId: l,
      cancelToken: c
    }) => await r(
      t ? Zf(l) : Xf(l),
      {},
      {
        cancelToken: c,
        headers: {
          "Content-Type": "application/json"
        }
      }
    ),
    removeDraftFile: async (l) => await n(Gf(l))
  };
}, tp = () => {
  let t;
  return {
    createToken: () => (t = pe.CancelToken.source(), t.token),
    cancel: () => {
      t && (t.cancel(), t = void 0);
    },
    getToken: () => t == null ? void 0 : t.token
  };
}, rp = ({
  onChange: t
}) => {
  let e = {
    isUploading: !1,
    progress: 0,
    total: 0,
    isUploaded: !1
  };
  const r = () => {
    t(e);
  }, n = () => {
    e = {
      ...e,
      progress: 0,
      total: 0,
      isUploading: !0,
      isUploaded: !1
    }, r();
  }, s = () => {
    e = {
      ...e,
      isUploading: !1,
      isUploaded: !0
    }, r();
  }, i = (l, c) => {
    c && (e = {
      ...e,
      progress: Math.round(l * 100 / c),
      total: c
    }, r());
  };
  return {
    getState: () => e,
    startProgress: n,
    finishProgress: s,
    updateProgress: i,
    resetProgress: () => {
      e = {
        progress: 0,
        total: 0,
        isUploading: !1,
        isUploaded: !1
      }, r();
    },
    progressHandler: (l) => {
      const c = l.loaded, u = l.total;
      i(c, u);
    }
  };
}, np = (t) => {
  const e = t.name.match(/\.[a-zA-Z0-9_-]+$/i);
  switch (e && e[0]) {
    case ft.Docx:
      return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    case ft.Doc:
      return "application/msword";
    case ft.Ttf:
      return "font/ttf";
    case ft.AD_PRT:
      return "application/vnd.alibre.part";
    case ft.AD_SMP:
      return "application/vnd.alibre.sheet_metal_part";
    case ft.AD_ASM:
      return "application/vnd.alibre.assembly";
    case ft.AD_DRW:
      return "application/vnd.alibre.drawing";
    default:
      return t.type;
  }
}, cl = (t) => {
  const { t: e } = Pe(), { validateAndGetUploadOptions: r, uploadToFileStore: n, activate: s, removeDraftFile: i } = ep(t);
  return {
    createFileUploader: (o) => {
      const l = rp({ onChange: o }), c = tp();
      return {
        progress: l,
        upload: async ({
          file: h,
          source: m,
          isCommon: f = !1
        }) => {
          l.startProgress();
          const y = c.createToken();
          let p;
          try {
            const { uploadOptions: S, id: x } = await r({
              file: h,
              isCommon: f,
              source: m,
              mimeType: np(h),
              cancelToken: y
            });
            p = x, await n({
              file: h,
              uploadOptions: S,
              progressHandler: l.progressHandler,
              cancelToken: y
            });
            const C = await s({
              fileId: x,
              cancelToken: y
            });
            return l.finishProgress(), C[x];
          } catch (S) {
            if (pe.isCancel(S)) {
              Me(e("file_manager.cancelled"));
              return;
            }
            throw typeof p == "number" ? await i(p) : Me.error(e("file_manager.error")), S;
          }
        },
        cancelUpload: () => {
          c.cancel(), l.resetProgress();
        }
      };
    }
  };
}, sp = ({
  preLoadedFiles: t,
  source: e,
  usePublicApi: r,
  onChange: n
}) => {
  const { t: s } = Pe(), { createFileUploader: i } = cl(r), { deleteFile: a } = ko(), [o, l] = te([]), [c, u] = te([]), [d, h] = te({}), [m, f] = te([]), y = (O) => {
    const R = t == null ? void 0 : t.map((N) => N.id);
    return R == null ? void 0 : R.includes(O.id);
  }, p = () => c.map((R) => {
    const N = !y(R);
    return {
      file: { ...R, name: R.filename },
      disabled: m.includes(R.id),
      uploaded: N
    };
  }), S = () => Object.entries(d).map(([R, N]) => ({
    file: { ...N, id: R, name: N.file.name },
    progress: N.progress.isUploading ? N.progress.progress : void 0,
    uploaded: N.progress.isUploaded
  })), x = p(), C = S(), P = async (O) => {
    try {
      f((R) => [...R, O]), await a({ id: O }), u((R) => {
        const N = R.filter((k) => k.id !== O);
        return n == null || n(N), N;
      });
    } catch (R) {
      throw R;
    } finally {
      f((R) => R.filter((N) => N !== O));
    }
  }, j = (O) => {
    d[O].cancelUpload(), h((R) => {
      const { [O]: N, ...k } = R;
      return k;
    });
  };
  return {
    waitingUploadFiles: o,
    setWaitingUploadFiles: l,
    removingFiles: m,
    uploadedFiles: c,
    setUploadedFiles: u,
    mappedUploadedFiles: x,
    mappedUploadingFiles: C,
    startUploading: async (O) => {
      const R = await dh(O) + "_" + crypto.randomUUID(), k = i((D) => {
        h((z) => ({
          ...z,
          [R]: {
            ...z[R],
            progress: D
          }
        }));
      });
      l((D) => D.filter((z) => z.file !== O)), h((D) => ({
        ...D,
        [R]: {
          file: O,
          progress: k.progress.getState(),
          cancelUpload: k.cancelUpload
        }
      }));
      try {
        const D = await k.upload({ file: O, source: e });
        if (D)
          return u((z) => {
            const U = [{ ...D, file: O }, ...z];
            return n == null || n(U), U;
          }), D;
      } catch (D) {
        const z = D instanceof Error ? D : new Error(s("file_manager.error"));
        throw l((U) => [{ file: O, error: z }, ...U]), D;
      } finally {
        h((D) => {
          const { [R]: z, ...U } = D;
          return U;
        });
      }
    },
    deleteUploadedOrUploadingFile: async (O) => {
      d[O] && await j(String(O)), c.find((k) => k.id === +O) && await P(Number(O));
    },
    deleteUploadedFile: P,
    deleteUploadingFile: j
  };
}, ip = (t) => t instanceof File, ap = (t) => "id" in t && "file" in t, op = (t) => "id" in t && "path" in t && "size" in t && "type" in t && "filename" in t && "thumbnail" in t, lp = ({ progress: t }) => {
  const r = 2 * Math.PI * 14, n = r * (1 - t / 100);
  return /* @__PURE__ */ v.jsxs("div", { className: "relative w-8 h-8", children: [
    /* @__PURE__ */ v.jsx("svg", { className: "w-full h-full", children: /* @__PURE__ */ v.jsx(
      "circle",
      {
        cx: "50%",
        cy: "50%",
        r: 14,
        className: "stroke-text-secondary fill-none",
        strokeWidth: "3"
      }
    ) }),
    /* @__PURE__ */ v.jsx("svg", { className: "absolute top-0 left-0 w-full h-full", children: /* @__PURE__ */ v.jsx(
      "circle",
      {
        cx: "50%",
        cy: "50%",
        r: 14,
        className: "stroke-background-secondary fill-none transition-all duration-300",
        strokeWidth: "3",
        strokeDasharray: r,
        strokeDashoffset: n,
        transform: "rotate(-90 16 16)"
      }
    ) })
  ] });
};
function us({
  file: t,
  progress: e = 0,
  isError: r,
  isLoading: n,
  isLoaded: s,
  isDeleting: i,
  className: a,
  disabled: o,
  disabledDeleteButton: l,
  showDeleteButton: c,
  showEditButton: u,
  onDeleteFile: d,
  onEdit: h
}) {
  return /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: ge("relative w-24 h-24", a),
      onClick: (m) => m.stopPropagation(),
      children: [
        c && /* @__PURE__ */ v.jsx(
          "button",
          {
            type: "button",
            className: ge(
              "absolute group -top-2 -right-2 z-1 rounded-full bg-background-primary",
              i && "animate-pulse"
            ),
            onClick: (m) => {
              m.preventDefault(), m.stopPropagation(), d();
            },
            disabled: l || o,
            children: /* @__PURE__ */ v.jsx(
              Pi,
              {
                className: ge(
                  "fill-text-secondary transition-colors",
                  !l && !o && "group-hover:fill-brand-primary"
                )
              }
            )
          }
        ),
        /* @__PURE__ */ v.jsxs("div", { className: "relative w-full h-full group/edit", children: [
          t instanceof File ? /* @__PURE__ */ v.jsx(vo, { file: t, className: "w-full h-full rounded-md" }) : /* @__PURE__ */ v.jsx(
            zt,
            {
              src: t.thumbnail || t.path,
              fileType: t.type,
              isThumbnail: !0,
              className: "w-full h-full rounded-md",
              title: t.filename
            }
          ),
          /* @__PURE__ */ v.jsx(
            "div",
            {
              className: ge(
                "absolute top-0 left-0 w-full h-full justify-center items-center backdrop-blur-md bg-background-secondary/20 rounded-md cursor-auto hidden",
                u && !o && "flex lg:hidden group-hover/edit:lg:flex"
              ),
              children: /* @__PURE__ */ v.jsx("div", { onClick: h, className: "cursor-pointer group p-2", children: /* @__PURE__ */ v.jsx(ac, { className: "fill-background-secondary group-hover:fill-brand-primary transition-colors" }) })
            }
          )
        ] }),
        r && /* @__PURE__ */ v.jsx("div", { className: "absolute top-0 left-0 flex w-full h-full justify-center items-center backdrop-blur-md bg-background-secondary/20 rounded-md", children: /* @__PURE__ */ v.jsx(Pi, { className: "fill-danger rounded-full" }) }),
        n && /* @__PURE__ */ v.jsx("div", { className: "absolute top-0 left-0 flex w-full h-full justify-center items-center backdrop-blur-md bg-background-secondary/20 rounded-md", children: /* @__PURE__ */ v.jsx(lp, { progress: e }) })
      ]
    }
  );
}
var ul = /* @__PURE__ */ ((t) => (t[t.Small = 0] = "Small", t[t.Medium = 1] = "Medium", t[t.Big = 2] = "Big", t))(ul || {});
const cp = {
  0: "p-2",
  1: "p-3",
  2: "p-10"
};
function hl({
  acceptTypes: t,
  children: e,
  dropZoneClassName: r,
  className: n,
  disabled: s,
  error: i,
  variant: a = ul.Medium,
  label: o,
  icon: l = /* @__PURE__ */ v.jsx(oc, {}),
  isPreFetching: c,
  toastText: u,
  labelClassName: d,
  openNativeWindow: h = !0,
  onSelectFile: m,
  onClick: f
}) {
  const { t: y } = Pe(), p = Le(null), [S, x] = te(!1), [C, P] = te(""), j = (N) => {
    var k;
    N.preventDefault(), !s && (f == null || f(), h && ((k = p.current) == null || k.click()));
  }, w = (N) => {
    if (N.target.files && N.target.files[0]) {
      const k = N.target.files[0];
      t && !ta(k.type, t) ? P(y("file_manager.file_upload.file_not_supported")) : (m(k), u && Me.success(u));
    }
    N.target.value = "";
  }, _ = (N) => {
    N.preventDefault(), x(!0);
  }, O = (N) => {
    N.preventDefault(), x(!1);
  }, R = (N) => {
    N.preventDefault(), N.stopPropagation();
    const { files: k } = N.dataTransfer;
    if (k && k.length) {
      const D = k[0];
      t && !ta(D.type, t) ? P(y("file_manager.file_upload.file_not_supported")) : (m(D), u && Me.success(u));
    }
    x(!1);
  };
  return /* @__PURE__ */ v.jsxs("div", { className: ge("font-medium", n), children: [
    /* @__PURE__ */ v.jsx(
      "input",
      {
        ref: p,
        type: "file",
        className: "invisible absolute h-1 w-0",
        onChange: w,
        disabled: c || s,
        accept: t && fh(t)
      }
    ),
    /* @__PURE__ */ v.jsxs(
      "button",
      {
        type: "button",
        className: ge(
          "bg-background-primary ring-brand-primary flex min-h-[60px] w-full flex-row flex-wrap gap-3 rounded-lg border border-dashed outline-hidden ring-offset-1 focus-visible:ring-2",
          S ? "border-brand-primary" : "border-text-secondary",
          cp[a],
          c && "animate-pulse",
          s || c ? "pointer-events-none" : "hover:border-brand-primary cursor-pointer",
          r
        ),
        onDragStart: _,
        onDragLeave: O,
        onDrop: R,
        onDragOver: _,
        onClick: j,
        children: [
          !!Xl.count(e) && /* @__PURE__ */ v.jsx("div", { className: "flex w-full flex-wrap gap-3", children: e }),
          /* @__PURE__ */ v.jsxs(
            "div",
            {
              className: ge(
                "flex w-full flex-col items-center justify-center gap-1",
                d
              ),
              children: [
                l,
                o ?? y("file_manager.file_upload.drop_files_here")
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ v.jsx(En, { error: C, errorClassName: "text-center mt-2" }),
    /* @__PURE__ */ v.jsx(En, { error: i, errorClassName: "text-center mt-2" })
  ] });
}
/*!
 * Cropper.js v1.6.2
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2024-04-21T07:43:05.335Z
 */
function Ra(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function dl(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ra(Object(r), !0).forEach(function(n) {
      fp(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ra(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function up(t, e) {
  if (typeof t != "object" || !t)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function fl(t) {
  var e = up(t, "string");
  return typeof e == "symbol" ? e : e + "";
}
function Ws(t) {
  "@babel/helpers - typeof";
  return Ws = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ws(t);
}
function hp(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function _a(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, fl(n.key), n);
  }
}
function dp(t, e, r) {
  return e && _a(t.prototype, e), r && _a(t, r), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function fp(t, e, r) {
  return e = fl(e), e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function pl(t) {
  return pp(t) || mp(t) || gp(t) || yp();
}
function pp(t) {
  if (Array.isArray(t))
    return Vs(t);
}
function mp(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function gp(t, e) {
  if (t) {
    if (typeof t == "string")
      return Vs(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
      return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Vs(t, e);
  }
}
function Vs(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function yp() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Vn = typeof window < "u" && typeof window.document < "u", rt = Vn ? window : {}, di = Vn && rt.document.documentElement ? "ontouchstart" in rt.document.documentElement : !1, fi = Vn ? "PointerEvent" in rt : !1, ue = "cropper", pi = "all", ml = "crop", gl = "move", yl = "zoom", Pt = "e", Tt = "w", Jt = "s", dt = "n", Ar = "ne", kr = "nw", Ir = "se", Mr = "sw", qs = "".concat(ue, "-crop"), Pa = "".concat(ue, "-disabled"), Fe = "".concat(ue, "-hidden"), Ta = "".concat(ue, "-hide"), bp = "".concat(ue, "-invisible"), Fn = "".concat(ue, "-modal"), Ks = "".concat(ue, "-move"), qr = "".concat(ue, "Action"), vn = "".concat(ue, "Preview"), mi = "crop", bl = "move", vl = "none", Qs = "crop", Ys = "cropend", Xs = "cropmove", Gs = "cropstart", Na = "dblclick", vp = di ? "touchstart" : "mousedown", wp = di ? "touchmove" : "mousemove", xp = di ? "touchend touchcancel" : "mouseup", ja = fi ? "pointerdown" : vp, Da = fi ? "pointermove" : wp, Fa = fi ? "pointerup pointercancel" : xp, Aa = "ready", ka = "resize", Ia = "wheel", Js = "zoom", Ma = "image/jpeg", Sp = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/, Ep = /^data:/, Cp = /^data:image\/jpeg;base64,/, Op = /^img|canvas$/i, wl = 200, xl = 100, La = {
  // Define the view mode of the cropper
  viewMode: 0,
  // 0, 1, 2, 3
  // Define the dragging mode of the cropper
  dragMode: mi,
  // 'crop', 'move' or 'none'
  // Define the initial aspect ratio of the crop box
  initialAspectRatio: NaN,
  // Define the aspect ratio of the crop box
  aspectRatio: NaN,
  // An object with the previous cropping result data
  data: null,
  // A selector for adding extra containers to preview
  preview: "",
  // Re-render the cropper when resize the window
  responsive: !0,
  // Restore the cropped area after resize the window
  restore: !0,
  // Check if the current image is a cross-origin image
  checkCrossOrigin: !0,
  // Check the current image's Exif Orientation information
  checkOrientation: !0,
  // Show the black modal
  modal: !0,
  // Show the dashed lines for guiding
  guides: !0,
  // Show the center indicator for guiding
  center: !0,
  // Show the white modal to highlight the crop box
  highlight: !0,
  // Show the grid background
  background: !0,
  // Enable to crop the image automatically when initialize
  autoCrop: !0,
  // Define the percentage of automatic cropping area when initializes
  autoCropArea: 0.8,
  // Enable to move the image
  movable: !0,
  // Enable to rotate the image
  rotatable: !0,
  // Enable to scale the image
  scalable: !0,
  // Enable to zoom the image
  zoomable: !0,
  // Enable to zoom the image by dragging touch
  zoomOnTouch: !0,
  // Enable to zoom the image by wheeling mouse
  zoomOnWheel: !0,
  // Define zoom ratio when zoom the image by wheeling mouse
  wheelZoomRatio: 0.1,
  // Enable to move the crop box
  cropBoxMovable: !0,
  // Enable to resize the crop box
  cropBoxResizable: !0,
  // Toggle drag mode between "crop" and "move" when click twice on the cropper
  toggleDragModeOnDblclick: !0,
  // Size limitation
  minCanvasWidth: 0,
  minCanvasHeight: 0,
  minCropBoxWidth: 0,
  minCropBoxHeight: 0,
  minContainerWidth: wl,
  minContainerHeight: xl,
  // Shortcuts of events
  ready: null,
  cropstart: null,
  cropmove: null,
  cropend: null,
  crop: null,
  zoom: null
}, Rp = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>', _p = Number.isNaN || rt.isNaN;
function X(t) {
  return typeof t == "number" && !_p(t);
}
var Ua = function(e) {
  return e > 0 && e < 1 / 0;
};
function hs(t) {
  return typeof t > "u";
}
function Wt(t) {
  return Ws(t) === "object" && t !== null;
}
var Pp = Object.prototype.hasOwnProperty;
function Zt(t) {
  if (!Wt(t))
    return !1;
  try {
    var e = t.constructor, r = e.prototype;
    return e && r && Pp.call(r, "isPrototypeOf");
  } catch {
    return !1;
  }
}
function De(t) {
  return typeof t == "function";
}
var Tp = Array.prototype.slice;
function Sl(t) {
  return Array.from ? Array.from(t) : Tp.call(t);
}
function ve(t, e) {
  return t && De(e) && (Array.isArray(t) || X(t.length) ? Sl(t).forEach(function(r, n) {
    e.call(t, r, n, t);
  }) : Wt(t) && Object.keys(t).forEach(function(r) {
    e.call(t, t[r], r, t);
  })), t;
}
var he = Object.assign || function(e) {
  for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++)
    n[s - 1] = arguments[s];
  return Wt(e) && n.length > 0 && n.forEach(function(i) {
    Wt(i) && Object.keys(i).forEach(function(a) {
      e[a] = i[a];
    });
  }), e;
}, Np = /\.\d*(?:0|9){12}\d*$/;
function ir(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return Np.test(t) ? Math.round(t * e) / e : t;
}
var jp = /^width|height|left|top|marginLeft|marginTop$/;
function St(t, e) {
  var r = t.style;
  ve(e, function(n, s) {
    jp.test(s) && X(n) && (n = "".concat(n, "px")), r[s] = n;
  });
}
function Dp(t, e) {
  return t.classList ? t.classList.contains(e) : t.className.indexOf(e) > -1;
}
function we(t, e) {
  if (e) {
    if (X(t.length)) {
      ve(t, function(n) {
        we(n, e);
      });
      return;
    }
    if (t.classList) {
      t.classList.add(e);
      return;
    }
    var r = t.className.trim();
    r ? r.indexOf(e) < 0 && (t.className = "".concat(r, " ").concat(e)) : t.className = e;
  }
}
function tt(t, e) {
  if (e) {
    if (X(t.length)) {
      ve(t, function(r) {
        tt(r, e);
      });
      return;
    }
    if (t.classList) {
      t.classList.remove(e);
      return;
    }
    t.className.indexOf(e) >= 0 && (t.className = t.className.replace(e, ""));
  }
}
function er(t, e, r) {
  if (e) {
    if (X(t.length)) {
      ve(t, function(n) {
        er(n, e, r);
      });
      return;
    }
    r ? we(t, e) : tt(t, e);
  }
}
var Fp = /([a-z\d])([A-Z])/g;
function gi(t) {
  return t.replace(Fp, "$1-$2").toLowerCase();
}
function Zs(t, e) {
  return Wt(t[e]) ? t[e] : t.dataset ? t.dataset[e] : t.getAttribute("data-".concat(gi(e)));
}
function Kr(t, e, r) {
  Wt(r) ? t[e] = r : t.dataset ? t.dataset[e] = r : t.setAttribute("data-".concat(gi(e)), r);
}
function Ap(t, e) {
  if (Wt(t[e]))
    try {
      delete t[e];
    } catch {
      t[e] = void 0;
    }
  else if (t.dataset)
    try {
      delete t.dataset[e];
    } catch {
      t.dataset[e] = void 0;
    }
  else
    t.removeAttribute("data-".concat(gi(e)));
}
var El = /\s\s*/, Cl = function() {
  var t = !1;
  if (Vn) {
    var e = !1, r = function() {
    }, n = Object.defineProperty({}, "once", {
      get: function() {
        return t = !0, e;
      },
      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: function(i) {
        e = i;
      }
    });
    rt.addEventListener("test", r, n), rt.removeEventListener("test", r, n);
  }
  return t;
}();
function Ve(t, e, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, s = r;
  e.trim().split(El).forEach(function(i) {
    if (!Cl) {
      var a = t.listeners;
      a && a[i] && a[i][r] && (s = a[i][r], delete a[i][r], Object.keys(a[i]).length === 0 && delete a[i], Object.keys(a).length === 0 && delete t.listeners);
    }
    t.removeEventListener(i, s, n);
  });
}
function Be(t, e, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, s = r;
  e.trim().split(El).forEach(function(i) {
    if (n.once && !Cl) {
      var a = t.listeners, o = a === void 0 ? {} : a;
      s = function() {
        delete o[i][r], t.removeEventListener(i, s, n);
        for (var c = arguments.length, u = new Array(c), d = 0; d < c; d++)
          u[d] = arguments[d];
        r.apply(t, u);
      }, o[i] || (o[i] = {}), o[i][r] && t.removeEventListener(i, o[i][r], n), o[i][r] = s, t.listeners = o;
    }
    t.addEventListener(i, s, n);
  });
}
function ar(t, e, r) {
  var n;
  return De(Event) && De(CustomEvent) ? n = new CustomEvent(e, {
    detail: r,
    bubbles: !0,
    cancelable: !0
  }) : (n = document.createEvent("CustomEvent"), n.initCustomEvent(e, !0, !0, r)), t.dispatchEvent(n);
}
function Ol(t) {
  var e = t.getBoundingClientRect();
  return {
    left: e.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: e.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
var ds = rt.location, kp = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
function za(t) {
  var e = t.match(kp);
  return e !== null && (e[1] !== ds.protocol || e[2] !== ds.hostname || e[3] !== ds.port);
}
function Ba(t) {
  var e = "timestamp=".concat((/* @__PURE__ */ new Date()).getTime());
  return t + (t.indexOf("?") === -1 ? "?" : "&") + e;
}
function zr(t) {
  var e = t.rotate, r = t.scaleX, n = t.scaleY, s = t.translateX, i = t.translateY, a = [];
  X(s) && s !== 0 && a.push("translateX(".concat(s, "px)")), X(i) && i !== 0 && a.push("translateY(".concat(i, "px)")), X(e) && e !== 0 && a.push("rotate(".concat(e, "deg)")), X(r) && r !== 1 && a.push("scaleX(".concat(r, ")")), X(n) && n !== 1 && a.push("scaleY(".concat(n, ")"));
  var o = a.length ? a.join(" ") : "none";
  return {
    WebkitTransform: o,
    msTransform: o,
    transform: o
  };
}
function Ip(t) {
  var e = dl({}, t), r = 0;
  return ve(t, function(n, s) {
    delete e[s], ve(e, function(i) {
      var a = Math.abs(n.startX - i.startX), o = Math.abs(n.startY - i.startY), l = Math.abs(n.endX - i.endX), c = Math.abs(n.endY - i.endY), u = Math.sqrt(a * a + o * o), d = Math.sqrt(l * l + c * c), h = (d - u) / u;
      Math.abs(h) > Math.abs(r) && (r = h);
    });
  }), r;
}
function wn(t, e) {
  var r = t.pageX, n = t.pageY, s = {
    endX: r,
    endY: n
  };
  return e ? s : dl({
    startX: r,
    startY: n
  }, s);
}
function Mp(t) {
  var e = 0, r = 0, n = 0;
  return ve(t, function(s) {
    var i = s.startX, a = s.startY;
    e += i, r += a, n += 1;
  }), e /= n, r /= n, {
    pageX: e,
    pageY: r
  };
}
function Et(t) {
  var e = t.aspectRatio, r = t.height, n = t.width, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "contain", i = Ua(n), a = Ua(r);
  if (i && a) {
    var o = r * e;
    s === "contain" && o > n || s === "cover" && o < n ? r = n / e : n = r * e;
  } else
    i ? r = n / e : a && (n = r * e);
  return {
    width: n,
    height: r
  };
}
function Lp(t) {
  var e = t.width, r = t.height, n = t.degree;
  if (n = Math.abs(n) % 180, n === 90)
    return {
      width: r,
      height: e
    };
  var s = n % 90 * Math.PI / 180, i = Math.sin(s), a = Math.cos(s), o = e * a + r * i, l = e * i + r * a;
  return n > 90 ? {
    width: l,
    height: o
  } : {
    width: o,
    height: l
  };
}
function Up(t, e, r, n) {
  var s = e.aspectRatio, i = e.naturalWidth, a = e.naturalHeight, o = e.rotate, l = o === void 0 ? 0 : o, c = e.scaleX, u = c === void 0 ? 1 : c, d = e.scaleY, h = d === void 0 ? 1 : d, m = r.aspectRatio, f = r.naturalWidth, y = r.naturalHeight, p = n.fillColor, S = p === void 0 ? "transparent" : p, x = n.imageSmoothingEnabled, C = x === void 0 ? !0 : x, P = n.imageSmoothingQuality, j = P === void 0 ? "low" : P, w = n.maxWidth, _ = w === void 0 ? 1 / 0 : w, O = n.maxHeight, R = O === void 0 ? 1 / 0 : O, N = n.minWidth, k = N === void 0 ? 0 : N, D = n.minHeight, z = D === void 0 ? 0 : D, U = document.createElement("canvas"), M = U.getContext("2d"), re = Et({
    aspectRatio: m,
    width: _,
    height: R
  }), ce = Et({
    aspectRatio: m,
    width: k,
    height: z
  }, "cover"), $ = Math.min(re.width, Math.max(ce.width, f)), K = Math.min(re.height, Math.max(ce.height, y)), ne = Et({
    aspectRatio: s,
    width: _,
    height: R
  }), W = Et({
    aspectRatio: s,
    width: k,
    height: z
  }, "cover"), A = Math.min(ne.width, Math.max(W.width, i)), Q = Math.min(ne.height, Math.max(W.height, a)), Z = [-A / 2, -Q / 2, A, Q];
  return U.width = ir($), U.height = ir(K), M.fillStyle = S, M.fillRect(0, 0, $, K), M.save(), M.translate($ / 2, K / 2), M.rotate(l * Math.PI / 180), M.scale(u, h), M.imageSmoothingEnabled = C, M.imageSmoothingQuality = j, M.drawImage.apply(M, [t].concat(pl(Z.map(function(Te) {
    return Math.floor(ir(Te));
  })))), M.restore(), U;
}
var Rl = String.fromCharCode;
function zp(t, e, r) {
  var n = "";
  r += e;
  for (var s = e; s < r; s += 1)
    n += Rl(t.getUint8(s));
  return n;
}
var Bp = /^data:.*,/;
function $p(t) {
  var e = t.replace(Bp, ""), r = atob(e), n = new ArrayBuffer(r.length), s = new Uint8Array(n);
  return ve(s, function(i, a) {
    s[a] = r.charCodeAt(a);
  }), n;
}
function Hp(t, e) {
  for (var r = [], n = 8192, s = new Uint8Array(t); s.length > 0; )
    r.push(Rl.apply(null, Sl(s.subarray(0, n)))), s = s.subarray(n);
  return "data:".concat(e, ";base64,").concat(btoa(r.join("")));
}
function Wp(t) {
  var e = new DataView(t), r;
  try {
    var n, s, i;
    if (e.getUint8(0) === 255 && e.getUint8(1) === 216)
      for (var a = e.byteLength, o = 2; o + 1 < a; ) {
        if (e.getUint8(o) === 255 && e.getUint8(o + 1) === 225) {
          s = o;
          break;
        }
        o += 1;
      }
    if (s) {
      var l = s + 4, c = s + 10;
      if (zp(e, l, 4) === "Exif") {
        var u = e.getUint16(c);
        if (n = u === 18761, (n || u === 19789) && e.getUint16(c + 2, n) === 42) {
          var d = e.getUint32(c + 4, n);
          d >= 8 && (i = c + d);
        }
      }
    }
    if (i) {
      var h = e.getUint16(i, n), m, f;
      for (f = 0; f < h; f += 1)
        if (m = i + f * 12 + 2, e.getUint16(m, n) === 274) {
          m += 8, r = e.getUint16(m, n), e.setUint16(m, 1, n);
          break;
        }
    }
  } catch {
    r = 1;
  }
  return r;
}
function Vp(t) {
  var e = 0, r = 1, n = 1;
  switch (t) {
    case 2:
      r = -1;
      break;
    case 3:
      e = -180;
      break;
    case 4:
      n = -1;
      break;
    case 5:
      e = 90, n = -1;
      break;
    case 6:
      e = 90;
      break;
    case 7:
      e = 90, r = -1;
      break;
    case 8:
      e = -90;
      break;
  }
  return {
    rotate: e,
    scaleX: r,
    scaleY: n
  };
}
var qp = {
  render: function() {
    this.initContainer(), this.initCanvas(), this.initCropBox(), this.renderCanvas(), this.cropped && this.renderCropBox();
  },
  initContainer: function() {
    var e = this.element, r = this.options, n = this.container, s = this.cropper, i = Number(r.minContainerWidth), a = Number(r.minContainerHeight);
    we(s, Fe), tt(e, Fe);
    var o = {
      width: Math.max(n.offsetWidth, i >= 0 ? i : wl),
      height: Math.max(n.offsetHeight, a >= 0 ? a : xl)
    };
    this.containerData = o, St(s, {
      width: o.width,
      height: o.height
    }), we(e, Fe), tt(s, Fe);
  },
  // Canvas (image wrapper)
  initCanvas: function() {
    var e = this.containerData, r = this.imageData, n = this.options.viewMode, s = Math.abs(r.rotate) % 180 === 90, i = s ? r.naturalHeight : r.naturalWidth, a = s ? r.naturalWidth : r.naturalHeight, o = i / a, l = e.width, c = e.height;
    e.height * o > e.width ? n === 3 ? l = e.height * o : c = e.width / o : n === 3 ? c = e.width / o : l = e.height * o;
    var u = {
      aspectRatio: o,
      naturalWidth: i,
      naturalHeight: a,
      width: l,
      height: c
    };
    this.canvasData = u, this.limited = n === 1 || n === 2, this.limitCanvas(!0, !0), u.width = Math.min(Math.max(u.width, u.minWidth), u.maxWidth), u.height = Math.min(Math.max(u.height, u.minHeight), u.maxHeight), u.left = (e.width - u.width) / 2, u.top = (e.height - u.height) / 2, u.oldLeft = u.left, u.oldTop = u.top, this.initialCanvasData = he({}, u);
  },
  limitCanvas: function(e, r) {
    var n = this.options, s = this.containerData, i = this.canvasData, a = this.cropBoxData, o = n.viewMode, l = i.aspectRatio, c = this.cropped && a;
    if (e) {
      var u = Number(n.minCanvasWidth) || 0, d = Number(n.minCanvasHeight) || 0;
      o > 1 ? (u = Math.max(u, s.width), d = Math.max(d, s.height), o === 3 && (d * l > u ? u = d * l : d = u / l)) : o > 0 && (u ? u = Math.max(u, c ? a.width : 0) : d ? d = Math.max(d, c ? a.height : 0) : c && (u = a.width, d = a.height, d * l > u ? u = d * l : d = u / l));
      var h = Et({
        aspectRatio: l,
        width: u,
        height: d
      });
      u = h.width, d = h.height, i.minWidth = u, i.minHeight = d, i.maxWidth = 1 / 0, i.maxHeight = 1 / 0;
    }
    if (r)
      if (o > (c ? 0 : 1)) {
        var m = s.width - i.width, f = s.height - i.height;
        i.minLeft = Math.min(0, m), i.minTop = Math.min(0, f), i.maxLeft = Math.max(0, m), i.maxTop = Math.max(0, f), c && this.limited && (i.minLeft = Math.min(a.left, a.left + (a.width - i.width)), i.minTop = Math.min(a.top, a.top + (a.height - i.height)), i.maxLeft = a.left, i.maxTop = a.top, o === 2 && (i.width >= s.width && (i.minLeft = Math.min(0, m), i.maxLeft = Math.max(0, m)), i.height >= s.height && (i.minTop = Math.min(0, f), i.maxTop = Math.max(0, f))));
      } else
        i.minLeft = -i.width, i.minTop = -i.height, i.maxLeft = s.width, i.maxTop = s.height;
  },
  renderCanvas: function(e, r) {
    var n = this.canvasData, s = this.imageData;
    if (r) {
      var i = Lp({
        width: s.naturalWidth * Math.abs(s.scaleX || 1),
        height: s.naturalHeight * Math.abs(s.scaleY || 1),
        degree: s.rotate || 0
      }), a = i.width, o = i.height, l = n.width * (a / n.naturalWidth), c = n.height * (o / n.naturalHeight);
      n.left -= (l - n.width) / 2, n.top -= (c - n.height) / 2, n.width = l, n.height = c, n.aspectRatio = a / o, n.naturalWidth = a, n.naturalHeight = o, this.limitCanvas(!0, !1);
    }
    (n.width > n.maxWidth || n.width < n.minWidth) && (n.left = n.oldLeft), (n.height > n.maxHeight || n.height < n.minHeight) && (n.top = n.oldTop), n.width = Math.min(Math.max(n.width, n.minWidth), n.maxWidth), n.height = Math.min(Math.max(n.height, n.minHeight), n.maxHeight), this.limitCanvas(!1, !0), n.left = Math.min(Math.max(n.left, n.minLeft), n.maxLeft), n.top = Math.min(Math.max(n.top, n.minTop), n.maxTop), n.oldLeft = n.left, n.oldTop = n.top, St(this.canvas, he({
      width: n.width,
      height: n.height
    }, zr({
      translateX: n.left,
      translateY: n.top
    }))), this.renderImage(e), this.cropped && this.limited && this.limitCropBox(!0, !0);
  },
  renderImage: function(e) {
    var r = this.canvasData, n = this.imageData, s = n.naturalWidth * (r.width / r.naturalWidth), i = n.naturalHeight * (r.height / r.naturalHeight);
    he(n, {
      width: s,
      height: i,
      left: (r.width - s) / 2,
      top: (r.height - i) / 2
    }), St(this.image, he({
      width: n.width,
      height: n.height
    }, zr(he({
      translateX: n.left,
      translateY: n.top
    }, n)))), e && this.output();
  },
  initCropBox: function() {
    var e = this.options, r = this.canvasData, n = e.aspectRatio || e.initialAspectRatio, s = Number(e.autoCropArea) || 0.8, i = {
      width: r.width,
      height: r.height
    };
    n && (r.height * n > r.width ? i.height = i.width / n : i.width = i.height * n), this.cropBoxData = i, this.limitCropBox(!0, !0), i.width = Math.min(Math.max(i.width, i.minWidth), i.maxWidth), i.height = Math.min(Math.max(i.height, i.minHeight), i.maxHeight), i.width = Math.max(i.minWidth, i.width * s), i.height = Math.max(i.minHeight, i.height * s), i.left = r.left + (r.width - i.width) / 2, i.top = r.top + (r.height - i.height) / 2, i.oldLeft = i.left, i.oldTop = i.top, this.initialCropBoxData = he({}, i);
  },
  limitCropBox: function(e, r) {
    var n = this.options, s = this.containerData, i = this.canvasData, a = this.cropBoxData, o = this.limited, l = n.aspectRatio;
    if (e) {
      var c = Number(n.minCropBoxWidth) || 0, u = Number(n.minCropBoxHeight) || 0, d = o ? Math.min(s.width, i.width, i.width + i.left, s.width - i.left) : s.width, h = o ? Math.min(s.height, i.height, i.height + i.top, s.height - i.top) : s.height;
      c = Math.min(c, s.width), u = Math.min(u, s.height), l && (c && u ? u * l > c ? u = c / l : c = u * l : c ? u = c / l : u && (c = u * l), h * l > d ? h = d / l : d = h * l), a.minWidth = Math.min(c, d), a.minHeight = Math.min(u, h), a.maxWidth = d, a.maxHeight = h;
    }
    r && (o ? (a.minLeft = Math.max(0, i.left), a.minTop = Math.max(0, i.top), a.maxLeft = Math.min(s.width, i.left + i.width) - a.width, a.maxTop = Math.min(s.height, i.top + i.height) - a.height) : (a.minLeft = 0, a.minTop = 0, a.maxLeft = s.width - a.width, a.maxTop = s.height - a.height));
  },
  renderCropBox: function() {
    var e = this.options, r = this.containerData, n = this.cropBoxData;
    (n.width > n.maxWidth || n.width < n.minWidth) && (n.left = n.oldLeft), (n.height > n.maxHeight || n.height < n.minHeight) && (n.top = n.oldTop), n.width = Math.min(Math.max(n.width, n.minWidth), n.maxWidth), n.height = Math.min(Math.max(n.height, n.minHeight), n.maxHeight), this.limitCropBox(!1, !0), n.left = Math.min(Math.max(n.left, n.minLeft), n.maxLeft), n.top = Math.min(Math.max(n.top, n.minTop), n.maxTop), n.oldLeft = n.left, n.oldTop = n.top, e.movable && e.cropBoxMovable && Kr(this.face, qr, n.width >= r.width && n.height >= r.height ? gl : pi), St(this.cropBox, he({
      width: n.width,
      height: n.height
    }, zr({
      translateX: n.left,
      translateY: n.top
    }))), this.cropped && this.limited && this.limitCanvas(!0, !0), this.disabled || this.output();
  },
  output: function() {
    this.preview(), ar(this.element, Qs, this.getData());
  }
}, Kp = {
  initPreview: function() {
    var e = this.element, r = this.crossOrigin, n = this.options.preview, s = r ? this.crossOriginUrl : this.url, i = e.alt || "The image to preview", a = document.createElement("img");
    if (r && (a.crossOrigin = r), a.src = s, a.alt = i, this.viewBox.appendChild(a), this.viewBoxImage = a, !!n) {
      var o = n;
      typeof n == "string" ? o = e.ownerDocument.querySelectorAll(n) : n.querySelector && (o = [n]), this.previews = o, ve(o, function(l) {
        var c = document.createElement("img");
        Kr(l, vn, {
          width: l.offsetWidth,
          height: l.offsetHeight,
          html: l.innerHTML
        }), r && (c.crossOrigin = r), c.src = s, c.alt = i, c.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"', l.innerHTML = "", l.appendChild(c);
      });
    }
  },
  resetPreview: function() {
    ve(this.previews, function(e) {
      var r = Zs(e, vn);
      St(e, {
        width: r.width,
        height: r.height
      }), e.innerHTML = r.html, Ap(e, vn);
    });
  },
  preview: function() {
    var e = this.imageData, r = this.canvasData, n = this.cropBoxData, s = n.width, i = n.height, a = e.width, o = e.height, l = n.left - r.left - e.left, c = n.top - r.top - e.top;
    !this.cropped || this.disabled || (St(this.viewBoxImage, he({
      width: a,
      height: o
    }, zr(he({
      translateX: -l,
      translateY: -c
    }, e)))), ve(this.previews, function(u) {
      var d = Zs(u, vn), h = d.width, m = d.height, f = h, y = m, p = 1;
      s && (p = h / s, y = i * p), i && y > m && (p = m / i, f = s * p, y = m), St(u, {
        width: f,
        height: y
      }), St(u.getElementsByTagName("img")[0], he({
        width: a * p,
        height: o * p
      }, zr(he({
        translateX: -l * p,
        translateY: -c * p
      }, e))));
    }));
  }
}, Qp = {
  bind: function() {
    var e = this.element, r = this.options, n = this.cropper;
    De(r.cropstart) && Be(e, Gs, r.cropstart), De(r.cropmove) && Be(e, Xs, r.cropmove), De(r.cropend) && Be(e, Ys, r.cropend), De(r.crop) && Be(e, Qs, r.crop), De(r.zoom) && Be(e, Js, r.zoom), Be(n, ja, this.onCropStart = this.cropStart.bind(this)), r.zoomable && r.zoomOnWheel && Be(n, Ia, this.onWheel = this.wheel.bind(this), {
      passive: !1,
      capture: !0
    }), r.toggleDragModeOnDblclick && Be(n, Na, this.onDblclick = this.dblclick.bind(this)), Be(e.ownerDocument, Da, this.onCropMove = this.cropMove.bind(this)), Be(e.ownerDocument, Fa, this.onCropEnd = this.cropEnd.bind(this)), r.responsive && Be(window, ka, this.onResize = this.resize.bind(this));
  },
  unbind: function() {
    var e = this.element, r = this.options, n = this.cropper;
    De(r.cropstart) && Ve(e, Gs, r.cropstart), De(r.cropmove) && Ve(e, Xs, r.cropmove), De(r.cropend) && Ve(e, Ys, r.cropend), De(r.crop) && Ve(e, Qs, r.crop), De(r.zoom) && Ve(e, Js, r.zoom), Ve(n, ja, this.onCropStart), r.zoomable && r.zoomOnWheel && Ve(n, Ia, this.onWheel, {
      passive: !1,
      capture: !0
    }), r.toggleDragModeOnDblclick && Ve(n, Na, this.onDblclick), Ve(e.ownerDocument, Da, this.onCropMove), Ve(e.ownerDocument, Fa, this.onCropEnd), r.responsive && Ve(window, ka, this.onResize);
  }
}, Yp = {
  resize: function() {
    if (!this.disabled) {
      var e = this.options, r = this.container, n = this.containerData, s = r.offsetWidth / n.width, i = r.offsetHeight / n.height, a = Math.abs(s - 1) > Math.abs(i - 1) ? s : i;
      if (a !== 1) {
        var o, l;
        e.restore && (o = this.getCanvasData(), l = this.getCropBoxData()), this.render(), e.restore && (this.setCanvasData(ve(o, function(c, u) {
          o[u] = c * a;
        })), this.setCropBoxData(ve(l, function(c, u) {
          l[u] = c * a;
        })));
      }
    }
  },
  dblclick: function() {
    this.disabled || this.options.dragMode === vl || this.setDragMode(Dp(this.dragBox, qs) ? bl : mi);
  },
  wheel: function(e) {
    var r = this, n = Number(this.options.wheelZoomRatio) || 0.1, s = 1;
    this.disabled || (e.preventDefault(), !this.wheeling && (this.wheeling = !0, setTimeout(function() {
      r.wheeling = !1;
    }, 50), e.deltaY ? s = e.deltaY > 0 ? 1 : -1 : e.wheelDelta ? s = -e.wheelDelta / 120 : e.detail && (s = e.detail > 0 ? 1 : -1), this.zoom(-s * n, e)));
  },
  cropStart: function(e) {
    var r = e.buttons, n = e.button;
    if (!(this.disabled || (e.type === "mousedown" || e.type === "pointerdown" && e.pointerType === "mouse") && // No primary button (Usually the left button)
    (X(r) && r !== 1 || X(n) && n !== 0 || e.ctrlKey))) {
      var s = this.options, i = this.pointers, a;
      e.changedTouches ? ve(e.changedTouches, function(o) {
        i[o.identifier] = wn(o);
      }) : i[e.pointerId || 0] = wn(e), Object.keys(i).length > 1 && s.zoomable && s.zoomOnTouch ? a = yl : a = Zs(e.target, qr), Sp.test(a) && ar(this.element, Gs, {
        originalEvent: e,
        action: a
      }) !== !1 && (e.preventDefault(), this.action = a, this.cropping = !1, a === ml && (this.cropping = !0, we(this.dragBox, Fn)));
    }
  },
  cropMove: function(e) {
    var r = this.action;
    if (!(this.disabled || !r)) {
      var n = this.pointers;
      e.preventDefault(), ar(this.element, Xs, {
        originalEvent: e,
        action: r
      }) !== !1 && (e.changedTouches ? ve(e.changedTouches, function(s) {
        he(n[s.identifier] || {}, wn(s, !0));
      }) : he(n[e.pointerId || 0] || {}, wn(e, !0)), this.change(e));
    }
  },
  cropEnd: function(e) {
    if (!this.disabled) {
      var r = this.action, n = this.pointers;
      e.changedTouches ? ve(e.changedTouches, function(s) {
        delete n[s.identifier];
      }) : delete n[e.pointerId || 0], r && (e.preventDefault(), Object.keys(n).length || (this.action = ""), this.cropping && (this.cropping = !1, er(this.dragBox, Fn, this.cropped && this.options.modal)), ar(this.element, Ys, {
        originalEvent: e,
        action: r
      }));
    }
  }
}, Xp = {
  change: function(e) {
    var r = this.options, n = this.canvasData, s = this.containerData, i = this.cropBoxData, a = this.pointers, o = this.action, l = r.aspectRatio, c = i.left, u = i.top, d = i.width, h = i.height, m = c + d, f = u + h, y = 0, p = 0, S = s.width, x = s.height, C = !0, P;
    !l && e.shiftKey && (l = d && h ? d / h : 1), this.limited && (y = i.minLeft, p = i.minTop, S = y + Math.min(s.width, n.width, n.left + n.width), x = p + Math.min(s.height, n.height, n.top + n.height));
    var j = a[Object.keys(a)[0]], w = {
      x: j.endX - j.startX,
      y: j.endY - j.startY
    }, _ = function(R) {
      switch (R) {
        case Pt:
          m + w.x > S && (w.x = S - m);
          break;
        case Tt:
          c + w.x < y && (w.x = y - c);
          break;
        case dt:
          u + w.y < p && (w.y = p - u);
          break;
        case Jt:
          f + w.y > x && (w.y = x - f);
          break;
      }
    };
    switch (o) {
      case pi:
        c += w.x, u += w.y;
        break;
      case Pt:
        if (w.x >= 0 && (m >= S || l && (u <= p || f >= x))) {
          C = !1;
          break;
        }
        _(Pt), d += w.x, d < 0 && (o = Tt, d = -d, c -= d), l && (h = d / l, u += (i.height - h) / 2);
        break;
      case dt:
        if (w.y <= 0 && (u <= p || l && (c <= y || m >= S))) {
          C = !1;
          break;
        }
        _(dt), h -= w.y, u += w.y, h < 0 && (o = Jt, h = -h, u -= h), l && (d = h * l, c += (i.width - d) / 2);
        break;
      case Tt:
        if (w.x <= 0 && (c <= y || l && (u <= p || f >= x))) {
          C = !1;
          break;
        }
        _(Tt), d -= w.x, c += w.x, d < 0 && (o = Pt, d = -d, c -= d), l && (h = d / l, u += (i.height - h) / 2);
        break;
      case Jt:
        if (w.y >= 0 && (f >= x || l && (c <= y || m >= S))) {
          C = !1;
          break;
        }
        _(Jt), h += w.y, h < 0 && (o = dt, h = -h, u -= h), l && (d = h * l, c += (i.width - d) / 2);
        break;
      case Ar:
        if (l) {
          if (w.y <= 0 && (u <= p || m >= S)) {
            C = !1;
            break;
          }
          _(dt), h -= w.y, u += w.y, d = h * l;
        } else
          _(dt), _(Pt), w.x >= 0 ? m < S ? d += w.x : w.y <= 0 && u <= p && (C = !1) : d += w.x, w.y <= 0 ? u > p && (h -= w.y, u += w.y) : (h -= w.y, u += w.y);
        d < 0 && h < 0 ? (o = Mr, h = -h, d = -d, u -= h, c -= d) : d < 0 ? (o = kr, d = -d, c -= d) : h < 0 && (o = Ir, h = -h, u -= h);
        break;
      case kr:
        if (l) {
          if (w.y <= 0 && (u <= p || c <= y)) {
            C = !1;
            break;
          }
          _(dt), h -= w.y, u += w.y, d = h * l, c += i.width - d;
        } else
          _(dt), _(Tt), w.x <= 0 ? c > y ? (d -= w.x, c += w.x) : w.y <= 0 && u <= p && (C = !1) : (d -= w.x, c += w.x), w.y <= 0 ? u > p && (h -= w.y, u += w.y) : (h -= w.y, u += w.y);
        d < 0 && h < 0 ? (o = Ir, h = -h, d = -d, u -= h, c -= d) : d < 0 ? (o = Ar, d = -d, c -= d) : h < 0 && (o = Mr, h = -h, u -= h);
        break;
      case Mr:
        if (l) {
          if (w.x <= 0 && (c <= y || f >= x)) {
            C = !1;
            break;
          }
          _(Tt), d -= w.x, c += w.x, h = d / l;
        } else
          _(Jt), _(Tt), w.x <= 0 ? c > y ? (d -= w.x, c += w.x) : w.y >= 0 && f >= x && (C = !1) : (d -= w.x, c += w.x), w.y >= 0 ? f < x && (h += w.y) : h += w.y;
        d < 0 && h < 0 ? (o = Ar, h = -h, d = -d, u -= h, c -= d) : d < 0 ? (o = Ir, d = -d, c -= d) : h < 0 && (o = kr, h = -h, u -= h);
        break;
      case Ir:
        if (l) {
          if (w.x >= 0 && (m >= S || f >= x)) {
            C = !1;
            break;
          }
          _(Pt), d += w.x, h = d / l;
        } else
          _(Jt), _(Pt), w.x >= 0 ? m < S ? d += w.x : w.y >= 0 && f >= x && (C = !1) : d += w.x, w.y >= 0 ? f < x && (h += w.y) : h += w.y;
        d < 0 && h < 0 ? (o = kr, h = -h, d = -d, u -= h, c -= d) : d < 0 ? (o = Mr, d = -d, c -= d) : h < 0 && (o = Ar, h = -h, u -= h);
        break;
      case gl:
        this.move(w.x, w.y), C = !1;
        break;
      case yl:
        this.zoom(Ip(a), e), C = !1;
        break;
      case ml:
        if (!w.x || !w.y) {
          C = !1;
          break;
        }
        P = Ol(this.cropper), c = j.startX - P.left, u = j.startY - P.top, d = i.minWidth, h = i.minHeight, w.x > 0 ? o = w.y > 0 ? Ir : Ar : w.x < 0 && (c -= d, o = w.y > 0 ? Mr : kr), w.y < 0 && (u -= h), this.cropped || (tt(this.cropBox, Fe), this.cropped = !0, this.limited && this.limitCropBox(!0, !0));
        break;
    }
    C && (i.width = d, i.height = h, i.left = c, i.top = u, this.action = o, this.renderCropBox()), ve(a, function(O) {
      O.startX = O.endX, O.startY = O.endY;
    });
  }
}, Gp = {
  // Show the crop box manually
  crop: function() {
    return this.ready && !this.cropped && !this.disabled && (this.cropped = !0, this.limitCropBox(!0, !0), this.options.modal && we(this.dragBox, Fn), tt(this.cropBox, Fe), this.setCropBoxData(this.initialCropBoxData)), this;
  },
  // Reset the image and crop box to their initial states
  reset: function() {
    return this.ready && !this.disabled && (this.imageData = he({}, this.initialImageData), this.canvasData = he({}, this.initialCanvasData), this.cropBoxData = he({}, this.initialCropBoxData), this.renderCanvas(), this.cropped && this.renderCropBox()), this;
  },
  // Clear the crop box
  clear: function() {
    return this.cropped && !this.disabled && (he(this.cropBoxData, {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    }), this.cropped = !1, this.renderCropBox(), this.limitCanvas(!0, !0), this.renderCanvas(), tt(this.dragBox, Fn), we(this.cropBox, Fe)), this;
  },
  /**
   * Replace the image's src and rebuild the cropper
   * @param {string} url - The new URL.
   * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
   * @returns {Cropper} this
   */
  replace: function(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return !this.disabled && e && (this.isImg && (this.element.src = e), r ? (this.url = e, this.image.src = e, this.ready && (this.viewBoxImage.src = e, ve(this.previews, function(n) {
      n.getElementsByTagName("img")[0].src = e;
    }))) : (this.isImg && (this.replaced = !0), this.options.data = null, this.uncreate(), this.load(e))), this;
  },
  // Enable (unfreeze) the cropper
  enable: function() {
    return this.ready && this.disabled && (this.disabled = !1, tt(this.cropper, Pa)), this;
  },
  // Disable (freeze) the cropper
  disable: function() {
    return this.ready && !this.disabled && (this.disabled = !0, we(this.cropper, Pa)), this;
  },
  /**
   * Destroy the cropper and remove the instance from the image
   * @returns {Cropper} this
   */
  destroy: function() {
    var e = this.element;
    return e[ue] ? (e[ue] = void 0, this.isImg && this.replaced && (e.src = this.originalUrl), this.uncreate(), this) : this;
  },
  /**
   * Move the canvas with relative offsets
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
   * @returns {Cropper} this
   */
  move: function(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, n = this.canvasData, s = n.left, i = n.top;
    return this.moveTo(hs(e) ? e : s + Number(e), hs(r) ? r : i + Number(r));
  },
  /**
   * Move the canvas to an absolute point
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Cropper} this
   */
  moveTo: function(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, n = this.canvasData, s = !1;
    return e = Number(e), r = Number(r), this.ready && !this.disabled && this.options.movable && (X(e) && (n.left = e, s = !0), X(r) && (n.top = r, s = !0), s && this.renderCanvas(!0)), this;
  },
  /**
   * Zoom the canvas with a relative ratio
   * @param {number} ratio - The target ratio.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoom: function(e, r) {
    var n = this.canvasData;
    return e = Number(e), e < 0 ? e = 1 / (1 - e) : e = 1 + e, this.zoomTo(n.width * e / n.naturalWidth, null, r);
  },
  /**
   * Zoom the canvas to an absolute ratio
   * @param {number} ratio - The target ratio.
   * @param {Object} pivot - The zoom pivot point coordinate.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoomTo: function(e, r, n) {
    var s = this.options, i = this.canvasData, a = i.width, o = i.height, l = i.naturalWidth, c = i.naturalHeight;
    if (e = Number(e), e >= 0 && this.ready && !this.disabled && s.zoomable) {
      var u = l * e, d = c * e;
      if (ar(this.element, Js, {
        ratio: e,
        oldRatio: a / l,
        originalEvent: n
      }) === !1)
        return this;
      if (n) {
        var h = this.pointers, m = Ol(this.cropper), f = h && Object.keys(h).length ? Mp(h) : {
          pageX: n.pageX,
          pageY: n.pageY
        };
        i.left -= (u - a) * ((f.pageX - m.left - i.left) / a), i.top -= (d - o) * ((f.pageY - m.top - i.top) / o);
      } else
        Zt(r) && X(r.x) && X(r.y) ? (i.left -= (u - a) * ((r.x - i.left) / a), i.top -= (d - o) * ((r.y - i.top) / o)) : (i.left -= (u - a) / 2, i.top -= (d - o) / 2);
      i.width = u, i.height = d, this.renderCanvas(!0);
    }
    return this;
  },
  /**
   * Rotate the canvas with a relative degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotate: function(e) {
    return this.rotateTo((this.imageData.rotate || 0) + Number(e));
  },
  /**
   * Rotate the canvas to an absolute degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotateTo: function(e) {
    return e = Number(e), X(e) && this.ready && !this.disabled && this.options.rotatable && (this.imageData.rotate = e % 360, this.renderCanvas(!0, !0)), this;
  },
  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Cropper} this
   */
  scaleX: function(e) {
    var r = this.imageData.scaleY;
    return this.scale(e, X(r) ? r : 1);
  },
  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scaleY: function(e) {
    var r = this.imageData.scaleX;
    return this.scale(X(r) ? r : 1, e);
  },
  /**
   * Scale the image
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scale: function(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, n = this.imageData, s = !1;
    return e = Number(e), r = Number(r), this.ready && !this.disabled && this.options.scalable && (X(e) && (n.scaleX = e, s = !0), X(r) && (n.scaleY = r, s = !0), s && this.renderCanvas(!0, !0)), this;
  },
  /**
   * Get the cropped area position and size data (base on the original image)
   * @param {boolean} [rounded=false] - Indicate if round the data values or not.
   * @returns {Object} The result cropped data.
   */
  getData: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, r = this.options, n = this.imageData, s = this.canvasData, i = this.cropBoxData, a;
    if (this.ready && this.cropped) {
      a = {
        x: i.left - s.left,
        y: i.top - s.top,
        width: i.width,
        height: i.height
      };
      var o = n.width / n.naturalWidth;
      if (ve(a, function(u, d) {
        a[d] = u / o;
      }), e) {
        var l = Math.round(a.y + a.height), c = Math.round(a.x + a.width);
        a.x = Math.round(a.x), a.y = Math.round(a.y), a.width = c - a.x, a.height = l - a.y;
      }
    } else
      a = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    return r.rotatable && (a.rotate = n.rotate || 0), r.scalable && (a.scaleX = n.scaleX || 1, a.scaleY = n.scaleY || 1), a;
  },
  /**
   * Set the cropped area position and size with new data
   * @param {Object} data - The new data.
   * @returns {Cropper} this
   */
  setData: function(e) {
    var r = this.options, n = this.imageData, s = this.canvasData, i = {};
    if (this.ready && !this.disabled && Zt(e)) {
      var a = !1;
      r.rotatable && X(e.rotate) && e.rotate !== n.rotate && (n.rotate = e.rotate, a = !0), r.scalable && (X(e.scaleX) && e.scaleX !== n.scaleX && (n.scaleX = e.scaleX, a = !0), X(e.scaleY) && e.scaleY !== n.scaleY && (n.scaleY = e.scaleY, a = !0)), a && this.renderCanvas(!0, !0);
      var o = n.width / n.naturalWidth;
      X(e.x) && (i.left = e.x * o + s.left), X(e.y) && (i.top = e.y * o + s.top), X(e.width) && (i.width = e.width * o), X(e.height) && (i.height = e.height * o), this.setCropBoxData(i);
    }
    return this;
  },
  /**
   * Get the container size data.
   * @returns {Object} The result container data.
   */
  getContainerData: function() {
    return this.ready ? he({}, this.containerData) : {};
  },
  /**
   * Get the image position and size data.
   * @returns {Object} The result image data.
   */
  getImageData: function() {
    return this.sized ? he({}, this.imageData) : {};
  },
  /**
   * Get the canvas position and size data.
   * @returns {Object} The result canvas data.
   */
  getCanvasData: function() {
    var e = this.canvasData, r = {};
    return this.ready && ve(["left", "top", "width", "height", "naturalWidth", "naturalHeight"], function(n) {
      r[n] = e[n];
    }), r;
  },
  /**
   * Set the canvas position and size with new data.
   * @param {Object} data - The new canvas data.
   * @returns {Cropper} this
   */
  setCanvasData: function(e) {
    var r = this.canvasData, n = r.aspectRatio;
    return this.ready && !this.disabled && Zt(e) && (X(e.left) && (r.left = e.left), X(e.top) && (r.top = e.top), X(e.width) ? (r.width = e.width, r.height = e.width / n) : X(e.height) && (r.height = e.height, r.width = e.height * n), this.renderCanvas(!0)), this;
  },
  /**
   * Get the crop box position and size data.
   * @returns {Object} The result crop box data.
   */
  getCropBoxData: function() {
    var e = this.cropBoxData, r;
    return this.ready && this.cropped && (r = {
      left: e.left,
      top: e.top,
      width: e.width,
      height: e.height
    }), r || {};
  },
  /**
   * Set the crop box position and size with new data.
   * @param {Object} data - The new crop box data.
   * @returns {Cropper} this
   */
  setCropBoxData: function(e) {
    var r = this.cropBoxData, n = this.options.aspectRatio, s, i;
    return this.ready && this.cropped && !this.disabled && Zt(e) && (X(e.left) && (r.left = e.left), X(e.top) && (r.top = e.top), X(e.width) && e.width !== r.width && (s = !0, r.width = e.width), X(e.height) && e.height !== r.height && (i = !0, r.height = e.height), n && (s ? r.height = r.width / n : i && (r.width = r.height * n)), this.renderCropBox()), this;
  },
  /**
   * Get a canvas drawn the cropped image.
   * @param {Object} [options={}] - The config options.
   * @returns {HTMLCanvasElement} - The result canvas.
   */
  getCroppedCanvas: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!this.ready || !window.HTMLCanvasElement)
      return null;
    var r = this.canvasData, n = Up(this.image, this.imageData, r, e);
    if (!this.cropped)
      return n;
    var s = this.getData(e.rounded), i = s.x, a = s.y, o = s.width, l = s.height, c = n.width / Math.floor(r.naturalWidth);
    c !== 1 && (i *= c, a *= c, o *= c, l *= c);
    var u = o / l, d = Et({
      aspectRatio: u,
      width: e.maxWidth || 1 / 0,
      height: e.maxHeight || 1 / 0
    }), h = Et({
      aspectRatio: u,
      width: e.minWidth || 0,
      height: e.minHeight || 0
    }, "cover"), m = Et({
      aspectRatio: u,
      width: e.width || (c !== 1 ? n.width : o),
      height: e.height || (c !== 1 ? n.height : l)
    }), f = m.width, y = m.height;
    f = Math.min(d.width, Math.max(h.width, f)), y = Math.min(d.height, Math.max(h.height, y));
    var p = document.createElement("canvas"), S = p.getContext("2d");
    p.width = ir(f), p.height = ir(y), S.fillStyle = e.fillColor || "transparent", S.fillRect(0, 0, f, y);
    var x = e.imageSmoothingEnabled, C = x === void 0 ? !0 : x, P = e.imageSmoothingQuality;
    S.imageSmoothingEnabled = C, P && (S.imageSmoothingQuality = P);
    var j = n.width, w = n.height, _ = i, O = a, R, N, k, D, z, U;
    _ <= -o || _ > j ? (_ = 0, R = 0, k = 0, z = 0) : _ <= 0 ? (k = -_, _ = 0, R = Math.min(j, o + _), z = R) : _ <= j && (k = 0, R = Math.min(o, j - _), z = R), R <= 0 || O <= -l || O > w ? (O = 0, N = 0, D = 0, U = 0) : O <= 0 ? (D = -O, O = 0, N = Math.min(w, l + O), U = N) : O <= w && (D = 0, N = Math.min(l, w - O), U = N);
    var M = [_, O, R, N];
    if (z > 0 && U > 0) {
      var re = f / o;
      M.push(k * re, D * re, z * re, U * re);
    }
    return S.drawImage.apply(S, [n].concat(pl(M.map(function(ce) {
      return Math.floor(ir(ce));
    })))), p;
  },
  /**
   * Change the aspect ratio of the crop box.
   * @param {number} aspectRatio - The new aspect ratio.
   * @returns {Cropper} this
   */
  setAspectRatio: function(e) {
    var r = this.options;
    return !this.disabled && !hs(e) && (r.aspectRatio = Math.max(0, e) || NaN, this.ready && (this.initCropBox(), this.cropped && this.renderCropBox())), this;
  },
  /**
   * Change the drag mode.
   * @param {string} mode - The new drag mode.
   * @returns {Cropper} this
   */
  setDragMode: function(e) {
    var r = this.options, n = this.dragBox, s = this.face;
    if (this.ready && !this.disabled) {
      var i = e === mi, a = r.movable && e === bl;
      e = i || a ? e : vl, r.dragMode = e, Kr(n, qr, e), er(n, qs, i), er(n, Ks, a), r.cropBoxMovable || (Kr(s, qr, e), er(s, qs, i), er(s, Ks, a));
    }
    return this;
  }
}, Jp = rt.Cropper, _l = /* @__PURE__ */ function() {
  function t(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (hp(this, t), !e || !Op.test(e.tagName))
      throw new Error("The first argument is required and must be an <img> or <canvas> element.");
    this.element = e, this.options = he({}, La, Zt(r) && r), this.cropped = !1, this.disabled = !1, this.pointers = {}, this.ready = !1, this.reloading = !1, this.replaced = !1, this.sized = !1, this.sizing = !1, this.init();
  }
  return dp(t, [{
    key: "init",
    value: function() {
      var r = this.element, n = r.tagName.toLowerCase(), s;
      if (!r[ue]) {
        if (r[ue] = this, n === "img") {
          if (this.isImg = !0, s = r.getAttribute("src") || "", this.originalUrl = s, !s)
            return;
          s = r.src;
        } else
          n === "canvas" && window.HTMLCanvasElement && (s = r.toDataURL());
        this.load(s);
      }
    }
  }, {
    key: "load",
    value: function(r) {
      var n = this;
      if (r) {
        this.url = r, this.imageData = {};
        var s = this.element, i = this.options;
        if (!i.rotatable && !i.scalable && (i.checkOrientation = !1), !i.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        }
        if (Ep.test(r)) {
          Cp.test(r) ? this.read($p(r)) : this.clone();
          return;
        }
        var a = new XMLHttpRequest(), o = this.clone.bind(this);
        this.reloading = !0, this.xhr = a, a.onabort = o, a.onerror = o, a.ontimeout = o, a.onprogress = function() {
          a.getResponseHeader("content-type") !== Ma && a.abort();
        }, a.onload = function() {
          n.read(a.response);
        }, a.onloadend = function() {
          n.reloading = !1, n.xhr = null;
        }, i.checkCrossOrigin && za(r) && s.crossOrigin && (r = Ba(r)), a.open("GET", r, !0), a.responseType = "arraybuffer", a.withCredentials = s.crossOrigin === "use-credentials", a.send();
      }
    }
  }, {
    key: "read",
    value: function(r) {
      var n = this.options, s = this.imageData, i = Wp(r), a = 0, o = 1, l = 1;
      if (i > 1) {
        this.url = Hp(r, Ma);
        var c = Vp(i);
        a = c.rotate, o = c.scaleX, l = c.scaleY;
      }
      n.rotatable && (s.rotate = a), n.scalable && (s.scaleX = o, s.scaleY = l), this.clone();
    }
  }, {
    key: "clone",
    value: function() {
      var r = this.element, n = this.url, s = r.crossOrigin, i = n;
      this.options.checkCrossOrigin && za(n) && (s || (s = "anonymous"), i = Ba(n)), this.crossOrigin = s, this.crossOriginUrl = i;
      var a = document.createElement("img");
      s && (a.crossOrigin = s), a.src = i || n, a.alt = r.alt || "The image to crop", this.image = a, a.onload = this.start.bind(this), a.onerror = this.stop.bind(this), we(a, Ta), r.parentNode.insertBefore(a, r.nextSibling);
    }
  }, {
    key: "start",
    value: function() {
      var r = this, n = this.image;
      n.onload = null, n.onerror = null, this.sizing = !0;
      var s = rt.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(rt.navigator.userAgent), i = function(c, u) {
        he(r.imageData, {
          naturalWidth: c,
          naturalHeight: u,
          aspectRatio: c / u
        }), r.initialImageData = he({}, r.imageData), r.sizing = !1, r.sized = !0, r.build();
      };
      if (n.naturalWidth && !s) {
        i(n.naturalWidth, n.naturalHeight);
        return;
      }
      var a = document.createElement("img"), o = document.body || document.documentElement;
      this.sizingImage = a, a.onload = function() {
        i(a.width, a.height), s || o.removeChild(a);
      }, a.src = n.src, s || (a.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;", o.appendChild(a));
    }
  }, {
    key: "stop",
    value: function() {
      var r = this.image;
      r.onload = null, r.onerror = null, r.parentNode.removeChild(r), this.image = null;
    }
  }, {
    key: "build",
    value: function() {
      if (!(!this.sized || this.ready)) {
        var r = this.element, n = this.options, s = this.image, i = r.parentNode, a = document.createElement("div");
        a.innerHTML = Rp;
        var o = a.querySelector(".".concat(ue, "-container")), l = o.querySelector(".".concat(ue, "-canvas")), c = o.querySelector(".".concat(ue, "-drag-box")), u = o.querySelector(".".concat(ue, "-crop-box")), d = u.querySelector(".".concat(ue, "-face"));
        this.container = i, this.cropper = o, this.canvas = l, this.dragBox = c, this.cropBox = u, this.viewBox = o.querySelector(".".concat(ue, "-view-box")), this.face = d, l.appendChild(s), we(r, Fe), i.insertBefore(o, r.nextSibling), tt(s, Ta), this.initPreview(), this.bind(), n.initialAspectRatio = Math.max(0, n.initialAspectRatio) || NaN, n.aspectRatio = Math.max(0, n.aspectRatio) || NaN, n.viewMode = Math.max(0, Math.min(3, Math.round(n.viewMode))) || 0, we(u, Fe), n.guides || we(u.getElementsByClassName("".concat(ue, "-dashed")), Fe), n.center || we(u.getElementsByClassName("".concat(ue, "-center")), Fe), n.background && we(o, "".concat(ue, "-bg")), n.highlight || we(d, bp), n.cropBoxMovable && (we(d, Ks), Kr(d, qr, pi)), n.cropBoxResizable || (we(u.getElementsByClassName("".concat(ue, "-line")), Fe), we(u.getElementsByClassName("".concat(ue, "-point")), Fe)), this.render(), this.ready = !0, this.setDragMode(n.dragMode), n.autoCrop && this.crop(), this.setData(n.data), De(n.ready) && Be(r, Aa, n.ready, {
          once: !0
        }), ar(r, Aa);
      }
    }
  }, {
    key: "unbuild",
    value: function() {
      if (this.ready) {
        this.ready = !1, this.unbind(), this.resetPreview();
        var r = this.cropper.parentNode;
        r && r.removeChild(this.cropper), tt(this.element, Fe);
      }
    }
  }, {
    key: "uncreate",
    value: function() {
      this.ready ? (this.unbuild(), this.ready = !1, this.cropped = !1) : this.sizing ? (this.sizingImage.onload = null, this.sizing = !1, this.sized = !1) : this.reloading ? (this.xhr.onabort = null, this.xhr.abort()) : this.image && this.stop();
    }
    /**
     * Get the no conflict cropper class.
     * @returns {Cropper} The cropper class.
     */
  }], [{
    key: "noConflict",
    value: function() {
      return window.Cropper = Jp, t;
    }
    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */
  }, {
    key: "setDefaults",
    value: function(r) {
      he(La, Zt(r) && r);
    }
  }]);
}();
he(_l.prototype, qp, Kp, Qp, Yp, Xp, Gp);
var Nt = function() {
  return Nt = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++)
      for (var s in e = arguments[r])
        Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
    return t;
  }, Nt.apply(this, arguments);
};
function fs(t, e) {
  var r = {};
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function") {
    var s = 0;
    for (n = Object.getOwnPropertySymbols(t); s < n.length; s++)
      e.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[s]) && (r[n[s]] = t[n[s]]);
  }
  return r;
}
var Zp = ["aspectRatio", "autoCrop", "autoCropArea", "background", "center", "checkCrossOrigin", "checkOrientation", "cropBoxMovable", "cropBoxResizable", "data", "dragMode", "guides", "highlight", "initialAspectRatio", "minCanvasHeight", "minCanvasWidth", "minContainerHeight", "minContainerWidth", "minCropBoxHeight", "minCropBoxWidth", "modal", "movable", "preview", "responsive", "restore", "rotatable", "scalable", "toggleDragModeOnDblclick", "viewMode", "wheelZoomRatio", "zoomOnTouch", "zoomOnWheel", "zoomable", "cropstart", "cropmove", "cropend", "crop", "zoom", "ready"], em = { opacity: 0, maxWidth: "100%" }, tm = Ae.forwardRef(function(t, e) {
  var r = fs(t, []), n = r.dragMode, s = n === void 0 ? "crop" : n, i = r.src, a = r.style, o = r.className, l = r.crossOrigin, c = r.scaleX, u = r.scaleY, d = r.enable, h = r.zoomTo, m = r.rotateTo, f = r.alt, y = f === void 0 ? "picture" : f, p = r.ready, S = r.onInitialized, x = fs(r, ["dragMode", "src", "style", "className", "crossOrigin", "scaleX", "scaleY", "enable", "zoomTo", "rotateTo", "alt", "ready", "onInitialized"]), C = { scaleY: u, scaleX: c, enable: d, zoomTo: h, rotateTo: m }, P = function() {
    for (var w = [], _ = 0; _ < arguments.length; _++)
      w[_] = arguments[_];
    var O = Le(null);
    return Ae.useEffect(function() {
      w.forEach(function(R) {
        R && (typeof R == "function" ? R(O.current) : R.current = O.current);
      });
    }, [w]), O;
  }(e, Le(null));
  We(function() {
    var w;
    !((w = P.current) === null || w === void 0) && w.cropper && typeof h == "number" && P.current.cropper.zoomTo(h);
  }, [r.zoomTo]), We(function() {
    var w;
    !((w = P.current) === null || w === void 0) && w.cropper && i !== void 0 && P.current.cropper.reset().clear().replace(i);
  }, [i]), We(function() {
    if (P.current !== null) {
      var w = new _l(P.current, Nt(Nt({ dragMode: s }, x), { ready: function(_) {
        _.currentTarget !== null && function(O, R) {
          R === void 0 && (R = {});
          var N = R.enable, k = N === void 0 || N, D = R.scaleX, z = D === void 0 ? 1 : D, U = R.scaleY, M = U === void 0 ? 1 : U, re = R.zoomTo, ce = re === void 0 ? 0 : re, $ = R.rotateTo;
          k ? O.enable() : O.disable(), O.scaleX(z), O.scaleY(M), $ !== void 0 && O.rotateTo($), ce > 0 && O.zoomTo(ce);
        }(_.currentTarget.cropper, C), p && p(_);
      } }));
      S && S(w);
    }
    return function() {
      var _, O;
      (O = (_ = P.current) === null || _ === void 0 ? void 0 : _.cropper) === null || O === void 0 || O.destroy();
    };
  }, [P]);
  var j = function(w) {
    return Zp.reduce(function(_, O) {
      var R = _, N = O;
      return R[N], fs(R, [typeof N == "symbol" ? N : N + ""]);
    }, w);
  }(Nt(Nt({}, x), { crossOrigin: l, src: i, alt: y }));
  return Ae.createElement("div", { style: a, className: o }, Ae.createElement("img", Nt({}, j, { style: em, ref: P })));
});
const Pl = Gl(
  ({ imageCropperRef: t, isRounded: e, imageFile: r, imageCropperProps: n }) => {
    const {
      viewMode: s = 1,
      autoCropArea: i = 1,
      aspectRatio: a = 1,
      checkOrientation: o = !1,
      // NOTE: it fixes this issue https://github.com/fengyuanchen/cropperjs/issues/671
      background: l = !0,
      dragMode: c = "move",
      toggleDragModeOnDblclick: u = !1,
      style: d = { height: 400, width: "100%" },
      ...h
    } = n || {}, m = Le(null), f = Le(null), y = Le(null), p = Le(null), S = () => {
      f.current && (f.current.style.opacity = ""), y.current && (y.current.style.display = "block"), p.current && (p.current.style.zIndex = "", p.current.innerText = "");
    }, x = () => {
      y.current && p.current && (p.current.appendChild(y.current.cloneNode(!0)), p.current.style.zIndex = "1000", y.current.style.display = "none"), f.current && (f.current.style.opacity = "0");
    }, C = (P) => new Promise((j, w) => {
      var _;
      try {
        const O = (_ = m.current) == null ? void 0 : _.cropper;
        if (!O)
          throw new Error();
        if (e) {
          const R = O == null ? void 0 : O.getCroppedCanvas();
          if (!R)
            throw new Error();
          const N = Math.min(R.width, R.height), k = document.createElement("canvas");
          k.width = N, k.height = N;
          const D = k.getContext("2d");
          if (!D)
            throw new Error();
          D.beginPath(), D.arc(N / 2, N / 2, N / 2, 0, Math.PI * 2), D.closePath(), D.clip(), D.drawImage(R, 0, 0, N, N), k.toBlob((z) => {
            if (!r || !z)
              return w(new Error());
            const U = Gi(
              ea(r, z),
              a
            );
            j(U);
          });
        } else
          O.getCroppedCanvas(P).toBlob((R) => {
            if (!r || !R)
              return w(new Error());
            const N = Gi(
              ea(r, R),
              a
            );
            j(N);
          });
      } catch (O) {
        w(O);
      }
    });
    return t && (t.current = {
      hidePreview: S,
      showPreview: x,
      getCroppedFile: C
    }), /* @__PURE__ */ v.jsx("div", { children: /* @__PURE__ */ v.jsxs("div", { className: "relative w-full overflow-hidden", children: [
      /* @__PURE__ */ v.jsx(
        "div",
        {
          ref: p,
          className: "absolute inset-0 flex items-center justify-center"
        }
      ),
      /* @__PURE__ */ v.jsx(
        "div",
        {
          ref: y,
          style: {
            position: "absolute",
            overflow: "hidden",
            width: d.width,
            height: d.height,
            borderRadius: e ? "50%" : 0
          }
        }
      ),
      /* @__PURE__ */ v.jsx("div", { ref: f, children: /* @__PURE__ */ v.jsx(
        tm,
        {
          className: e ? "sio-cropper-rounded" : "",
          ref: m,
          src: r && URL.createObjectURL(r),
          preview: y || void 0,
          style: d,
          viewMode: s,
          background: l,
          autoCropArea: i,
          aspectRatio: a,
          checkOrientation: o,
          dragMode: c,
          toggleDragModeOnDblclick: u,
          ...h
        }
      ) })
    ] }) });
  }
);
Pl.displayName = "ImageCropper";
function Tl({
  imageFile: t,
  opened: e,
  actionButtonLabel: r,
  isFetching: n,
  onClose: s,
  onCrop: i,
  ...a
}) {
  const { t: o } = Pe(), l = Le(), [c, u] = te(!1), d = (m) => {
    var f, y;
    u(m), m ? (f = l.current) == null || f.showPreview() : (y = l.current) == null || y.hidePreview();
  }, h = async () => {
    var m;
    try {
      const f = await ((m = l.current) == null ? void 0 : m.getCroppedFile());
      if (!f)
        throw new Error();
      i(f);
    } catch {
      Me.error(o("file_manager.error"));
    }
  };
  return /* @__PURE__ */ v.jsxs(
    kn,
    {
      title: o("file_manager.file_upload.crop_file"),
      opened: e,
      onClose: s,
      afterLeave: () => u(!1),
      isFetching: n,
      isCentered: !0,
      children: [
        /* @__PURE__ */ v.jsx(Pl, { imageCropperRef: l, imageFile: t, ...a }),
        /* @__PURE__ */ v.jsxs("div", { className: "flex justify-between items-center mt-10", children: [
          /* @__PURE__ */ v.jsx(
            lc,
            {
              label: o("file_manager.preview"),
              selected: c,
              onChange: d
            }
          ),
          /* @__PURE__ */ v.jsx(an, { onClick: h, isFetching: n, children: r ?? o("file_manager.file_upload.crop_file") })
        ] })
      ]
    }
  );
}
const rm = ({
  uploaderRef: t,
  opened: e,
  source: r,
  imageCropperModalProps: n,
  showCroppingNote: s,
  acceptTypes: i,
  usePublicApi: a,
  actionLabel: o,
  singleFileMode: l,
  openCroppingModalOnAdding: c,
  requireCropping: u,
  onClose: d,
  onUploadFinish: h
}) => {
  const { t: m } = Pe(), [f, y] = te(!1), [p, S] = te(), {
    waitingUploadFiles: x,
    setWaitingUploadFiles: C,
    removingFiles: P,
    mappedUploadedFiles: j,
    mappedUploadingFiles: w,
    startUploading: _,
    setUploadedFiles: O,
    deleteUploadedOrUploadingFile: R
  } = sp({
    usePublicApi: a,
    source: r
  }), N = async (A) => {
    var ot;
    const Q = (ot = n == null ? void 0 : n.imageCropperProps) == null ? void 0 : ot.aspectRatio;
    if (!ws(A) || !Q || isNaN(Q))
      return !0;
    const Z = URL.createObjectURL(A), [Te, nt] = await go(Z);
    return !!yo(nt, Q);
  };
  Ji(x, async (A, Q) => {
    if (!c)
      return;
    const { added: Z } = A ? Zi(A, Q) : { added: Q };
    for (const { file: Te } of Z)
      if (!await N(Te)) {
        K(Te);
        break;
      }
  }), Ji(x, async (A, Q) => {
    if (!s)
      return;
    const { added: Z } = A ? Zi(A, Q) : { added: Q };
    for (const { file: Te } of Z)
      if (!await N(Te)) {
        Me(m("file_manager.image_cropper.aspect_ratio.need_to_crop_note"));
        break;
      }
  });
  const k = async (A) => {
    C(l ? [{ file: A }] : (Q) => [{ file: A }, ...Q]);
  }, D = async (A) => {
    try {
      ip(A) && C((Q) => Q == null ? void 0 : Q.filter((Z) => Z.file !== A)), ap(A) && (await R(A.id), C((Q) => Q == null ? void 0 : Q.filter((Z) => Z.file !== A.file))), op(A) && await R(A.id);
    } catch {
      Me.error(m("file_manager.error"));
    }
  }, z = async () => {
    try {
      if (S(void 0), y(!0), u) {
        for await (const { file: Z } of x)
          if (!await N(Z))
            throw new Error(m("file_manager.image_cropper.aspect_ratio.need_to_crop_note"));
      }
      const A = [], Q = await Promise.allSettled(
        x.map(
          ({ file: Z }) => _(Z).catch(() => {
            A.push(m("file_manager.error") + ": " + Z.name);
          })
        )
      );
      if (A.length)
        throw new Error(A.join(", "));
      await h(
        Q.map((Z) => {
          if (Z.status === "fulfilled")
            return Z.value;
        })
      ), Me.success(m("file_manager.file_upload.uploaded_successfully"));
    } catch (A) {
      const Q = A instanceof Error ? A : new Error(m("file_manager.error"));
      S(Q);
    } finally {
      y(!1);
    }
  }, U = !![...x, ...w, ...j].length, [M, re] = te(!1), [ce, $] = te(), K = (A) => {
    re(!0), $(A);
  }, ne = () => {
    re(!1), $(void 0);
  }, W = (A) => {
    C(
      (Q) => Q.map((Z) => Z.file === ce ? { file: A } : Z)
    ), ne();
  };
  return t && (t.current = {
    setWaitingUploadFiles: C
  }), /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(
      kn,
      {
        title: m("file_manager.file_upload.upload_files"),
        isCentered: !0,
        isFetching: f,
        opened: e,
        onClose: d,
        afterLeave: () => {
          O([]), C([]);
        },
        children: /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col gap-5", children: [
          /* @__PURE__ */ v.jsxs(
            hl,
            {
              acceptTypes: i,
              onSelectFile: k,
              dropZoneClassName: ge("min-h-[400px]", !U && "items-center"),
              label: m("file_manager.file_upload.drop_files_here"),
              disabled: f,
              children: [
                x.map((A, Q) => /* @__PURE__ */ v.jsx("div", { title: A.file.name, children: /* @__PURE__ */ v.jsx(
                  us,
                  {
                    file: A.file,
                    isError: !!A.error,
                    onDeleteFile: () => D(A.file),
                    showDeleteButton: !0,
                    showEditButton: ws(A.file),
                    onEdit: () => K(A.file)
                  }
                ) }, Q + A.file.name)),
                w.map((A) => /* @__PURE__ */ v.jsx("div", { title: A.file.name, children: /* @__PURE__ */ v.jsx(
                  us,
                  {
                    file: A.file.file,
                    progress: A.progress,
                    isLoading: !0,
                    onDeleteFile: () => D(A.file)
                  }
                ) }, A.file.id)),
                j.map((A) => /* @__PURE__ */ v.jsx("div", { title: A.file.name, children: /* @__PURE__ */ v.jsx(
                  us,
                  {
                    file: A.file,
                    progress: A.progress,
                    isLoaded: !0,
                    isDeleting: P.includes(A.file.id),
                    onDeleteFile: () => D(A.file)
                  }
                ) }, A.file.id))
              ]
            }
          ),
          /* @__PURE__ */ v.jsx("div", { children: /* @__PURE__ */ v.jsx(
            En,
            {
              error: p == null ? void 0 : p.message,
              className: "text-center"
            }
          ) }),
          /* @__PURE__ */ v.jsxs("div", { className: "flex justify-end gap-3", children: [
            /* @__PURE__ */ v.jsx(Ja, { disabled: f, onClick: () => d(), children: m("file_manager.cancel") }),
            /* @__PURE__ */ v.jsx(
              an,
              {
                isFetching: f,
                onClick: z,
                disabled: !U,
                children: o ?? m("file_manager.upload")
              }
            )
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ v.jsx(
      Tl,
      {
        imageFile: ce,
        opened: M,
        onClose: ne,
        onCrop: W,
        ...n
      }
    )
  ] });
};
function nm({
  uploadingFromSource: t,
  requiredCropping: e = !0,
  fileUploaderModalProps: r,
  initialSearchFilters: n,
  disabledFileTypeSelect: s,
  disabledFileSourceSelect: i,
  fileSelectorRef: a,
  onSelect: o
}) {
  var Rt, fn;
  e = !!(e && ((fn = (Rt = r == null ? void 0 : r.imageCropperModalProps) == null ? void 0 : Rt.imageCropperProps) != null && fn.aspectRatio));
  const { t: l } = Pe(), { width: c } = cc(), [u, d] = te(
    n ?? {
      name: "",
      source: [],
      type: []
    }
  ), [h, m] = te(u), [f, y] = te(), [p, S] = te(), [x, C] = te(), [P, j] = te(""), [w, _] = te(), O = td({
    filter: h,
    sortColumn: "createdAt",
    sortDirection: Za.Desc
  }), { resetAndRefetch: R, deleteItemFromData: N, renameItemFromData: k } = O, { deleteFile: D, downloadFile: z, renameFile: U } = ko(), { data: M, isFetching: re } = rd({
    id: f == null ? void 0 : f.id
  }), ce = async () => {
    p && (await D(p), N(p.id), Me.success(l("file_manager.file_deleted_successfully")), S(void 0));
  }, $ = async (de) => {
    try {
      await z(de);
    } catch {
    }
  }, [K, ne] = te(), W = async () => {
    var de;
    if (x)
      try {
        ne(void 0), await U({ id: x.id, name: P }), k({ id: x.id, name: P }), Me.success(l("file_manager.file_renamed_successfully")), C(void 0);
      } catch (Ce) {
        if (Ce instanceof yc)
          ne((de = Ce.errors.fields.name) == null ? void 0 : de.join(" "));
        else
          throw Ce;
      }
  }, A = Le(), [Q, Z] = te(!1), Te = (de) => {
    var Ce;
    (Ce = A.current) == null || Ce.setWaitingUploadFiles((st) => [...st, { file: de }]), Z(!0);
  };
  We(() => {
    r != null && r.uploaderRef && (r.uploaderRef.current = A.current);
  }, [A.current]), a && (a.current = {
    setFileUploadModalOpen: Z
  });
  const { createFileUploader: nt } = cl(), [ot, Ct] = te(!1), [Er, Ot] = te(!1), [qn, Cr] = te(!1), [Kn, un] = te(), Vt = (de) => {
    Ct(!0), un(de);
  }, lt = () => {
    Ct(!1), un(void 0);
  }, hn = async (de) => {
    try {
      Ot(!0);
      const st = await nt(() => {
      }).upload({
        file: de,
        source: t
      });
      if (!st)
        throw new Error();
      const qt = uh(st, t);
      o(qt), R(), lt();
    } catch {
      Me.error(l("file_manager.error"));
    } finally {
      Ot(!1);
    }
  }, dn = async () => {
    var Ce, st;
    if (!w)
      return;
    const de = (st = (Ce = r == null ? void 0 : r.imageCropperModalProps) == null ? void 0 : Ce.imageCropperProps) == null ? void 0 : st.aspectRatio;
    if (!e || !ws(w) || !de || isNaN(de)) {
      o(w);
      return;
    }
    try {
      Cr(!0);
      const [qt, pn] = await go(w.path);
      if (yo(pn, de)) {
        o(w);
        return;
      }
      Me(ch(de));
      const mn = await hh(qt, w.name, w.type);
      Vt(mn);
    } catch {
      Me.error(l("file_manager.error"));
    } finally {
      Cr(!1);
    }
  };
  return /* @__PURE__ */ v.jsxs("div", { className: "flex gap-5", children: [
    /* @__PURE__ */ v.jsx(
      "div",
      {
        className: ge(
          f ? "w-1/2" : "w-full",
          c < 1024 && f ? "hidden" : "auto"
        ),
        children: /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col gap-5", children: [
          /* @__PURE__ */ v.jsx(
            nd,
            {
              isFetching: O.isFetching,
              values: u,
              disabledFileSourceSelect: i,
              disabledFileTypeSelect: s,
              onChange: d,
              onSubmit: () => {
                m(u);
              }
            }
          ),
          /* @__PURE__ */ v.jsx(
            vd,
            {
              dataFilesApi: O,
              onDetails: y,
              onSelect: _,
              onDelete: S,
              onDownload: $,
              onRename: (de) => {
                C(de), j(de.name);
              },
              specialElementInGrid: /* @__PURE__ */ v.jsx(
                hl,
                {
                  className: "h-full w-full",
                  dropZoneClassName: "w-full h-full items-center",
                  labelClassName: "text-text-primary",
                  onSelectFile: Te
                }
              )
            }
          ),
          /* @__PURE__ */ v.jsxs("div", { className: "sticky bottom-4 flex items-center justify-between sm:relative sm:bottom-0", children: [
            /* @__PURE__ */ v.jsxs("div", { className: "text-text-tertiary text-sm", children: [
              +!!w,
              " ",
              l("file_manager.file_selector.files_selected")
            ] }),
            /* @__PURE__ */ v.jsx(
              an,
              {
                className: "min-w-14",
                disabled: w === void 0,
                isFetching: qn,
                onClick: () => dn(),
                children: l("file_manager.select")
              }
            )
          ] })
        ] })
      }
    ),
    f && /* @__PURE__ */ v.jsx(
      ph,
      {
        className: ge(c < 1024 ? "w-full" : "max-w-[calc(50%-20px)]"),
        fileType: M == null ? void 0 : M.type,
        src: (M == null ? void 0 : M.path) ?? (M == null ? void 0 : M.thumbnail) ?? void 0,
        alt: M == null ? void 0 : M.name,
        name: M == null ? void 0 : M.name,
        size: M == null ? void 0 : M.size,
        onClose: () => y(void 0),
        isFetching: re
      }
    ),
    /* @__PURE__ */ v.jsx(
      ra,
      {
        opened: !!p,
        onClose: () => S(void 0),
        confirmationText: l("file_manager.file_selector.file_deletion_confirmation_text", {
          file: p == null ? void 0 : p.name
        }),
        onConfirm: () => ce()
      }
    ),
    /* @__PURE__ */ v.jsx(
      ra,
      {
        opened: !!x,
        onClose: () => {
          C(void 0), ne(void 0);
        },
        title: l("file_manager.file_selector.rename_file"),
        confirmButtonCaption: l("file_manager.rename"),
        confirmationContent: /* @__PURE__ */ v.jsx(
          uc,
          {
            label: l("file_manager.file_selector.file_name"),
            placeholder: l("file_manager.file_selector.enter_new_file_name"),
            value: P,
            onChange: (de) => j(de.target.value),
            error: K
          }
        ),
        onConfirm: () => W()
      }
    ),
    /* @__PURE__ */ v.jsx(
      rm,
      {
        ...r,
        uploaderRef: A,
        opened: Q,
        source: t,
        showCroppingNote: e,
        onClose: () => Z(!1),
        onUploadFinish: () => {
          R(), Z(!1);
        }
      }
    ),
    /* @__PURE__ */ v.jsx(
      Tl,
      {
        isFetching: Er,
        imageFile: Kn,
        opened: ot,
        onClose: lt,
        onCrop: hn,
        actionButtonLabel: l("file_manager.file_upload.crop_and_select_file"),
        ...r == null ? void 0 : r.imageCropperModalProps
      }
    )
  ] });
}
function pm({
  title: t,
  opened: e,
  onClose: r,
  onSelect: n,
  ...s
}) {
  const { t: i } = Pe();
  return /* @__PURE__ */ v.jsx(
    kn,
    {
      title: t ?? i("file_manager.file_selector.choose_file"),
      opened: e,
      isCentered: !0,
      size: hc.big,
      onClose: r,
      children: /* @__PURE__ */ v.jsx(nm, { onSelect: n, ...s })
    }
  );
}
export {
  Cc as AudioFileIcon,
  ra as ConfirmationModal,
  ji as DocumentFileIcon,
  gh as FileActionMenuDeleteItem,
  mh as FileActionMenuDetailsItem,
  bh as FileActionMenuDownloadItem,
  yh as FileActionMenuRenameItem,
  ph as FileDetails,
  ul as FileDropZoneVariantEnum,
  ft as FileExtensionEnum,
  vd as FileGrid,
  iu as FileItem,
  zt as FilePreview,
  vo as FilePreviewFromOS,
  nd as FileSearch,
  nm as FileSelector,
  pm as FileSelectorModal,
  oe as FileSourceEnum,
  Sc as FileSourceEnumLocoKeys,
  ie as FileTypeEnum,
  Ec as FileTypeEnumLocoKeys,
  hl as FileUploaderDropZone,
  us as FileUploaderItem,
  rm as FileUploaderModal,
  Pl as ImageCropper,
  Tl as ImageCropperModal,
  Oc as ImageFileIcon,
  ed as LocaleContext,
  dm as LocaleProvider,
  ei as PaginationOrderEnum,
  hm as QueryClientProvider,
  Za as SortDirectionEnum,
  Rc as VideoFileIcon,
  Gi as appendAspectRatioToFileName,
  yo as areAspectRatiosEqual,
  uh as convertFileInfoToDataFile,
  tp as createCanceler,
  rp as createProgress,
  cm as fileInputAcceptTypes,
  fh as formatAcceptTypeForInput,
  oh as formatBytes,
  Zi as getArrayDifference,
  bo as getAspectRatioLabel,
  ch as getAspectRatioNote,
  um as getFileTypeFromName,
  go as getImageAspectRatio,
  np as getMimeType,
  _c as getThumbnailByType,
  dh as hashFile,
  ni as httpClient,
  ye as i18n,
  hh as imageToFile,
  ta as isAcceptTypeValid,
  xc as isDataFileInterface,
  op as isFileInfoInterface,
  ws as isImageFile,
  ip as isOsFile,
  ap as isOsFileWithId,
  ah as loadLangBundle,
  ri as namespace,
  ea as replaceImageFileBlob,
  mo as t,
  fm as useDataFiles,
  nr as useFetch,
  ko as useFileActions,
  rd as useFileDetails,
  cl as useFileUploader,
  ep as useFileUploaderActions,
  sp as useFileUploaderManager,
  td as useInfiniteDataFiles,
  Ji as useStateWatcher,
  Pe as useTranslation,
  cp as variantClassName
};
